{
  "common": {
    "languageName": "العربية",
    "switchTo": "English",
    "locales": {
      "ar": "العربية",
      "en": "English"
    }
  },
  "support": {
    "whatsapp": {
      "open": "تواصل معنا عبر واتساب"
    }
  },
  "providerSyncProgress": {
    "progressDeterminate": "تم جلب {{fetched}} من {{total}} عنصر عبر {{pages}} صفحات.",
    "progressIndeterminate": "تم جلب {{fetched}} عنصر عبر {{pages}} صفحات.",
    "rateLimited": "تم الوصول إلى حد معدل المزوّد. سيعيد تلاق المحاولة تلقائياً.",
    "rateLimitedWithTime": "تم الوصول إلى حد معدل المزوّد. سيعيد تلاق المحاولة قرابة {{retryAt}}.",
    "failed": "فشلت المزامنة بالرمز {{code}}.",
    "unknownError": "UNKNOWN_ERROR",
    "status": {
      "QUEUED": "في قائمة الانتظار",
      "RUNNING": "قيد التشغيل",
      "RATE_LIMITED": "محدود المعدل",
      "SUCCEEDED": "نجح",
      "SUCCEEDED_WITH_ISSUES": "نجح مع مشكلات",
      "FAILED": "فشل"
    }
  },
  "auth": {
    "google": {
      "title": "تسجيل الدخول باستخدام Google",
      "signUp": "إنشاء حساب باستخدام Google",
      "loading": "جارٍ تحميل تسجيل الدخول باستخدام Google…",
      "unavailable": "تسجيل الدخول باستخدام Google غير متاح حالياً. يمكنك استخدام البريد الإلكتروني وكلمة المرور.",
      "retry": "إعادة المحاولة باستخدام Google",
      "failed": "تعذّر إكمال تسجيل الدخول باستخدام Google. حاول مرة أخرى.",
      "notLinked": "حساب Google هذا غير مرتبط بتلاق. أنشئ مساحة عمل أو اربطه بحسابك الحالي.",
      "conflict": "لا يمكن ربط حساب Google هذا. جرّب حساب Google آخر أو تابع دون الربط.",
      "missingDetails": "أدخل اسمك واسم المؤسسة للمتابعة.",
      "create": "إنشاء مساحة عمل جديدة",
      "connect": "ربط حساب موجود",
      "signupHint": "أنشئ مساحة عملك ببريد Google دون كلمة مرور. يمكنك تعيين كلمة مرور لاحقاً عبر «نسيت كلمة المرور».",
      "linkHint": "أكّد بريدك الإلكتروني وكلمة مرور حسابك الحالي في تلاق، ثم اختر حساب Google لربطه. نسيت كلمة المرور؟ ارجع لتسجيل الدخول بالبريد واطلب رابط إعادة التعيين.",
      "continue": "متابعة",
      "confirmSignup": "اختر حساب Google لإنشاء {{organization}}. سيكون بريد Google هو بريد تسجيل الدخول إلى تلاق.",
      "confirmLink": "اختر حساب Google الذي تريد ربطه بـ {{email}}. ستفتح طريقتا الدخول مساحة العمل نفسها.",
      "skipLink": "المتابعة دون ربط Google",
      "back": "العودة للدخول أو التسجيل بالبريد الإلكتروني",
      "orEmail": "أو استخدم البريد الإلكتروني وكلمة المرور"
    },
    "layout": {
      "backHome": "العودة للرئيسية",
      "hero": {
        "title": "أدر مبيعاتك في أسواق المنطقة من مساحة عمل واحدة تملكها فعلاً.",
        "subtitle": "اربط زد وسلة وأمازون وترينديول. تلاق يحتفظ بمنتجاتك ومستودعاتك ومخزونك — ربط زوهو اختياري وليس شرطاً.",
        "pills": {
          "channels": "ربط مع أغلب المتاجر",
          "ownInventory": "دعم لأنظمة المخازن المحلية والعالمية",
          "stockSplit": "توزيع ممنهج للكميات"
        }
      }
    },
    "login": {
      "eyebrow": "هلابك",
      "title": "تسجيل الدخول إلى تلاق",
      "hero": {
        "title": "وزع نسب المخزون على متاجرك",
        "subtitle": "اربط متاجرك مع مستودعك وتلاق بيحرص إن المخزون يتوزع حسب النسب الي حددتها أول بأول"
      },
      "email": "البريد الإلكتروني",
      "emailPlaceholder": "you@company.com",
      "password": "كلمة المرور",
      "passwordPlaceholder": "أدخل كلمة المرور",
      "forgot": "نسيت كلمة المرور؟",
      "submit": "تسجيل الدخول",
      "submitting": "جارٍ تسجيل الدخول…",
      "newToTlaaq": "جديد على تلاق؟",
      "createAccount": "أنشئ حساباً",
      "contexts": {
        "zidOAuth": "سجّل الدخول لإنهاء ربط متجر زد. حفظنا التسليم الآمن من زد وسنتابع تلقائياً.",
        "sallaOAuth": "سجّل الدخول لإنهاء ربط متجر سلة. حفظنا التسليم الآمن من سلة وسنتابع تلقائياً.",
        "amazonOAuth": "سجّل الدخول لإنهاء ربط حساب بائع أمازون. حفظنا التسليم الآمن من أمازون وسنتابع تلقائياً.",
        "zohoOAuth": "سجّل الدخول لإكمال ربط Zoho Inventory."
      },
      "errors": {
        "missingFields": "أدخل بريدك الإلكتروني وكلمة المرور للمتابعة.",
        "expired": "انتهت صلاحية كلمة المرور. اطلب رابطاً لإعادة التعيين لاختيار كلمة جديدة.",
        "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة. يمكنك أيضاً الدخول باستخدام Google أو تعيين كلمة مرور عبر «نسيت كلمة المرور».",
        "network": "تعذّر الوصول إلى تلاق. حاول مرة أخرى.",
        "sendReset": "أرسل لي رابط إعادة التعيين"
      }
    },
    "register": {
      "title": "ابدأ بمتجرك",
      "subtitle": "أنشئ المؤسسة وحساب المالك لمساحة عملك في تلاق.",
      "hero": {
        "title": "زامن مستودعك مع متاجرك.\nتحكم بطلبات متاجر من مكان واحد.",
        "subtitle": "اربط متاجرك مع مستودعك وتحكم بتوزيع الكميات وإدارة الطلبات من مكان واحد."
      },
      "fullName": "الاسم الكامل",
      "fullNamePlaceholder": "أحمد",
      "organizationName": "اسم المؤسسة أو المتجر",
      "organizationPlaceholder": "تلاق",
      "email": "البريد الإلكتروني",
      "emailPlaceholder": "you@company.com",
      "password": "كلمة المرور",
      "passwordPlaceholder": "اختر كلمة مرور قوية",
      "submit": "تسجيل",
      "submitting": "جارٍ التسجيل…",
      "haveAccount": "لديك حساب بالفعل؟",
      "signIn": "تسجيل الدخول",
      "legal": {
        "prefix": "بإنشاء حساب، فإنك توافق على",
        "terms": "شروط الخدمة",
        "middle": "وتقر بالاطلاع على",
        "privacy": "سياسة الخصوصية"
      },
      "contexts": {
        "zidOAuthSubtitle": "أنشئ مساحة عملك لإنهاء تثبيت تلاق من زد.",
        "zidOAuth": "بعد إنشاء مساحة العمل، سيعود تلاق إلى إعداد ربط زد ويبدأ أول استيراد.",
        "sallaOAuthSubtitle": "أنشئ مساحة عملك لإنهاء ربط متجر سلة.",
        "sallaOAuth": "بعد إنشاء مساحة العمل، سيعود تلاق إلى إعداد ربط سلة ويبدأ أول استيراد.",
        "amazonOAuthSubtitle": "أنشئ مساحة عملك لإنهاء ربط حساب بائع أمازون.",
        "amazonOAuth": "بعد إنشاء مساحة العمل، سيعود تلاق إلى إعداد ربط أمازون ويبدأ أول استيراد للكتالوج والطلبات.",
        "zohoOAuth": "أنشئ حسابك لإكمال ربط Zoho Inventory.",
        "zohoOAuthSubtitle": "أنشئ مساحة عمل تلاق أولاً، ثم سنعيدك إلى ربط Zoho Inventory."
      },
      "errors": {
        "missingFields": "أكمل جميع الحقول لإنشاء مساحة العمل.",
        "policy": "حدّث كلمة المرور لتطابق متطلبات السياسة.",
        "emailTaken": "يوجد حساب مسجل بهذا البريد. سجّل الدخول بدلاً من ذلك.",
        "policyServer": "كلمة المرور لا تستوفي متطلبات السياسة.",
        "network": "تعذّر إنشاء مساحة العمل. حاول مرة أخرى."
      }
    },
    "forgot": {
      "eyebrow": "إعادة تعيين كلمة المرور",
      "title": "إعادة تعيين كلمة المرور",
      "titleSent": "تحقق من صندوق الوارد",
      "subtitle": "أدخل بريدك الإلكتروني وسنرسل لك رابطاً آمناً لإعادة التعيين.",
      "subtitleSent": "إذا كان هناك حساب بهذا البريد فقد أرسلنا تعليمات إعادة التعيين.",
      "email": "البريد الإلكتروني للعمل",
      "emailPlaceholder": "you@company.com",
      "submit": "أرسل رابط إعادة التعيين",
      "submitting": "جارٍ الإرسال…",
      "back": "العودة لتسجيل الدخول",
      "afterNote": "يمكنك إغلاق هذه الشاشة بأمان أو العودة لتسجيل الدخول بعد اختيار كلمة المرور الجديدة.",
      "returnToSignIn": "العودة لتسجيل الدخول"
    },
    "reset": {
      "eyebrow": "اختر كلمة مرور جديدة",
      "title": "إعادة تعيين كلمة المرور",
      "subtitle": "اختر كلمة مرور جديدة تلتزم بسياسة أمان مساحة العمل.",
      "newPassword": "كلمة المرور الجديدة",
      "newPasswordPlaceholder": "اختر كلمة مرور قوية",
      "confirmPassword": "تأكيد كلمة المرور",
      "confirmPasswordPlaceholder": "أعد كتابة كلمة المرور الجديدة",
      "submit": "إعادة تعيين كلمة المرور",
      "submitting": "جارٍ إعادة التعيين…",
      "needNewLink": "تحتاج رابطاً جديداً؟",
      "invalidEyebrow": "رابط إعادة التعيين",
      "invalidTitle": "هذا الرابط غير صالح",
      "invalidSubtitle": "ربما انتهت صلاحية الرابط أو سبق استخدامه. اطلب رابطاً جديداً للمتابعة.",
      "requestNew": "اطلب رابطاً جديداً",
      "requestNewLong": "اطلب رابط إعادة تعيين جديداً",
      "errors": {
        "missingFields": "أدخل كلمة المرور الجديدة وأكدها.",
        "mismatch": "حقلا كلمة المرور غير متطابقين.",
        "policy": "حدّث كلمة المرور لتطابق متطلبات السياسة.",
        "policyServer": "كلمة المرور لا تستوفي متطلبات السياسة.",
        "network": "تعذّر إعادة تعيين كلمة المرور. حاول مرة أخرى."
      }
    },
    "invite": {
      "eyebrow": "دعوة فريق",
      "loadingTitle": "جارٍ التحقق من الدعوة",
      "loadingSubtitle": "نتأكد من أن رابط الدعوة الآمن ما زال صالحاً.",
      "title": "الانضمام إلى {{organization}}",
      "subtitle": "أنشئ كلمة مرور للانضمام إلى مساحة العمل بصلاحية كاملة للمتجر.",
      "newPassword": "كلمة المرور",
      "newPasswordPlaceholder": "اختر كلمة مرور قوية",
      "confirmPassword": "تأكيد كلمة المرور",
      "confirmPasswordPlaceholder": "أعد كتابة كلمة المرور",
      "submit": "قبول الدعوة",
      "submitting": "جارٍ الانضمام…",
      "backToLogin": "العودة لتسجيل الدخول",
      "privacyPrefix": "راجع كيفية تعامل تلاق مع بياناتك الشخصية في",
      "privacy": "سياسة الخصوصية",
      "invalidEyebrow": "رابط الدعوة",
      "invalidTitle": "هذه الدعوة غير صالحة",
      "invalidSubtitle": "ربما انتهت صلاحية الرابط أو أُلغي أو سبق استخدامه. اطلب من مالك المساحة إرسال دعوة جديدة.",
      "details": {
        "organization": "مساحة العمل",
        "invitee": "العضو المدعو",
        "email": "البريد الإلكتروني",
        "expires": "تنتهي {{date}}"
      },
      "errors": {
        "missingFields": "أدخل كلمة المرور الجديدة وأكدها.",
        "mismatch": "حقلا كلمة المرور غير متطابقين.",
        "policy": "حدّث كلمة المرور لتطابق متطلبات السياسة.",
        "policyServer": "كلمة المرور لا تستوفي متطلبات السياسة.",
        "emailAlreadyUser": "يوجد حساب بهذا البريد بالفعل. سجّل الدخول بدلاً من ذلك أو اطلب من المالك دعوة جديدة.",
        "network": "تعذّر قبول هذه الدعوة. حاول مرة أخرى."
      }
    },
    "policy": {
      "length": "من 12 إلى 128 حرفاً",
      "lowercase": "حرف صغير واحد",
      "uppercase": "حرف كبير واحد",
      "number": "رقم واحد",
      "symbol": "رمز واحد",
      "noPersonal": "لا تحتوي على اسمك أو بريدك الإلكتروني"
    }
  },
  "localeSwitcher": {
    "label": "اللغة"
  },
  "imports": {
    "title": "الاستيرادات", "close": "إغلاق الاستيرادات", "back": "رجوع", "all": "الكل", "detailTitle": "تفاصيل الاستيراد",
    "loading": "جارٍ تحميل الاستيرادات…", "empty": "لا توجد استيرادات بعد.", "stale": "التحديثات غير متاحة مؤقتًا. نعرض آخر المهام المحفوظة.", "retry": "إعادة المحاولة", "unavailable": "هذا الاستيراد غير متاح حاليًا.", "unknownChannel": "قناة غير معروفة",
    "queued": "تمت إضافة الاستيراد رقم {{id}} إلى قائمة الانتظار.", "submit": "بدء الاستيراد", "submitting": "جارٍ البدء…", "submitError": "تعذر بدء الاستيراد. حاول مرة أخرى.",
    "productsHint": "استورد باستخدام مصادر الكتالوج والمخزون الحالية دون تغيير مرجعية المصدر.", "ordersHint": "يمكنك تحديد نطاق زمني لاستيراد الطلبات.",
    "continue": "متابعة العمل", "continueHint": "تستمر الاستيرادات التي بدأت في الخلفية. افتح الاستيرادات من أي صفحة لمتابعة التقدم.",
    "setup": { "products": "استيراد المنتجات", "orders": "استيراد الطلبات", "noon-catalog": "استيراد كتالوج نون", "noon-sales": "استيراد مبيعات نون" },
    "kinds": { "products": "المنتجات", "orders": "الطلبات", "onboarding": "تهيئة القناة", "noon-catalog": "كتالوج نون", "noon-sales": "مبيعات نون" },
    "status": { "QUEUED": "في الانتظار", "RUNNING": "قيد التنفيذ", "DEFERRED": "مؤجل", "COMPLETED": "مكتمل", "COMPLETED_WITH_ISSUES": "مكتمل مع ملاحظات", "FAILED": "فشل", "CANCELLED": "ملغي" },
    "fields": { "fetched": "تم الجلب", "upserted": "تم الحفظ", "processedRowCount": "تمت المعالجة", "totalIssueCount": "الملاحظات", "errorCode": "الخطأ", "rows": "الصفوف", "imported": "تم الاستيراد", "mapped": "تمت المطابقة", "unmapped": "غير مطابق", "skipped": "تم التخطي", "productFetched": "المنتجات المجلوبة", "productUpserted": "المنتجات المحفوظة", "orderFetched": "الطلبات المجلوبة", "orderUpserted": "الطلبات المحفوظة", "orderSkipped": "الطلبات المتخطاة", "dataRowCount": "إجمالي الصفوف", "matchedOrderUpdatedCount": "الطلبات المحدثة", "standaloneCreatedCount": "المبيعات المنشأة", "skippedCount": "تم التخطي", "conflictCount": "التعارضات", "failedCount": "فشل", "productsCreated": "المنتجات المنشأة", "productsUpdated": "المنتجات المحدثة", "issueCount": "الملاحظات" }
  },
  "nav": {
    "groups": {
      "operate": "التشغيل",
      "connect": "الربط",
      "setup": "الإعداد"
    },
    "mobile": {
      "label": "التنقل الرئيسي"
    },
    "items": {
      "home": "الرئيسية",
      "analytics": "التحليلات",
      "orders": "الطلبات",
      "products": "المنتجات",
      "channels": "القنوات",
      "inventory": "المخزون",
      "warehouses": "المستودعات",
      "team": "الفريق",
      "billing": "الفوترة",
      "settings": "الإعدادات"
    },
    "topbar": {
      "signOut": "تسجيل الخروج"
    },
    "demo": {
      "organization": "Fitneeds",
      "domain": "fitneeds.sa",
      "avatarName": "Lubna"
    }
  },
  "app": {
    "loading": {
      "eyebrow": "جلسة آمنة",
      "title": "جارٍ التحقق من جلستك",
      "subtitle": "نعيد فتح مساحة عمل تلاق إذا كنت قد سجلت الدخول من قبل.",
      "body": "جارٍ التحميل…"
    },
    "meta": {
      "home": {
        "title": "الرئيسية",
        "subtitle": "نظرة مباشرة على مساحة العمل"
      },
      "analytics": {
        "title": "التحليلات",
        "subtitle": "أداء المبيعات حسب الفترة والعملة والقناة"
      },
      "orders": {
        "title": "الطلبات",
        "newBadge": "{{count}} جديد"
      },
      "orderRouting": {
        "title": "توجيه الطلبات",
        "subtitle": "وجّه كل طلب إلى قيم Zoho المناسبة"
      },
      "products": {
        "title": "المنتجات",
        "badge": "المرحلة 1"
      },
      "channels": {
        "title": "القنوات"
      },
      "inventory": {
        "title": "المخزون"
      },
      "tlaaqInventoryDetail": {
        "title": "مخزون تلاق",
        "subtitle": "المخزون المحلي والتوزيع وخصم الطلبات"
      },
      "warehouses": {
        "title": "المستودعات"
      },
      "team": {
        "title": "الفريق"
      },
      "billing": {
        "title": "الفوترة"
      },
      "settings": {
        "title": "الإعدادات"
      },
      "zohoDetail": {
        "title": "مخزون زوهو",
        "subtitle": "مصدر المخزون · متصل"
      },
      "zohoOrderAudit": {
        "title": "تدقيق طلبات زوهو",
        "subtitle": "المخزون · Zoho Inventory · مطابقة للقراءة فقط"
      },
      "syncWizard": {
        "title": "سياسة طلبات زوهو",
        "subtitle": "المخزون · Zoho Inventory · سياسة الطلبات"
      },
      "productDetail": {
        "title": "تفاصيل المنتج"
      },
      "productsEmpty": {
        "title": "المنتجات",
        "subtitle": "أدخل كتالوجك إلى تلاق"
      },
      "productNew": {
        "title": "منتج جديد",
        "subtitle": "أنشئ بيانات المنتج الرئيسية وصوره"
      },
      "productEdit": {
        "title": "تعديل المنتج",
        "subtitle": "تحديث بيانات المنتج الرئيسية وصوره"
      },
      "channelDetail": {
        "title": "اتصال القناة",
        "subtitle": "القنوات · إعدادات الاتصال"
      },
      "unmappedChannelListings": {
        "title": "مراجعة القوائم غير المرتبطة",
        "subtitle": "اربط منتجات القنوات بمنتجها الرئيسي في تلاق"
      },
      "channelInventoryVariance": {
        "title": "تباين مخزون القنوات",
        "subtitle": "القنوات · توفر المصدر مقابل لقطات القنوات"
      },
      "zohoPullRunDetail": {
        "title": "تفاصيل سحب Zoho",
        "subtitle": "المخزون · Zoho Inventory · سحب المنتجات"
      },
      "stockAllocationRules": {
        "title": "قواعد توزيع المخزون",
          "subtitle": "اختر المستودعات ونسب التوزيع وفروع الهدف واستثناءات المنتجات لكل متجر زد أو سلة أو نون FBPI متصل. يبقى الدفع اليدوي للمخزون من تفاصيل المنتج كما هو."
      },
      "stockAllocationActivity": {
        "title": "سجل توزيع المخزون",
        "subtitle": "راجع تحديثات المخزون الآلية والمنتجات المرفوضة ونتائج إعادة المحاولة."
      }
    }
  },
  "home": {
    "stats": {
      "orders": "طلبات آخر 24 ساعة",
      "ordersSub": "عبر {{count}} قنوات بيع",
      "revenue": "إيراد آخر 24 ساعة",
      "revenueSub": "من الطلبات",
      "connectedChannels": "قنوات البيع المتصلة",
      "connectedChannelsSub": "{{connected}} من {{total}} متصلة",
      "actionQueue": "إجراءات بحاجة للمراجعة",
      "actionQueueSub": "بناء على تحليل المنصة"
    },
    "channelHealth": {
      "title": "حالة الاتصال بقنوات البيع",
      "realtime": "",
      "live": "تحديث لحظي",
      "ordersToday": "{{count}} طلب",
      "revenueToday": "{{amount}}",
      "lastSync": "آخر مزامنة {{value}}",
      "empty": {
        "title": "لا توجد قنوات متصلة بعد",
        "body": "اربط قناة لتبدأ رؤية الطلبات وصحة المزامنة هنا.",
        "cta": "فتح القنوات"
      }
    },
    "recent": {
      "title": "أحدث الطلبات",
      "subtitle": "أحدث الطلبات المحفوظة عبر القنوات المتصلة.",
      "viewAll": "عرض الكل ←",
      "empty": {
        "title": "لا توجد طلبات بعد",
        "body": "ستظهر الطلبات بعد أن تسحبها قناة متصلة أو تستقبلها."
      }
    },
    "quickActions": {
      "title": "إجراءات سريعة",
      "connectChannel": "ربط قناة جديدة",
      "inviteTeam": "دعوة عضو للفريق",
      "subtitle": "انتقل إلى أكثر مسارات العمل استخداماً لمالك المتجر.",
      "connectChannelDesc": "أضف زد أو سلة أو أمازون أو نون أو ترينديول.",
      "addProduct": "إضافة منتج",
      "addProductDesc": "إنشاء أو مراجعة بيانات الكتالوج.",
      "reviewOrders": "مراجعة الطلبات",
      "reviewOrdersDesc": "فحص الطلبات الجديدة وقيد التنفيذ.",
      "inviteTeamDesc": "أضف مشغّلاً إلى مساحة العمل هذه."
    },
    "currency": "ر.س",
    "emptyValue": "—",
    "hero": {
      "eyebrow": "لوحة المعلومات",
      "title": "تابع طلباتك وحالة قنوات البيع وحالة المخزون من مكان واحد.",
      "body": "",
      "window": "آخر 24 ساعة",
      "primaryAction": "قنوات البيع",
      "secondaryAction": "المنتجات"
    },
    "loading": {
      "title": "جارٍ تحميل اللوحة",
      "body": "نقرأ بيانات مساحة عملك.",
      "badge": "تحميل"
    },
    "errors": {
      "title": "تعذّر تحميل اللوحة",
      "retry": "إعادة المحاولة",
      "codes": {
        "REQUEST_FAILED": "تعذّر تحميل اللوحة. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لعرض اللوحة."
      }
    },
    "coverage": {
      "title": "معلومات عامة",
      "subtitle": "",
      "totalProducts": "إجمالي المنتجات",
      "listedProducts": "منتجات مدرجة في قنوات بيع",
      "stockCoveredProducts": "منتجات لها مخزون متاح",
      "connectedChannels": "قنوات البيع"
    },
    "actionQueue": {
      "title": "قائمة الإجراءات",
      "subtitle": "ملاحظات تحتاج للمراجعة",
      "empty": {
        "title": "لا توجد إجراءات حالياً",
        "body": "لم يجد تلاق مشكلات في القنوات أو القوائم أو الطلبات أو المخزون المنخفض ضمن بيانات هذه المساحة."
      },
      "items": {
        "CHANNEL_ATTENTION": {
          "title": "قنوات تحتاج انتباهاً: {{count}}",
          "body": "إحدى القنوات المتصلة مفصولة أو منتهي تفويضها أو تسجل خطأ.",
          "badge": "القنوات: {{count}}",
          "cta": "مراجعة القنوات"
        },
        "LOW_STOCK": {
          "title": "منتجات منخفضة المخزون: {{count}}",
          "body": "المخزون المتاح عند حد المخزون المنخفض التشغيلي وهو 5 حبات أو أقل.",
          "badge": "المنتجات: {{count}}",
          "cta": "فتح المخزون"
        },
        "CHANNEL_INVENTORY_VARIANCE": {
          "title": "اختلاف كميات ما بين المخزون وقنوات البيع: {{count}}",
          "body": "توجد منتجات لها كميات في المخزون لم تحدث في قنوات البيع أو معروضة بكمية اكبر في قنوات البيع",
          "badge": "عدد الاختلافات: {{count}}",
          "cta": "مراجعة التقرير"
        },
        "UNMAPPED_LISTINGS": {
          "title": "قوائم قنوات بيع بحاجة لربط مع منتج في تلاق: {{count}}",
          "body": "توجد قائمة مزود محفوظة لكنها غير مربوطة بمنتج في تلاق بعد.",
          "badge": "القوائم: {{count}}",
          "cta": "فتح المنتجات"
        },
        "FAILED_ZOHO_SYNC": {
          "title": "طلبات فشلت مزامنتها مع زوهو: {{count}}",
          "body": "يوجد طلبات فشل ترحيلها لزوهو.",
          "badge": "الطلبات: {{count}}",
          "cta": "مراجعة الطلبات"
        },
        "ZOHO_CONNECTION_ATTENTION": {
          "title": "أعد ربط Zoho Inventory",
          "body": "اتصال زوهو غير متاح. أعد ربطه من صفحة المخزون لاستئناف إرسال الطلبات. سجلات المزامنة السابقة محفوظة.",
          "badge": "الاتصال غير متاح",
          "cta": "فتح المخزون"
        }
      }
    },
    "trend": {
      "title": "المبيعات",
      "subtitle": "الطلبات والإيرادات خلال آخر 7 أيام.",
      "orders": "الطلبات",
      "revenue": "الإيراد",
      "metricToggle": "مقياس نبض المبيعات",
      "metrics": {
        "revenue": "الإيراد",
        "orders": "الطلبات"
      },
      "summaryRevenue": "إيراد 7 أيام: {{amount}}",
      "summaryOrders": "طلبات 7 أيام: {{count}}",
      "bestDay": "أفضل يوم: {{day}}",
      "selectedDay": "اليوم المحدد: {{day}} · الطلبات: {{orders}} · الإيراد: {{revenue}}",
      "dayAria": "{{day}} · الطلبات: {{orders}} · الإيراد: {{revenue}}"
    },
    "inventoryWatchlist": {
      "title": "قائمة مراقبة المخزون",
      "subtitle": "المنتجات النشطة عند حد المخزون المنخفض أو أقل منه.",
      "available": "{{count}} متاح",
      "reserved": "{{count}} محجوز",
      "risk": {
        "HIGH": "خطر مرتفع",
        "MEDIUM": "خطر متوسط"
      },
      "empty": {
        "title": "لا توجد منتجات منخفضة المخزون",
        "body": "لا توجد منتجات نشطة حالياً عند حد المخزون المنخفض أو أقل منه."
      },
      "cta": "فتح المخزون",
      "openProductAria": "فتح المنتج {{name}}"
    }
  },
  "channels": {
    "description": "ربط القناة يربط المتجر فقط؛ لا يستورد المنتجات تلقائياً. اختر أين تُدار المنتجات والمخزون، ثم اسحب المنتجات عندما تكون جاهزاً.",
    "noonRefresh": {
      "action": "تحديث جميع عروض نون",
      "active": "تحديث نون قيد التنفيذ",
      "title": "تحديث العروض · {{name}}",
      "description": "تحديث الأسماء وحالة العروض ومخزون المستودعات للعروض المستوردة مسبقاً إلى تلاق. يعمل في الخلفية دون اكتشاف منتجات جديدة أو تغيير المخزون الأساسي.",
      "retainedProgress": "تم حفظ التقدم لـ {{count}} من العروض. تستأنف إعادة المحاولة من آخر نقطة محفوظة.",
      "result": {
        "processed": "العروض المعالجة",
        "refreshed": "العروض المحدّثة",
        "issues": "العروض ذات المشاكل"
      },
      "issues": {
        "codes": {
          "NOON_LISTING_REFRESH_OFFER_REJECTED": "رفضت نون طلب جلب العرض للرمز {{sku}}. تم الاحتفاظ بالبيانات السابقة ومتابعة تحديث العروض الأخرى.",
          "NOON_LISTING_REFRESH_INVALID_RESPONSE": "أعادت نون بيانات ناقصة أو غير صالحة للرمز {{sku}}. تم الاحتفاظ بالبيانات السابقة.",
          "NOON_LISTING_REFRESH_CONFLICT": "تغيّر العرض {{sku}} أثناء التحديث. تم الاحتفاظ ببياناته الأحدث.",
          "CHANNEL_LISTING_SKU_REQUIRED": "تعذّر تحديث عرض لعدم وجود رمز الشريك SKU."
        }
      }
    },
    "noonCatalogImport": {
      "action": "استيراد المنتجات من Excel",
      "title": "استيراد منتجات نون · {{name}}",
      "close": "إغلاق",
      "description": "طابق رموز الشريك في نون مع رموز SKU الأساسية أو البديلة في كتالوج المخزون، بما فيها المنتجات المستوردة من زوهو. لن تتغير أسماء المنتجات أو الكميات أو مصدر المخزون. تبقى عروض المنتجات غير المطابقة متاحة للمراجعة والربط.",
      "fileLabel": "ملف كتالوج نون بصيغة Excel",
      "fileHint": "ورقة واحدة بصيغة .xlsx، بحد أقصى 5 ميغابايت و5,000 صف. العمود المطلوب: partner_sku. الاختياري: noon_title. احفظ المعرّفات كنص للحفاظ على الأصفار في بدايتها. يُستخدم أول صف صالح لكل رمز شريك وتُتخطى التكرارات التالية. إعادة الاستيراد تحدّث العروض الموجودة.",
      "upload": "استيراد الكتالوج",
      "uploading": "جارٍ الاستيراد…",
      "completed": "تم استيراد {{imported}} عرض منتج من {{rows}} صفاً.",
      "counts": {
        "imported": "العروض المستوردة",
        "mapped": "تمت المطابقة",
        "unmapped": "تحتاج إلى ربط",
        "skipped": "الصفوف المتخطاة"
      },
      "issues": "مراجعة ملاحظات الصفوف ({{count}})",
      "row": "الصف {{row}}",
      "issueCodes": {
        "DUPLICATE_SKU": "رمز شريك مكرر؛ تم الاحتفاظ بأول صف صالح.",
        "MISSING_TITLE": "تم الاستيراد دون اسم؛ رمز الشريك متاح للمطابقة.",
        "SKU_INVALID": "رمز الشريك مفقود أو يتجاوز 64 حرفاً أو ليس معرّفاً رقمياً صحيحاً وآمناً. احفظ المعرّفات الطويلة كنص.",
        "TITLE_TOO_LONG": "الاسم يتجاوز 512 حرفاً؛ تم تخطي الصف.",
        "CELL_TYPE_INVALID": "الخلية تحتوي على صيغة أو خطأ أو نوع غير مدعوم؛ تم تخطي الصف. استخدم النص للمعرّفات والأسماء."
      },
      "errors": {
        "FILE_REQUIRED": "اختر ملف Excel للاستيراد.",
        "FILE_TYPE_INVALID": "اختر ملف Excel بصيغة .xlsx.",
        "FILE_TOO_LARGE": "الملف يتجاوز حد الرفع البالغ 5 ميغابايت أو 20 ميغابايت بعد فك الضغط.",
        "SHEET_INVALID": "استخدم ملفاً يحتوي على ورقة واحدة فقط.",
        "HEADER_INVALID": "يجب أن يحتوي الصف الأول على عمود partner_sku واحد. استخدم عناوين فريدة وبحد أقصى 32 عموداً.",
        "ROW_LIMIT": "الورقة تتجاوز 5,000 صف بيانات. قسّمها إلى ملفات أصغر.",
        "EMPTY": "الورقة لا تحتوي على صفوف منتجات.",
        "WORKBOOK_INVALID": "تعذرت قراءة الملف بأمان. احفظ نسخة جديدة بصيغة .xlsx دون وحدات ماكرو أو روابط خارجية.",
        "CONNECTION_INVALID": "اختر قناة نون متصلة.",
        "REQUEST_FAILED": "تعذر إكمال الاستيراد. تحقق من الاتصال وأعد المحاولة. إعادة الاستيراد لن تكرر العروض الموجودة."
      }
    },
    "noonSalesImport": {
      "action": "استيراد مبيعات نون",
      "title": "استيراد مبيعات نون · {{name}}",
      "description": "طابق صفوف عناصر FBN وFBP من تقرير مبيعات نون بصيغة CSV أو Excel.",
      "partnerLabel": "معرّف شريك نون (id_partner)",
      "partnerHint": "أدخل id_partner من التقرير عند الاستيراد الأول. يُحفظ بعد قبول التقرير. بيانات API والويبهوك اختيارية، ويمكنك إعداد FBPI لاحقاً.",
      "excelOnly": "استيراد Excel فقط",
      "close": "إغلاق",
      "fulfillmentTitle": "تسميات التنفيذ المقبولة",
      "fulfillment": {
        "fbn": "Fulfilled by Noon (FBN)",
        "supermall": "Supermall",
        "fbp": "Fulfilled by Partner (FBP)"
      },
      "matching": "يحدّث item_nr المطابق طلبه الحالي، بينما ينشئ الصف غير المطابق عملية بيع مستقلة على مستوى العنصر.",
      "chronologicalWarning": "يسود آخر رفع للحالة والتواريخ. ارفع التقارير حسب ترتيب تصديرها الزمني.",
      "fileLabel": "تقرير مبيعات نون",
      "fileHint": "{{extensions}} · حتى {{size}} م.ب و{{rows}} صف",
      "timeZoneLabel": "المنطقة الزمنية للمصدر",
      "timeZonePlaceholder": "Asia/Riyadh",
      "timeZoneHint": "أدخل منطقة IANA الزمنية المستخدمة للطوابع التي لا تحتوي على إزاحة.",
      "upload": "رفع التقرير",
      "uploading": "جارٍ الرفع…",
      "reupload": "رفع تقرير آخر",
      "cancel": "إلغاء الاستيراد",
      "cancelling": "جارٍ الإلغاء…",
      "loadingLatest": "جارٍ تحميل آخر استيراد…",
      "pollWarning": "تعذر تحديث الحالة مؤقتاً. ستتم إعادة المحاولة تلقائياً…",
      "jobTitle": "مهمة الاستيراد #{{id}}",
      "counts": {
        "processed": "الصفوف المعالجة",
        "matched": "الطلبات المطابقة",
        "standalone": "العناصر المستقلة",
        "issues": "المشكلات"
      },
      "acceptedCounts": "صفوف FBN المقبولة: {{fbn}} · صفوف FBP المقبولة: {{fbp}}",
      "issueSummaryTitle": "ملخص المشكلات",
      "issueContext": "{{count}} حالة، أولها في الصف {{row}}",
      "rowsTitle": "نتائج الصفوف",
      "rowNumber": "الصف {{row}}",
      "unknownItem": "عنصر غير معروف",
      "noRowIssues": "لا توجد مشكلات في الصف",
      "page": "الصفحة {{page}} من {{pages}}",
      "previous": "السابق",
      "next": "التالي",
      "status": {
        "QUEUED": "في قائمة الانتظار",
        "RUNNING": "قيد التنفيذ",
        "COMPLETED": "مكتمل",
        "COMPLETED_WITH_ISSUES": "مكتمل مع مشكلات",
        "FAILED": "فشل",
        "CANCELLED": "ملغي"
      },
      "outcomes": {
        "PENDING": "قيد الانتظار",
        "MATCHED_ORDER_UPDATED": "تم تحديث الطلب المطابق",
        "MATCHED_ORDER_UNCHANGED": "الطلب المطابق دون تغيير",
        "STANDALONE_CREATED": "تم إنشاء عنصر مستقل",
        "STANDALONE_UPDATED": "تم تحديث العنصر المستقل",
        "STANDALONE_UNCHANGED": "العنصر المستقل دون تغيير",
        "SUPERSEDED": "استُبدل العنصر المستقل",
        "SKIPPED": "تم التخطي",
        "CONFLICT": "تعارض",
        "FAILED": "فشل"
      },
      "issueCodes": {
        "UNKNOWN": "مشكلة استيراد غير معروفة",
        "NOON_SALES_IMPORT_ITEM_MATCH_AMBIGUOUS": "يطابق العنصر أكثر من طلب واحد.",
        "NOON_SALES_IMPORT_PARENT_STATUS_CONFLICT": "تتعارض حالة أو تواريخ صفوف الطلب نفسه.",
        "NOON_SALES_IMPORT_DUPLICATE_ITEM_CONFLICT": "تتعارض صفوف العنصر المكررة.",
        "NOON_SALES_IMPORT_DUPLICATE_IDENTICAL_ROW": "تم تخطي صف مكرر مطابق.",
        "NOON_SALES_IMPORT_IDENTITY_COLLISION": "تتعارض هوية العنصر مع سجل موجود.",
        "NOON_SALES_IMPORT_FULFILLMENT_UNSUPPORTED": "تسمية التنفيذ غير مدعومة.",
        "NOON_SALES_IMPORT_FORMULA_CELL": "خلايا المعادلات غير مقبولة.",
        "NOON_SALES_IMPORT_ERROR_CELL": "يحتوي المصنف على خلية خطأ.",
        "NOON_SALES_IMPORT_INVALID_TYPE": "نوع قيمة الخلية غير صالح.",
        "NOON_SALES_IMPORT_DECIMAL_INVALID": "القيمة العشرية غير صالحة.",
        "NOON_SALES_IMPORT_CURRENCY_INVALID": "رمز العملة غير صالح.",
        "NOON_SALES_IMPORT_DATE_CHRONOLOGY_INVALID": "تواريخ الشحن أو التسليم ليست مرتبة زمنياً.",
        "NOON_SALES_IMPORT_ROW_PROCESSING_FAILED": "تعذرت معالجة الصف.",
        "NOON_SALES_IMPORT_SCHEDULE_FAILED": "تعذرت جدولة الاستيراد.",
        "NOON_SALES_IMPORT_STALLED": "توقّف تقدم الاستيراد."
      },
      "errors": {
        "REQUEST_FAILED": "فشل طلب استيراد مبيعات نون. حاول مرة أخرى.",
        "NOON_SALES_IMPORT_PARTNER_REQUIRED": "أدخل معرّف شريك نون بالأرقام، على أن يطابق جميع صفوف التقرير.",
        "NOON_SALES_IMPORT_CONNECTION_PARTNER_UNRESOLVED": "أدخل معرّف شريك نون قبل استيراد Excel الأول.",
        "NOON_SALES_IMPORT_PARTNER_MISMATCH": "التقرير أو حساب API يخص شريك نون مختلفاً عن هذه القناة.",
        "NOON_SALES_IMPORT_MIXED_PARTNERS": "ارفع تقريراً يحتوي فقط على معرّف شريك نون لهذه القناة.",
        "NOON_SALES_IMPORT_CONNECTION_INVALID": "هذه القناة مفصولة أو ليست قناة نون.",
        "NOON_SALES_IMPORT_CONFIGURATION_INVALID": "لم تتم تهيئة استيراد مبيعات نون بأنواع الملفات ونماذج التنفيذ المقبولة.",
        "NOON_SALES_IMPORT_FILE_REQUIRED": "اختر تقرير مبيعات نون بصيغة .csv أو .xlsx.",
        "NOON_SALES_IMPORT_FILE_TYPE_INVALID": "اختر ملفاً صالحاً بصيغة .csv أو .xlsx.",
        "NOON_SALES_IMPORT_FILE_TOO_LARGE": "يتجاوز التقرير حجم الملف المسموح.",
        "NOON_SALES_IMPORT_TIMEZONE_REQUIRED": "أدخل المنطقة الزمنية لمصدر التقرير.",
        "NOON_SALES_IMPORT_TIMEZONE_INVALID": "أدخل منطقة IANA زمنية صالحة.",
        "NOON_SALES_IMPORT_ACTIVE_JOB": "يوجد استيراد نشط آخر لربط نون هذا.",
        "NOON_SALES_IMPORT_DISABLED": "استيراد مبيعات نون معطّل حالياً.",
        "NOON_SALES_IMPORT_JOB_NOT_FOUND": "لم يتم العثور على مهمة الاستيراد.",
        "NOON_SALES_IMPORT_CANCELLATION_CONFLICT": "لم يعد من الممكن إلغاء هذا الاستيراد.",
        "NOON_SALES_IMPORT_PARTNER_MISMATCH": "لا يتبع التقرير ربط نون هذا.",
        "NOON_SALES_IMPORT_MIXED_PARTNERS": "يحتوي التقرير على أكثر من شريك نون.",
        "NOON_SALES_IMPORT_WORKBOOK_INVALID": "المصنف غير صالح أو غير آمن.",
        "NOON_SALES_IMPORT_WORKBOOK_HEADER_INVALID": "لا تتطابق أعمدة التقرير مع تصدير مبيعات نون المدعوم.",
        "NOON_SALES_IMPORT_NO_ACCEPTED_ROWS": "لا يحتوي التقرير على صفوف مبيعات مقبولة."
      }
    },
    "connect": "ربط قناة",
    "onboardingStockOwner": {
      "title": "أين ستدير المخزون؟",
      "subtitle": "نستورد المنتجات والمخزون من {{store}} في الحالتين. هذا الاختيار يحدد من يملك المخزون بعد الاستيراد.",
      "recommended": "موصى به",
      "tlaaq": {
        "title": "تلاق",
        "body": "استخدم تلاق كنظام للمخزون. تعدّل المخزون في تلاق وتدفعه إلى {{store}}، وتُخصم طلبات {{store}} من مخزون تلاق."
      },
      "channel": {
        "body": "استمر في إدارة المخزون في {{store}}. يقرأ تلاق الكميات من {{store}} ولا يرسل تحديثات المخزون إلى {{store}}."
      },
      "hint": {
        "tlaaq": "يتولى تلاق المخزون عند انتهاء الاستيراد الأول. يمكنك تغيير ذلك لاحقاً من صفحة المخزون.",
        "channel": "يبقى المخزون في {{store}}. يمكنك التحويل إلى تلاق لاحقاً من صفحة المخزون."
      },
      "error": "تعذّر حفظ اختيارك. حاول مرة أخرى.",
      "applied": {
        "title": "يدير تلاق مخزونك الآن",
        "body": "تم استيراد الكميات من {{store}}. عدّل المخزون في تلاق وادفعه إلى {{store}} من صفحة كل منتج. تبقى تفاصيل المنتجات في {{store}}."
      }
    },
    "providers": {
      "ZID": "زد",
      "SALLA": "سلة",
      "AMAZON": "أمازون",
      "TRENDYOL": "ترينديول",
        "NOON": "نون",
        "ZOHO": "زوهو"
      },
    "status": {
      "PENDING": "بانتظار الإعداد",
      "CONNECTED": "متصل",
      "DISCONNECTED": "مفصول",
      "AUTH_EXPIRED": "انتهى التفويض",
      "ERROR": "خطأ"
    },
    "adapter": {
      "available": "المحول متاح",
      "comingLater": "المحول قادم لاحقاً"
    },
    "form": {
      "title": "إضافة ربط قناة",
      "provider": "المزود",
      "providerPlaceholder": "اختر المزود",
      "displayName": "اسم العرض",
      "displayNamePlaceholder": "متجر Fitneeds على زد",
      "helper": "ينشئ هذا ربطاً مؤقتاً بحالة انتظار. بعد ربط القناة، اختر هل تلاق أم المتجر هو مصدر المنتجات والمخزون.",
      "submit": "إضافة قناة",
      "submitting": "جارٍ الإضافة…"
    },
    "actions": {
      "refresh": "تحديث",
      "manage": "إدارة",
      "delete": "حذف",
      "deleting": "جارٍ الحذف…",
      "connect": "ربط",
      "connecting": "جارٍ الربط…",
      "pullProducts": "سحب المنتجات",
      "manageSource": "إدارة المصدر",
      "saveSource": "حفظ اختيار المصدر",
      "savingSource": "جارٍ الحفظ…",
      "pullAndImport": "حفظ وسحب",
      "refreshListings": "تحديث القوائم",
      "importing": "جارٍ الاستيراد…",
      "queueingProducts": "جارٍ الجدولة…",
      "productPullActive": "سحب المنتجات نشط",
      "enterCredentials": "إدخال بيانات الاعتماد",
      "reconnectCredentials": "إعادة الربط",
      "updateCredentials": "تحديث بيانات الاعتماد",
      "pullOrders": "سحب الطلبات",
      "reviewUnmapped": "مراجعة القوائم غير المرتبطة",
      "reviewUnmappedShort": "مراجعة غير المرتبط",
      "pullingOrders": "جارٍ سحب الطلبات…",
      "stockAllocation": "توزيع المخزون"
    },
    "stockSyncAlert": {
      "title": "مزامنة مخزون {{provider}} تحتاج إلى مراجعة",
      "body": "قُبلت طلبات مخزون {{pushed}} منتجاً وفشلت طلبات {{failed}}. القبول لا يؤكد مخزون القناة. راجع نتائج العناصر الدقيقة قبل إعادة المحاولة.",
      "action": "مراجعة النشاط"
    },
    "credentials": {
      "trendyolTitle": "بيانات اعتماد ترينديول لـ {{name}}",
      "trendyolSubtitle": "أدخل رقم البائع ومفتاح API وسر API من حساب التاجر في ترينديول. بيانات الاعتماد للكتابة فقط ولا تظهر بعد حفظها.",
      "amazonTitle": "بيانات اعتماد Amazon SP-API التجريبية لـ {{name}}",
      "amazonSubtitle": "استخدم زر الربط OAuth للمسار المعتاد، أو الصق رمز تحديث تجريبي أثناء بقاء تطبيق أمازون في وضع المسودة.",
      "noonTitle": "إعداد نون اليدوي لـ {{name}}",
      "noonSubtitle": "الصق مفتاح JSON لحساب خدمة نون الذي نزّلته من Noon Access App ورمز مستودع FBPI المستخدم لسحب طلبات نون. يستخدمهما تلاق لتسجيل دخول التاجر المباشر واستيراد طلبات FBPI حسب المستودع.",
      "sellerId": "رقم البائع",
      "externalAccountId": "معرّف الحساب الخارجي",
      "trendyolSellerIdPlaceholder": "123456",
      "amazonSellerIdPlaceholder": "A1EXAMPLESELLER",
      "noonExternalAccountIdPlaceholder": "noon-seller-or-account-id",
      "noonWarehouseCode": "رمز مستودع FBPI",
      "noonWarehouseCodePlaceholder": "مثال: RUH-FBPI-001",
      "noonServiceAccountJson": "JSON حساب الخدمة",
      "noonServiceAccountJsonPlaceholder": "الصق ملف مفتاح Noon .json كاملاً هنا",
      "noonServiceAccountUpload": "رفع ملف .json (اختياري)",
      "noonServiceAccountRequiredFields": "حقول JSON المطلوبة: private_key و key_id و project_code و channel_identifier.",
      "apiKey": "مفتاح API",
      "apiSecret": "سر API",
      "userAgent": "معرّف المستخدم (اختياري)",
      "userAgentPlaceholder": "اسم تطبيق التاجر",
      "amazonMarketplaceIds": "معرّفات الأسواق",
      "amazonMarketplaceIdsPlaceholder": "A2VIGQ35RCS4UG",
      "amazonRegion": "منطقة SP-API",
      "amazonRegions": {
        "EU": "أوروبا / الشرق الأوسط (EU)",
        "NA": "أمريكا الشمالية (NA)",
        "FE": "الشرق الأقصى (FE)"
      },
      "amazonRefreshToken": "رمز التحديث",
      "amazonRefreshTokenPlaceholder": "Atzr|IwEB...",
      "trendyolHelper": "حفظ بيانات الاعتماد يربط ترينديول ويفعّل سحب المنتجات والطلبات. اترك معرّف المستخدم فارغاً لاستخدام القيمة الافتراضية من تلاق.",
      "amazonHelper": "حفظ بيانات الاعتماد يربط حساب بائع أمازون هذا لسحب الكتالوج/القوائم والطلبات. لا يصبح مخزون أمازون مصدر الحقيقة في هذه النسخة التجريبية.",
      "noonHelper": "الحفظ يسجل الدخول إلى نون بمفتاح حساب الخدمة، ويحفظ رمز مستودع FBPI، ويتحقق من الجلسة قبل اعتبار القناة متصلة. بعد الحفظ يمكن لتلاق جدولة سحب طلبات Noon FBPI لهذا المستودع. إعداد رابط الويبهوك ومفتاح API منفصل؛ استيراد الكتالوج وتسجيل الويبهوك عن بعد وإنشاء الشحنات والمانيفست والمخزون والتسعير وتسعير Xborder غير مفعّلة بعد.",
      "save": "حفظ بيانات الاعتماد",
      "saving": "جارٍ الحفظ…",
      "saved": "تم حفظ بيانات الاعتماد لـ {{name}}.",
      "cancel": "إغلاق"
    },
    "ordersPull": {
      "title": "تم سحب الطلبات من {{name}}",
      "jobTitle": "تمت جدولة سحب الطلبات من {{name}}",
      "fetched": "طلبات مسحوبة",
      "upserted": "طلبات محدّثة",
      "skipped": "طلبات متخطاة",
      "hasMore": "توجد طلبات إضافية لهذه النافذة. سيبدأ هذا القسم سحباً جديداً في المرة التالية.",
      "jobQueued": "تعمل عملية السحب في الخلفية ويتم تحديث الحالة هنا حتى تكتمل. يمكنك متابعة العمل أثناء تشغيلها.",
      "jobsTitle": "أحدث عمليات سحب الطلبات",
      "jobsSubtitle": "أحدث عمليات سحب الطلبات الخلفية لكل قناة. يمكن تشغيل أكثر من قناة في الوقت نفسه.",
      "activeJobs": "عمليات نشطة",
      "dismiss": "إخفاء سحب الطلبات من {{name}}",
      "jobIssue": "ملاحظة على سحب الطلبات: {{message}}",
      "issues": {
        "CHANNEL_AUTH_EXPIRED": "انتهى تفويض القناة. أعد ربط هذه القناة ثم حاول مرة أخرى.",
        "CHANNEL_ORDER_PULL_FORBIDDEN": "رفض المزوّد الوصول إلى طلبات هذه القناة. تأكد من أن حساب التاجر منح صلاحية الوصول للطلبات وأن الحساب المضبوط يخص هذا المتجر.",
        "CHANNEL_ORDER_PULL_RATE_LIMITED": "قيّد المزوّد عملية السحب مؤقتاً. انتظر بضع دقائق ثم حاول مرة أخرى.",
        "CHANNEL_ORDER_PULL_PROVIDER_REJECTED": "رفض المزوّد طلب سحب الطلبات. راجع إعدادات الحساب/المنطقة لهذه القناة ثم حاول مرة أخرى.",
        "CHANNEL_ORDER_PULL_PROVIDER_UNAVAILABLE": "طلبات المزوّد غير متاحة مؤقتاً. حاول لاحقاً.",
        "CHANNEL_ORDER_PULL_FAILED": "فشلت عملية سحب الطلبات قبل اكتمالها. حاول مرة أخرى أو راجع سجلات الخادم لهذه القناة.",
        "CHANNEL_ORDER_PULL_INCOMPLETE": "وصلت عملية سحب الطلبات إلى حد الصفحات قبل اكتمالها. ابدأ سحباً آخر أو قلّص نطاق التاريخ.",
        "CHANNEL_ORDER_PULL_ACTIVE": "توجد عملية سحب طلبات نشطة لهذه القناة. انتظر حتى تكتمل قبل بدء عملية أخرى.",
        "CHANNEL_ORDER_PULL_SCHEDULE_FAILED": "تعذرت جدولة سحب الطلبات في الخلفية. حاول مرة أخرى بعد قليل.",
        "CHANNEL_CONNECT_FAILED": "لم تعد القناة متصلة. أعد ربطها ثم حاول مرة أخرى."
      },
      "status": {
        "QUEUED": "في الانتظار",
        "RUNNING": "قيد التشغيل",
        "COMPLETED": "مكتمل",
        "COMPLETED_WITH_ISSUES": "مكتمل مع ملاحظات",
        "FAILED": "فشل"
      },
      "panelTitle": "سحب الطلبات من {{name}}",
      "panelSubtitle": "اختر نطاق تاريخ اختياري للطلبات، ثم جدوِل سحباً يعمل في الخلفية. اترك التواريخ فارغة لاستخدام النطاق الافتراضي للمزوّد.",
      "dateFrom": "من تاريخ",
      "dateTo": "إلى تاريخ",
      "dateFromHint": "اختياري. يشمل الطلبات من بداية هذا اليوم.",
      "dateToHint": "اختياري. يشمل الطلبات حتى نهاية هذا اليوم.",
      "queue": "جدولة السحب",
      "queueing": "جارٍ الجدولة…",
      "cancel": "إغلاق",
      "activeForConnection": "توجد عملية سحب طلبات نشطة لهذه القناة. انتظر حتى تكتمل قبل بدء عملية أخرى.",
      "rangeLabel": "النطاق: {{range}}",
      "rangeDefault": "النطاق الافتراضي للمزوّد",
      "rangeFrom": "من {{from}}",
      "rangeTo": "حتى {{to}}",
      "rangeBetween": "{{from}} – {{to}}"
    },
    "productPull": {
      "jobsTitle": "أحدث عمليات سحب المنتجات",
      "dismiss": "إخفاء سحب المنتجات من {{name}}",
      "status": {
        "QUEUED": "في الانتظار",
        "RUNNING": "قيد التشغيل",
        "DEFERRED": "مؤجل",
        "COMPLETED": "مكتمل",
        "COMPLETED_WITH_ISSUES": "مكتمل مع ملاحظات",
        "FAILED": "فشل"
      },
      "title": {
        "QUEUED": "تمت جدولة سحب المنتجات من {{name}}",
        "RUNNING": "جارٍ سحب المنتجات من {{name}}",
        "DEFERRED": "تم تأجيل سحب المنتجات من {{name}}",
        "COMPLETED": "اكتمل سحب المنتجات من {{name}}",
        "COMPLETED_WITH_ISSUES": "اكتمل سحب المنتجات من {{name}} مع ملاحظات",
        "FAILED": "فشل سحب المنتجات من {{name}}"
      },
      "deferredUntil": "طلب المزوّد من تلاق الانتظار. سيُستأنف السحب تلقائياً بعد {{time}}.",
      "retainedProgress": "تم حفظ تقدم {{count}} صفحة مكتملة ولن تُسحب من جديد.",
      "retry": "إعادة المحاولة من التقدم المحفوظ",
      "retrying": "جارٍ جدولة الإعادة…"
    },
    "table": {
      "channel": "القناة",
      "provider": "المزود",
      "status": "الحالة",
      "adapter": "المحول",
      "source": "المصدر",
      "import": "الاستيراد",
      "webhooks": "الويب هوكس",
      "health": "الصحة",
      "activity": "النشاط",
      "actions": "الإجراءات"
    },
    "webhooks": {
      "unchecked": "لم يتم الفحص",
      "registered": "مسجلة {{registered}}/{{expected}}",
      "missing": "ناقصة {{registered}}/{{expected}}",
      "missingCount": "{{count}} ناقصة",
      "lastChecked": "آخر فحص {{checkedAt}}",
      "notApplicable": "—",
      "check": "فحص",
      "checking": "جارٍ الفحص…",
      "reregister": "إعادة التسجيل",
      "registering": "جارٍ التسجيل…",
      "noonPending": "الويبهوك اختياري. استورد المبيعات من Excel الآن، أو أضف بيانات حساب الخدمة لاحقاً لإنشاء تفاصيل ويبهوك FBPI.",
      "noonFbpiHelper": "أضف وجهة HTTPS في بوابة شركاء نون باستخدام رابط الويبهوك ومفتاح API أدناه. بعدها يمكن لإشعارات نون تشغيل تحديث طلبات FBPI في تلاق.",
      "noonManualOwnership": "يتم إنشاء تفاصيل الوجهة محلياً. لا ينشئ تلاق الوجهة في نون ولا يسجلها أو يتحقق منها نيابةً عنك.",
      "noonTargetUrl": "رابط الويبهوك",
      "noonApiKey": "مفتاح API",
      "copyUrl": "نسخ الرابط",
      "copyApiKey": "نسخ مفتاح API",
      "copied": "تم النسخ"
    },
    "onboarding": {
      "none": "لا توجد مهمة استيراد بعد",
      "notApplicable": "—",
      "retry": "إعادة المحاولة",
      "retrying": "جارٍ الإعادة…",
      "progress": "{{products}} منتجات · {{orders}} طلبات",
      "issues": "{{count}} مشكلات منتجات",
      "status": {
        "QUEUED": "الاستيراد في الانتظار",
        "RUNNING": "الاستيراد جارٍ",
        "COMPLETED": "اكتمل الاستيراد",
        "COMPLETED_WITH_ISSUES": "اكتمل مع مشكلات",
        "FAILED": "فشل الاستيراد"
      }
    },
    "source": {
      "bannerTitle": "مصدر خارجي مفعّل",
      "bannerBody": "مصدر الكتالوج: {{catalog}}. مصدر المخزون: {{stock}}. يمكن أن تكون القناة المتصلة مصدراً، لكن المنتجات لا تُستورد إلا عند سحبها.",
      "catalogBadge": "مصدر الكتالوج",
      "stockBadge": "مصدر المخزون",
      "notSource": "ليست مصدراً",
      "noPushNote": "لا يدفع تلاق المخزون إلى متجر هو مصدره.",
      "amazonCatalogOnly": "أمازون في هذه النسخة التجريبية للكتالوج/القوائم وسحب الطلبات فقط. يبقى المخزون مع مصدر المخزون الحالي.",
      "panelTitle": "إعداد {{name}}",
      "panelSubtitle": "اختر من يملك المنتجات والمخزون في هذه المساحة. بعد ذلك اسحب المنتجات من هذه القناة الآن، أو احفظ اختيار المصدر واستورد لاحقاً.",
      "close": "إغلاق",
      "choiceLabel": "مصدر الحقيقة",
      "owners": {
        "tlaaq": "تلاق",
        "channelFallback": "قناة متصلة",
        "inventoryFallback": "مخزون {{provider}}"
      },
      "confirmSwitch": "حالياً {{current}} هو مصدر المنتجات والمخزون. هل تريد تغيير مصدر الحقيقة إلى {{next}}؟ قد تستبدل المزامنات القادمة أي تعديلات محلية متعارضة.",
      "choices": {
        "tlaaq": {
          "title": "تلاق هو نظامي",
          "body": "أدر المنتجات والمخزون داخل تلاق. يمكن للسحب من هذه القناة إنشاء المنتجات الناقصة كبداية دون جعل القناة مصدراً رئيسياً."
        },
        "keepExisting": {
          "title": "إبقاء المصدر الحالي",
          "body": "أبقِ الكتالوج والمخزون مملوكين لـ {{catalog}} و{{stock}}. سيحدّث تلاق القوائم فقط ولن يستورد المنتجات أو المخزون من هذه القناة."
        },
        "channel": {
          "title": "{{name}} هو نظامي",
          "body": "تُدار المنتجات والمخزون في هذا المتجر. يعكسها تلاق ويمكنه مزامنتها مع الأنظمة المتصلة الأخرى."
        }
      },
      "import": {
        "title": "سحب المنتجات",
        "sourceSyncTitle": "استيراد المنتجات والمخزون من متجر المصدر",
        "sourceSyncBody": "يستخدم وضع مزامنة المصدر: ينشئ المنتجات الناقصة، ويحدّث الحقول المملوكة للمزود، ويستورد أحدث لقطة مخزون.",
        "keepExistingTitle": "تحديث القوائم فقط",
        "keepExistingBody": "يبقي مصادر الكتالوج والمخزون الحالية كما هي. سيحدّث تلاق روابط قوائم المزوّد دون استيراد منتجات أو مخزون.",
        "bootstrapTitle": "استيراد المنتجات الناقصة كبداية",
        "bootstrapBody": "ينشئ منتجات محلية للأكواد الآمنة غير المطابقة. لن تستبدل التغييرات المستقبلية في المتجر بيانات تلاق لأن تلاق يبقى المصدر.",
        "listingsOnlyTitle": "تحديث القوائم فقط",
        "listingsOnlyBody": "يربط قوائم المزود بأكواد SKU الموجودة دون إنشاء منتجات أو استيراد مخزون."
      },
      "resultTitle": "اكتمل السحب من {{name}}",
      "result": {
        "productsCreated": "منتجات جديدة",
        "mapped": "قوائم مطابقة",
        "productsSkipped": "منتجات متخطاة",
        "stockRowsImported": "صفوف مخزون",
        "fetched": "تم سحب {{count}} منتجاً من المزود",
        "listings": "تم تحديث {{count}} قائمة"
      },
      "issues": {
        "title": "مشكلات الاستيراد",
        "unknownSku": "SKU غير معروف",
        "unknownExternalProductId": "معرّف منتج غير معروف",
        "count": "المنتجات: {{count}}",
        "context": "SKU: {{sku}} · ID: {{externalProductId}}",
        "codes": {
          "UNKNOWN": "تحتاج بعض المنتجات إلى مراجعة قبل استيرادها.",
          "MISSING_EXTERNAL_PRODUCT_ID": "معرّف المنتج من المزود مفقود، لذلك تم تخطي هذا العنصر.",
          "MISSING_SKU": "لا يوجد SKU لهذا المنتج — أضفه في متجرك وسنلتقطه في المزامنة القادمة.",
          "INVALID_SKU": "SKU \"{{sku}}\" يحتوي على رموز غير مدعومة. حدّثه في المتجر ثم أعد المزامنة.",
          "DUPLICATE_PROVIDER_SKU": "يوجد منتجان يشتركان في SKU \"{{sku}}\". لم نستورد أيّاً منهما — يرجى تغيير أحدهما.",
          "DUPLICATE_PROVIDER_SKU_STOCK_SKIPPED": "تم تخطي المخزون لأن أكثر من منتج لدى المزود يستخدم SKU \"{{sku}}\".",
          "MISSING_PRICE": "السعر مفقود لـ SKU \"{{sku}}\". استوردناه بسعر 0 للمراجعة.",
          "SKU_CONFLICT": "SKU \"{{sku}}\" موجود بالفعل في تلاق ويحتاج إلى مراجعة.",
          "INVALID_IMAGE_URL": "رابط إحدى الصور غير صالح، لذلك تم تخطي تلك الصورة.",
          "MISSING_STOCK_QUANTITY": "كمية المخزون غير متاحة — جرّب التحديث في متجرك.",
          "INFINITE_STOCK_UNSUPPORTED": "هذا المنتج مضبوط على مخزون غير محدود. لا يدعم تلاق المخزون غير المحدود حالياً — حدّد كمية للمزامنة.",
          "NEGATIVE_STOCK_CLAMPED": "تم تحويل المخزون السالب إلى 0.",
          "PRODUCT_SKU_CONFLICT": "SKU \"{{sku}}\" موجود بالفعل في تلاق ويحتاج إلى مراجعة."
        }
      }
    },
    "loading": "جارٍ تحميل القنوات…",
    "confirmDelete": "هل تريد حذف {{name}}؟\n\nسيؤدي هذا إلى حذف هذه القناة نهائياً وكل الطلبات المرتبطة بها وكل منتج مرتبط بهذه القناة — حتى المنتجات المعيّنة أيضاً لقناة أخرى. ستصبح قوائم القنوات الأخرى لهذه المنتجات غير معيّنة. لا يمكن التراجع عن هذا الإجراء.",
    "empty": {
      "title": "لا توجد روابط قنوات بعد",
      "subtitle": "أضف مزوداً واسم عرض لإنشاء أول ربط بحالة انتظار."
    },
    "errors": {
      "generic": "تعذّر تحديث القنوات. حاول مرة أخرى.",
      "validation": "اختر مزوداً وأدخل اسم العرض.",
      "codes": {
        "REQUEST_FAILED": "تعذّر تحديث القنوات. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لإدارة القنوات.",
        "VALIDATION_FAILED": "اختر مزوداً وأدخل اسم العرض.",
          "CHANNEL_CREDENTIALS_REQUIRED": "أدخل بيانات اعتماد البائع المطلوبة لهذا المزود.",
          "CHANNEL_CREDENTIALS_WAREHOUSE_REQUIRED": "أدخل رمز مستودع Noon FBPI المستخدم لسحب الطلبات.",
          "CHANNEL_CREDENTIALS_JSON_INVALID": "الصق ملف JSON صالحاً لحساب خدمة نون.",
          "CHANNEL_CREDENTIALS_JSON_FIELDS_REQUIRED": "يجب أن يتضمن JSON حساب خدمة نون الحقول private_key و key_id و project_code و channel_identifier.",
        "CHANNEL_PROVIDER_UNSUPPORTED": "هذا المزود غير مدعوم لروابط القنوات حالياً.",
        "CHANNEL_CONNECTION_EXISTS": "يوجد ربط لهذا المزود بالفعل.",
        "CHANNEL_CONNECTION_NOT_FOUND": "لم يتم العثور على ربط القناة هذا.",
        "CHANNEL_DISCONNECT_FAILED": "فشل الفصل من المزود. حاول لاحقاً.",
        "CHANNEL_DELETE_FAILED": "تعذّر حذف هذه القناة. حاول مرة أخرى.",
        "CHANNEL_DELETE_CONFIRMATION_REQUIRED": "أكّد أن المنتجات والطلبات المرتبطة ستحذف قبل حذف هذه القناة.",
        "CHANNEL_ADAPTER_NOT_REGISTERED": "محول هذه القناة غير متاح بعد.",
        "CHANNEL_CONNECT_FAILED": "تعذّر بدء عملية ربط القناة. حاول لاحقاً.",
        "CHANNEL_OAUTH_STATE_INVALID": "انتهت صلاحية جلسة الربط أو سبق استخدامها. ابدأ عملية الربط من جديد.",
        "CHANNEL_OAUTH_CALLBACK_FAILED": "رفض المزود إكمال الربط. حاول مرة أخرى.",
        "CHANNEL_AUTH_EXPIRED": "انتهى تفويض القناة. أعد الربط للمتابعة.",
        "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "يتعارض حساب البائع مع شريك هذه القناة المحفوظ أو مع اتصال موجود آخر.",
        "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "لم نجد مهمة استيراد لهذه القناة بعد.",
        "CHANNEL_ONBOARDING_INCOMPLETE": "مهمة الاستيراد ليست جاهزة لإعادة المحاولة بعد.",
        "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "تعذّرت جدولة مهمة الاستيراد. حاول مرة أخرى.",
        "CHANNEL_ORDER_PULL_FORBIDDEN": "رفض المزود الوصول إلى طلبات هذه القناة. راجع صلاحيات البائع وإعدادات السوق.",
        "CHANNEL_ORDER_PULL_RATE_LIMITED": "قيّد المزود عملية سحب الطلبات مؤقتاً. انتظر بضع دقائق ثم حاول مرة أخرى.",
        "CHANNEL_ORDER_PULL_PROVIDER_REJECTED": "رفض المزود طلب سحب الطلبات. راجع إعدادات السوق/المنطقة لهذه القناة ثم حاول مرة أخرى.",
        "CHANNEL_ORDER_PULL_PROVIDER_UNAVAILABLE": "واجهة طلبات المزود غير متاحة مؤقتاً. حاول لاحقاً.",
        "CHANNEL_ORDER_PULL_FAILED": "فشلت عملية سحب الطلبات قبل اكتمالها. حاول مرة أخرى.",
        "CHANNEL_SOURCE_AUTHORITY_ACTIVE": "هذه القناة هي مصدر الحقيقة. أعد المنتجات والمخزون إلى تلاق قبل فصلها.",
        "CHANNEL_PRODUCT_PULL_ACTIVE": "توجد عملية سحب منتجات نشطة لهذه القناة. انتظر حتى تكتمل قبل بدء عملية أخرى.",
        "CHANNEL_PRODUCT_PULL_JOB_NOT_FOUND": "تعذّر العثور على مهمة سحب المنتجات هذه.",
        "CHANNEL_PRODUCT_PULL_RETRY_NOT_ALLOWED": "يمكن إعادة محاولة عمليات سحب المنتجات الفاشلة فقط.",
        "CHANNEL_PRODUCT_PULL_SCHEDULE_FAILED": "تعذّرت جدولة سحب المنتجات في الخلفية. أعد المحاولة من التقدم المحفوظ.",
        "CHANNEL_PRODUCT_PULL_CURSOR_STALLED": "كرر المزوّد الصفحة نفسها. أعد المحاولة من التقدم المحفوظ أو تواصل مع الدعم.",
        "CHANNEL_PRODUCT_PULL_PAGE_LIMIT": "وصل سحب المنتجات إلى حد الأمان للصفحات قبل اكتماله.",
        "CHANNEL_PRODUCT_PULL_RATE_LIMITED": "قيّد المزوّد سحب المنتجات مؤقتاً. سيستأنفه تلاق تلقائياً.",
        "CHANNEL_PRODUCT_PULL_RATE_LIMIT_RETRY_EXHAUSTED": "استمر المزوّد في تقييد سحب المنتجات. أعد المحاولة من التقدم المحفوظ لاحقاً.",
        "NOON_LISTING_REFRESH_PROVIDER_ERROR": "تعذّر إكمال التحديث من نون. أعد المحاولة من التقدم المحفوظ؛ لم تتغير بيانات العرض المحفوظة سابقاً.",
        "NOON_LISTING_REFRESH_INVALID_RESPONSE": "أعادت نون بيانات مستودعات غير صالحة. أعد محاولة التحديث لاحقاً.",
        "CHANNEL_PRODUCT_PULL_SOURCE_MISMATCH": "يتطلب وضع السحب هذا أن تكون القناة المختارة مصدر الكتالوج.",
        "CHANNEL_STOCK_PULL_SOURCE_MISMATCH": "يتطلب استيراد المخزون أن تكون القناة المختارة مصدر المخزون.",
        "SOURCE_AUTHORITY_CONFLICT": "يوجد مصدر آخر مفعّل. أكد التغيير وحاول مرة أخرى.",
        "SOURCE_AUTHORITY_INVALID_DOMAIN": "اختر نطاق مصدر صالحاً.",
        "SOURCE_AUTHORITY_INVALID_OWNER": "اختر مالك مصدر صالحاً.",
        "SOURCE_AUTHORITY_CHANNEL_CONNECTION_NOT_FOUND": "تعذّر العثور على القناة المتصلة.",
        "SOURCE_AUTHORITY_CHANNEL_NOT_CONNECTED": "اربط القناة قبل جعلها مصدر الحقيقة.",
        "SOURCE_AUTHORITY_INVENTORY_CONNECTION_NOT_FOUND": "تعذّر العثور على ربط المخزون.",
        "CHANNEL_INVALID_DATE_RANGE": "يجب أن يكون تاريخ النهاية في نفس يوم البداية أو بعده.",
        "CHANNEL_ORDER_PULL_ACTIVE": "توجد عملية سحب طلبات نشطة لهذه القناة. انتظر حتى تكتمل قبل بدء عملية أخرى."
      }
    }
  },
  "billing": {
    "notice": {
      "title": "لا تتم فوترتك من تلاق مباشرة اليوم",
      "body": "يُدفع اشتراك تلاق عبر سوق تطبيقات واجهة متجرك. ستجد تلاق كتطبيق مثبت داخل زد وسلة وتظهر الرسوم هناك."
    },
    "status": {
      "active": "نشط",
      "free": "مجاني"
    },
    "plan": {
      "label": "الخطة",
      "zidName": "Growth · 299 ر.س/شهر",
      "zidRenews": "يتجدد في 14 مايو 2026",
      "sallaName": "Special · 199 ر.س/شهر",
      "sallaRenews": "يتجدد في 02 يونيو 2026"
    },
    "actions": {
      "manageZid": "إدارة في زد ↗",
      "manageSalla": "إدارة في سلة ↗"
    },
    "free": {
      "title": "قنوات مجانية الربط",
      "body": "هذه القنوات لا تحمل اشتراك تلاق اليوم. سنخبرك إذا تغير ذلك."
    },
    "stores": {
      "zid": "زد · Fitneeds Zid",
      "zidDomain": "fitneeds.zid.sa",
      "salla": "سلة · Beanzi Coffee",
      "sallaDomain": "beanzi.salla.sa"
    }
  },
  "warehouses": {
    "description": {
      "zoho": "تأتي مستودعاتك من مخزون زوهو وهي للقراءة فقط هنا. أضف أو عدّل المستودعات في زوهو وسيلتقط تلاق التغييرات.",
      "tlaaq": "تلاق هو مصدر مخزونك، لذلك تدير المستودعات هنا. اربط زوهو أو مصدراً آخر لمزامنتها تلقائياً."
    },
    "actions": {
      "syncZoho": "مزامنة من زوهو",
      "openZoho": "فتح في زوهو ↗",
      "new": "مستودع جديد",
      "edit": "تعديل المستودع",
      "delete": "حذف المستودع",
      "save": "حفظ المستودع",
      "saving": "جارٍ الحفظ…",
      "cancel": "إلغاء"
    },
    "banner": {
      "synced": "متزامن من زوهو · منذ 4 دقائق",
      "managed": "يُدار في تلاق",
      "autoRefresh": "تحديث تلقائي كل 5 دقائق"
    },
    "table": {
      "warehouse": "المستودع",
      "code": "الكود",
      "location": "الموقع",
      "skus": "الأكواد",
      "units": "الوحدات",
      "source": "المصدر"
    },
    "form": {
      "titleCreate": "مستودع جديد",
      "titleEdit": "تعديل المستودع",
      "name": "الاسم",
      "code": "الكود",
      "location": "الموقع"
    },
    "empty": {
      "title": "لا توجد مستودعات بعد",
      "body": "أنشئ أول مستودع لبدء تتبع المخزون لكل موقع."
    },
    "loading": "جارٍ تحميل المستودعات…",
    "confirmDelete": "حذف المستودع \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
    "errors": {
      "codes": {
        "REQUEST_FAILED": "تعذّر تحميل المستودعات. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة.",
        "VALIDATION_FAILED": "أدخل الكود والاسم للمتابعة.",
        "WAREHOUSE_NOT_FOUND": "لم يتم العثور على المستودع.",
        "WAREHOUSE_CODE_CONFLICT": "يوجد مستودع بهذا الكود بالفعل.",
        "WAREHOUSE_HAS_STOCK": "ما زال هذا المستودع يحوي مخزوناً ولا يمكن حذفه."
      }
    },
    "readOnly": "قراءة فقط"
  },
  "team": {
    "description": "ادعُ زملاءك للمساعدة في تشغيل متجرك. كل عضو مدعو يحصل على صلاحية كاملة للمتجر في هذه النسخة؛ لا يوجد اختيار أدوار حالياً.",
    "invite": "دعوة زميل",
    "loading": "جارٍ تحميل الفريق…",
    "inviteForm": {
      "title": "دعوة زميل",
      "helper": "سنرسل رابط دعوة آمناً عبر البريد ليختار كلمة مرور وينضم إلى مساحة العمل.",
      "fullName": "الاسم الكامل",
      "fullNamePlaceholder": "عمر بدر",
      "email": "البريد الإلكتروني للعمل",
      "emailPlaceholder": "teammate@company.com",
      "submit": "إرسال الدعوة",
      "submitting": "جارٍ إرسال الدعوة…",
      "cancel": "إلغاء"
    },
    "sections": {
      "members": "الأعضاء النشطون",
      "pendingInvites": "الدعوات المعلّقة"
    },
    "table": {
      "member": "العضو",
      "access": "الصلاحية",
      "status": "الحالة",
      "lastSeen": "آخر ظهور",
      "expires": "تنتهي",
      "invitedBy": "أرسلها",
      "actions": "الإجراءات"
    },
    "access": {
      "owner": "مالك",
      "full": "صلاحية كاملة"
    },
    "status": {
      "active": "نشط",
      "pending": "معلّقة"
    },
    "actions": {
      "remove": "إزالة",
      "cancelInvite": "إلغاء الدعوة"
    },
    "confirm": {
      "remove": "إزالة {{name}} من مساحة العمل؟",
      "cancelInvite": "إلغاء الدعوة إلى {{email}}؟"
    },
    "empty": {
      "members": "لا يوجد زملاء نشطون بعد.",
      "invites": "لا توجد دعوات معلّقة.",
      "lastSeen": "لم يظهر بعد",
      "notAvailable": "—"
    },
    "errors": {
      "load": "تعذّر تحميل الفريق. حاول مرة أخرى.",
      "inviteFields": "أدخل اسم الزميل وبريده الإلكتروني.",
      "emailAlreadyUser": "يوجد حساب بهذا البريد بالفعل. اطلب منه تسجيل الدخول أو استخدم بريداً مختلفاً.",
      "invite": "تعذّر إرسال الدعوة. حاول مرة أخرى.",
      "remove": "تعذّر إزالة هذا الزميل. حاول مرة أخرى.",
      "cancelInvite": "تعذّر إلغاء هذه الدعوة. حاول مرة أخرى.",
      "ownerRequired": "يمكن لمالكي مساحة العمل فقط إدارة دعوات الفريق."
    }
  },
  "pages": {
    "orderRouting": {
      "orderFacts": "بيانات الطلب",
      "resolvedMapping": "قيم Zoho المحسومة",
      "policyStatus": {
        "DRAFT": "مسودة",
        "ACTIVE": "نشطة",
        "ARCHIVED": "مؤرشفة"
      },
      "design": {
        "defaults": "مسار Zoho الافتراضي",
        "inheritHelp": "تُحسم كل قيمة بشكل مستقل. يُستخدم أول قرار مطابق، ثم يُراجع الافتراضي أخيراً.",
        "lifecycleHelp": "اربط حالات الطلب الواردة بإجراء Zoho التالي. اضبط قيم التوجيه في مصفوفة التوجيه.",
        "lifecycleNotice": "تظل حالة المستندات في Zoho سارية. معاينة السياسة لا ترسل طلباً ولا تنشئ مستنداً.",
        "internalOrderId": "معرف الطلب الداخلي في تلاق (وليس رقم طلب المتجر)",
        "previewError": "تعذرت معاينة الطلب. تحقق من معرفه الداخلي وأنه يتبع إحدى قنوات هذه السياسة."
      },
      "picker": { "selected": "المحدد:",
        "title": "اختيار صنف رسوم",
        "empty": "لا توجد منتجات مطابقة.",
        "help": "اختر منتجاً موجوداً. يتحقق الحفظ من ربطه بصنف Zoho؛ لا يتم إنشاء منتج هنا.",
        "cancel": "إلغاء",
        "apply": "استخدام المنتج المحدد"
      },
      "disabled": "توجيه الطلبات غير مفعّل لهذه المنشأة. تستمر السياسات الحالية دون تغيير.",
      "observed": {
        "count": "رُصدت في {{count}} طلبات",
        "empty": "لا توجد قيم مرصودة. أدخل قيمة دقيقة إن كانت معروفة.",
        "error": "تعذر تحميل القيم المرصودة. أعد فتح هذه الخطوة للمحاولة مجددًا."
      },
      "title": "توجيه الطلبات",
      "back": "رجوع",
      "retry": "إعادة المحاولة",
      "copy": "نسخ إلى مسودة جديدة",
      "previous": "السابق",
      "next": "التالي",
      "loading": "جارٍ تحميل سياسة التوجيه…",
      "noConnection": "اختر اتصال Zoho Inventory أولاً.",
      "locked": "نسخة مقفلة",
      "sourceOrder": "بدأ الإعداد من الطلب رقم {{id}}. لن تُحفظ الشروط تلقائياً.",
      "steps": {
        "label": "خطوات إعداد التوجيه",
        "scope": "النطاق",
        "lifecycle": "دورة الطلب",
        "segments": "الشرائح",
        "matrix": "المصفوفة",
        "review": "المراجعة"
      },
      "scope": {
        "title": "نطاق السياسة",
        "name": "اسم السياسة",
        "invoiceSource": "مصدر الفاتورة",
        "localOrder": "بيانات الطلب المحلي",
        "zohoSnapshot": "لقطة أمر البيع في Zoho"
      },
      "lifecycle": {
        "title": "إجراءات دورة الطلب",
        "raw": "حالات المصدر الاختيارية، مفصولة بفواصل",
        "moveUp": "تقديم الإجراء",
        "moveDown": "تأخير الإجراء"
      },
      "segments": {
        "title": "الشرائح",
        "add": "إضافة شريحة",
        "default": "الافتراضي",
        "values": "القيم، مفصولة بفواصل",
        "addPredicate": "إضافة شرط",
        "pinned": "دائماً في النهاية",
        "selected": "قيد التحرير",
        "editor": "شروط الشريحة",
        "editorHelp": "اختر بيانات الطلب التي تحدد هذه الشريحة. اضبط قيم Zoho الخاصة بها في مصفوفة التوجيه.",
        "matchHelp": "يجب أن تتحقق جميع الشروط معاً (AND). تُحسم القيم بشكل مستقل حسب ترتيب الشرائح، ويوفر الافتراضي القيم عند عدم وجود قرار سابق ينطبق عليها."
      },
      "source": {
        "title": "إنشاء شريحة من هذا الطلب",
        "help": "اختر فقط بيانات التوجيه غير الشخصية التي تريد حفظها. لا نعرض بيانات العميل.",
        "name": "اسم الشريحة الجديدة غير المحفوظة",
        "add": "إنشاء شريحة غير محفوظة"
      },
      "matrix": {
        "title": "مصفوفة التوجيه",
        "segment": "الشريحة",
        "productSearch": "البحث في منتجات الرسوم",
        "productsLoading": "جارٍ البحث في المنتجات…",
        "productsError": "تعذر تحميل المنتجات. غيّر البحث لإعادة المحاولة.",
        "mode": "الوضع",
        "inherit": "توريث",
        "set": "تعيين",
        "clear": "مسح",
        "choose": "اختر قيمة فعلية", "productId": "منتج رقم {{id}}"
      },
      "review": {
        "title": "المراجعة والحفظ",
        "summary": "{{channels}} قنوات · {{actions}} إجراءات · {{segments}} شرائح · {{cells}} قرارات",
        "feeNotice": "يبقى احتساب الرسوم على وضع زد القديم. يدير الخادم إعدادات الضريبة.",
        "invalid": "أكمل اسم السياسة والنطاق ودورة الطلب وكل شرط شريحة.",
        "save": "حفظ المسودة",
        "saving": "جارٍ الحفظ…",
        "saved": "تم حفظ المسودة."
      },
      "preview": {
        "resolutions": {
          "SET": "مُعيّن",
          "CLEAR": "ممسوح",
          "UNRESOLVED": "غير محسوم"
        },
        "noSource": "لا يوجد قرار مطابق",
        "title": "معاينة المسودة المحفوظة",
        "help": "تستخدم المعاينة المسودة المحفوظة وليس التعديلات غير المحفوظة.",
        "orderId": "معرف الطلب",
        "run": "تشغيل المعاينة",
        "loading": "جارٍ إعداد المعاينة…",
        "result": "معاينة الطلب رقم {{id}}",
        "action": "إجراء دورة الطلب",
        "none": "لا يوجد إجراء",
        "segmentCount": "{{count}} شرائح مطابقة",
        "blockers": "{{count}} أخطاء مانعة",
        "warnings": "{{count}} تحذيرات"
      },
      "compatibility": {
        "badge": "الإصدار 1",
        "title": "سياسة قديمة",
        "available": "حوّل المسودة أو أنشئ نسخة مسودة جديدة باستخدام تحويل التوافق على الخادم. لا تتغير السياسات النشطة أو مستندات الطلبات الحالية.",
        "convert": "تحويل هذه المسودة",
        "dormant": "تبقى {{count}} قواعد استثناء تاريخية غير نشطة ولا تُحوّل.",
        "unavailable": "التحويل الآمن غير متاح بعد. استخدم محرر قواعد المزامنة القديم؛ لم تتغير هذه السياسة."
      },
      "actions": {
        "CREATE_SALES_ORDER": "إنشاء أمر بيع",
        "CONFIRM_SALES_ORDER": "تأكيد أمر البيع",
        "CREATE_INVOICE": "إنشاء فاتورة",
        "VOID_SALES_ORDER": "إلغاء أمر البيع",
        "CREATE_CREDIT_NOTE": "إنشاء إشعار دائن"
      },
      "statuses": {
        "NEW": "جديد",
        "IN_PROGRESS": "قيد التنفيذ",
        "COMPLETED": "مكتمل",
        "CANCELLED": "ملغي",
        "UNKNOWN": "غير معروف"
      },
      "operators": {
        "EQUALS": "يساوي",
        "ONE_OF": "واحد من",
        "PREFIX": "يبدأ بـ",
        "SUFFIX": "ينتهي بـ",
        "CONTAINS": "يحتوي"
      },
      "lineScope": {
        "ANY_LINE": "أي بند",
        "ALL_LINES": "كل البنود",
        "NO_LINE": "لا بند"
      },
      "fields": {
        "CHANNEL_PROVIDER": "مزود القناة",
        "CHANNEL_CONNECTION_ID": "اتصال القناة",
        "ORDER_STATUS": "حالة الطلب",
        "RAW_STATUS": "الحالة الأصلية",
        "PAYMENT_STATUS": "حالة الدفع",
        "PAYMENT_METHOD_CODE": "رمز طريقة الدفع",
        "PAYMENT_METHOD_NAME": "اسم طريقة الدفع",
        "PAYMENT_METHOD_TYPE": "نوع طريقة الدفع",
        "PAYMENT_METHOD_EXTERNAL_ID": "معرف طريقة الدفع",
        "SHIPPING_METHOD_EXTERNAL_ID": "معرف طريقة الشحن",
        "SHIPPING_METHOD_CODE": "رمز طريقة الشحن",
        "SHIPPING_COMPANY": "شركة الشحن",
        "SHIPPING_METHOD": "طريقة الشحن",
        "FULFILLMENT_CHANNEL": "قناة التنفيذ",
        "FULFILLMENT_STATUS": "حالة التنفيذ",
        "LINE_ITEM_SKU": "رمز صنف الطلب"
      },
      "outputs": {
        "CUSTOMER": "العميل",
        "WAREHOUSE": "المستودع",
        "SALES_PERSON": "مندوب المبيعات",
        "PAYMENT_TERMS": "شروط الدفع",
        "DELIVERY_METHOD": "طريقة التسليم",
        "REPORTING_TAG": "وسم التقرير",
        "PAYMENT_FEE_ITEM": "صنف رسوم الدفع",
        "SHIPPING_FEE_ITEM": "صنف رسوم الشحن"
      },
      "errors": {
        "REQUEST_FAILED": "تعذر تحميل توجيه الطلبات أو حفظه. حاول مرة أخرى."
      },
      "defaults": {
        "complete": "المسار الافتراضي مكتمل. كل طلب يستطيع تحديد عميل ومستودع.",
        "required": "يجب أن يحدد المسار الافتراضي عميلاً ومستودعاً قبل تفعيل هذه السياسة."
      }
    },
    "salesAnalytics": {
      "title": "تحليلات المبيعات",
      "subtitle": "استكشف الطلبات المحفوظة وإجماليات المبيعات المسجلة للفترة التي تختارها.",
      "timeZone": "المنطقة الزمنية: {{zone}}",
      "generatedAt": "آخر تحديث {{value}}",
      "sundayWeek": "تبدأ الفترة الأسبوعية يوم الأحد وتنتهي اليوم. تعيد الواجهة الحدود الدقيقة للتقرير.",
      "sundayWeekShort": "أسبوع يبدأ الأحد",
      "filters": {
        "channel": "القناة",
        "allChannels": "جميع القنوات",
        "channelsError": "تعذر تحميل القنوات.",
        "range": "فترة التقرير",
        "from": "من",
        "to": "إلى",
        "apply": "تطبيق التواريخ",
        "granularity": "تجميع الاتجاه",
        "compare": "مقارنة الفترة",
        "compareHint": "عرض الفترة السابقة المكافئة"
      },
      "ranges": {
        "TODAY": "اليوم",
        "YESTERDAY": "أمس",
        "THIS_WEEK": "هذا الأسبوع",
        "THIS_MONTH": "هذا الشهر",
        "THIS_YEAR": "هذه السنة",
        "CUSTOM": "مخصصة"
      },
      "granularities": {
        "AUTO": "تلقائي",
        "DAY": "يومي",
        "MONTH": "شهري"
      },
      "comparison": {
        "new": "جديد",
        "percent": "{{value}}٪"
      },
      "summary": {
        "totalOrders": "إجمالي الطلبات",
        "salesOrders": "طلبات المبيعات",
        "cancelledOrders": "الطلبات الملغاة",
        "unknownOrders": "طلبات بحالة غير معروفة",
        "storedSalesTotal": "إجمالي المبيعات المسجل · {{currency}}",
        "averageOrderValue": "متوسط {{value}} عبر {{count}} طلبات تحمل مبلغاً",
        "noMoney": "لا تحتوي طلبات المبيعات في هذه الفترة على مبلغ وعملة صالحين."
      },
      "trend": {
        "title": "اتجاه الطلبات والمبيعات",
        "subtitle": "فترات تقويمية محلية مكتملة من الواجهة؛ وتظل الفترات بلا نشاط ظاهرة.",
        "currency": "عملة المبيعات",
        "noCurrency": "لا توجد عملة",
        "caption": "حجم الطلبات للفترة {{period}}",
        "chartAria": "مخطط أعمدة لإجمالي الطلبات حسب فترة التقرير",
        "pointTitle": "{{date}}: إجمالي {{count}} طلبات",
        "tableCaption": "بديل جدولي لاتجاه الطلبات والمبيعات المسجلة",
        "columns": {
          "date": "الفترة",
          "totalOrders": "الإجمالي",
          "salesOrders": "المبيعات",
          "cancelledOrders": "الملغاة",
          "storedSales": "المبيعات المسجلة · {{currency}}"
        }
      },
      "bestSellers": {
        "title": "المنتجات الأكثر مبيعاً",
        "subtitle": "أعلى 10 حسب الوحدات الموجبة المعروفة؛ لقطات المزوّد غير مرتبطة بمنتجات الكتالوج.",
        "empty": "لا توجد بنود مبيعات قابلة للتعريف في هذه الفترة.",
        "approximate": "تطابق بالاسم فقط",
        "units": "الوحدات المباعة",
        "orders": "الطلبات",
        "noMoney": "لا يوجد إجمالي صالح للبند",
        "columns": {
          "item": "البند",
          "units": "الوحدات",
          "orders": "الطلبات",
          "storedSales": "إجماليات البنود المسجلة"
        }
      },
      "breakdowns": {
        "title": "تفصيل الطلبات",
        "subtitle": "كل قائمة محدودة بالأسماء الأبرز مع فئتي غير معروف وأخرى بشكل صريح.",
        "payment": "طرق الدفع",
        "shipping": "طرق الشحن",
        "channels": "القنوات",
        "unknown": "غير معروف",
        "other": "أخرى",
        "empty": "لا توجد طلبات لتفصيلها.",
        "orderCount": "{{count}} طلبات"
      },
      "dataQuality": {
        "title": "بعض بيانات المزوّد غير مكتملة",
        "body": "يبقي التقرير الطلبات المحفوظة غير المكتملة ظاهرة ويوضح مواضع نقص التغطية.",
        "items": {
          "fallbackTimestamp": "{{count}} طلبات تستخدم وقت التحديث أو آخر ظهور.",
          "missingMoney": "{{count}} طلبات مبيعات بلا مبلغ أو عملة صالحة.",
          "missingPayment": "{{count}} طلبات بلا تعريف لطريقة الدفع.",
          "missingShipping": "{{count}} طلبات بلا تعريف لطريقة الشحن.",
          "excludedLines": "استُبعد {{count}} من بنود المبيعات من الترتيب."
        }
      },
      "states": {
        "loading": "جارٍ تحميل تحليلات المبيعات…",
        "refreshing": "جارٍ تحديث التقرير، وتبقى النتيجة السابقة ظاهرة.",
        "staleError": "فشل آخر تحديث. تبقى النتيجة السابقة ظاهرة.",
        "retry": "إعادة المحاولة",
        "emptyTitle": "لا توجد طلبات في هذه الفترة",
        "emptyBody": "اختر فترة تقرير أخرى لعرض نشاط المبيعات المحفوظ."
      },
      "errors": {
        "requestFailed": "تعذر تحميل تحليلات المبيعات.",
        "customRequired": "اختر تاريخ بداية وتاريخ نهاية.",
        "customOrder": "يجب أن يكون تاريخ النهاية في تاريخ البداية أو بعده.",
        "customFuture": "لا يمكن أن يكون تاريخ النهاية في المستقبل.",
        "customTooLarge": "اختر فترة لا تتجاوز 366 يوماً.",
        "codes": {
          "INVALID_ANALYTICS_RANGE": "فترة التقرير المحددة غير مدعومة.",
          "ANALYTICS_RANGE_PARAMETERS_INVALID": "مجموعة التواريخ المحددة غير صالحة.",
          "ANALYTICS_RANGE_TOO_LARGE": "اختر فترة لا تتجاوز 366 يوماً.",
          "INVALID_ANALYTICS_TIME_ZONE": "المنطقة الزمنية للمتصفح غير مدعومة.",
          "INVALID_ANALYTICS_GRANULARITY": "تجميع الاتجاه المحدد غير مدعوم."
        }
      }
    },
    "channelInventoryVariance": {
      "back": "العودة إلى القنوات",
      "title": "تباين مخزون القنوات",
      "description": "راجع القوائم المرتبطة التي تتعارض فيها لقطة مخزون القناة مع توفر المصدر. هذا التقرير للقراءة فقط ولا يدفع المخزون إلى المزودين أبداً.",
      "loading": "جارٍ تحميل تقرير تباين المخزون…",
      "generatedAt": "تم الإنشاء {{value}}",
      "neverSeen": "لا يوجد",
      "noSku": "لا يوجد SKU",
      "lastSeen": "آخر ظهور {{value}}",
      "locations": "موقع واحد",
      "locations_plural": "{{count}} مواقع",
      "summary": {
        "total": "إجمالي التباينات",
        "danger": "صفوف خطرة",
        "warning": "صفوف تحذيرية",
        "excluded": "لقطات مستبعدة",
        "excludedSub": "∞ {{infinite}} · غير معروف {{unknown}}",
        "live": "تقرير فعلي"
      },
      "severity": {
        "WARNING": "تحذير",
        "DANGER": "خطر"
      },
      "types": {
        "NEGATIVE_CHANNEL_QUANTITY": "كمية قناة سالبة",
        "ZERO_OR_NEGATIVE_SOURCE_POSITIVE": "القناة صفر بينما لدى المصدر مخزون",
        "CHANNEL_EXCEEDS_SOURCE_AVAILABILITY": "القناة تتجاوز توفر المصدر"
      },
      "remediation": {
        "title": "إرشاد معالجة للقراءة فقط",
        "body": "استخدم هذا التقرير لفحص المنتج، والتأكد من مخزون المصدر، ومراجعة قواعد التوزيع. هذه الشاشة لا تعدّل مخزون المصدر ولا تدفع مخزون المزود."
      },
      "filters": {
        "query": "بحث",
        "queryPlaceholder": "SKU أو المنتج أو القائمة أو معرّف المزود…",
        "provider": "المزود",
        "allProviders": "كل المزودين",
        "connection": "القناة",
        "allChannels": "كل القنوات",
        "warehouse": "مستودع المصدر",
        "allWarehouses": "كل المستودعات",
        "loadError": "تعذّر تحميل فلاتر القنوات والمستودعات."
      },
      "actions": {
        "applyFilters": "تطبيق الفلاتر",
        "clearFilters": "مسح",
        "retry": "إعادة المحاولة",
        "viewProduct": "عرض المنتج",
        "stockAllocation": "توزيع المخزون"
      },
      "empty": {
        "title": "لا توجد تباينات مخزون",
        "body": "لا توجد قوائم قنوات مرتبطة تطابق فلاتر التباين الحالية."
      },
      "table": {
        "product": "المنتج",
        "channelListing": "قائمة القناة",
        "source": "المصدر",
        "channel": "القناة",
        "difference": "الفرق",
        "variance": "التباين",
        "lastSeen": "آخر ظهور",
        "actions": "الإجراءات"
      },
      "sort": {
        "none": "عمود {{column}} غير مرتب. فعّله للترتيب تنازلياً.",
        "ascending": "عمود {{column}} مرتب تصاعدياً. فعّله للترتيب تنازلياً.",
        "descending": "عمود {{column}} مرتب تنازلياً. فعّله للترتيب تصاعدياً."
      },
      "paginationRange": "عرض {{start}}–{{end}} من {{total}}",
      "previous": "السابق",
      "next": "التالي",
      "errors": {
        "REQUEST_FAILED": "تعذّر تحميل تقرير تباين المخزون. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لعرض تقرير التباين.",
        "CHANNEL_INVENTORY_VARIANCE_REPORT_FAILED": "تعذّر حساب تقرير التباين الآن. حاول مرة أخرى."
      },
      "export": {
        "action": "تصدير Excel",
        "exporting": "جارٍ التصدير…",
        "error": "تعذّر تصدير تقرير التباين. حاول التصدير مرة أخرى."
      }
    },
    "channelConnectionDetail": {
      "back": "العودة إلى القنوات",
      "loading": "جارٍ تحميل اتصال القناة…",
      "retry": "إعادة المحاولة",
      "notFoundTitle": "اتصال القناة غير متاح",
      "notFoundBody": "لم نعثر على اتصال القناة هذا أو لم يعد متاحاً. ارجع إلى القنوات لاختيار اتصال آخر.",
      "identityTitle": "حالة الاتصال",
      "connectionId": "معرّف الاتصال {{id}}",
      "statusLabel": "الحالة",
      "adapterLabel": "المحوّل",
      "orderRefreshLabel": "تحديث الطلب",
      "available": "متاح",
      "unavailable": "غير متاح",
      "safeguardsTitle": "ضمانات الإرسال إلى زوهو",
      "preSendRefreshLabel": "تحديث الطلب قبل إرساله إلى زوهو",
      "preSendRefreshDescription": "عند التفعيل، يجلب تلاق الطلب من القناة أولاً قبل كل إرسال يدوي، وكل محاولة تلقائية مفعّلة أو إعادة محاولة أو تسوية. تُتخطى المهام التلقائية المعطّلة دون جلب، وأي فشل في التحديث يمنع الإرسال إلى زوهو.",
      "unavailableWarning": "تحديث ما قبل الإرسال غير متاح حالياً لأن الاتصال غير متصل، أو المحوّل غير متاح، أو تحديث الطلبات معطّل. يمكنك حفظ الإعداد الآن، لكن إرسال الطلبات إلى زوهو سيبقى محظوراً حتى يتمكن الاتصال من تحديث الطلبات.",
      "save": "حفظ",
      "saving": "جارٍ الحفظ…",
      "saved": "تم حفظ ضمانات القناة.",
      "errors": {
        "generic": "تعذّر تحميل اتصال القناة أو حفظه. حاول مرة أخرى."
      }
    },
    "channelUnmappedListings": {
      "back": "العودة إلى القنوات",
      "total": "قائمة غير مرتبطة واحدة",
      "total_plural": "{{count}} قوائم غير مرتبطة",
      "noChannelTitle": "اختر قناة أولاً",
      "noChannelSubtitle": "افتح صفحة القنوات واختر مراجعة غير المرتبط على قناة متصلة.",
      "externalSourceTitle": "مصدر كتالوج خارجي مفعّل",
      "externalSourceBody": "الربط هنا يضيف اسماً بديلاً محلياً للمطابقة داخل تلاق فقط. لن يتغير مخزون المصدر.",
      "listTitle": "قوائم القناة غير المرتبطة",
      "listSubtitle": "اختر قائمة واحدة، ثم اختر المنتج الرئيسي الذي تنتمي إليه.",
      "searchListings": "ابحث بالـ SKU أو العنوان أو معرّف المزود…",
      "search": "بحث",
      "loading": "جارٍ تحميل القوائم غير المرتبطة…",
      "emptyTitle": "لا توجد قوائم غير مرتبطة",
      "emptySubtitle": "لا توجد لهذه القناة قوائم تنتظر الربط اليدوي.",
      "table": {
        "product": "منتج القناة",
        "sku": "SKU",
        "stock": "المخزون",
        "lastSeen": "آخر ظهور"
      },
      "untitled": "قائمة بلا عنوان",
      "noSku": "لا يوجد SKU",
      "neverSeen": "لا يوجد",
      "infiniteStock": "مخزون غير محدود",
      "unknownStock": "المخزون غير معروف",
      "finiteStock": "{{count}} وحدة",
      "locations": "موقع واحد",
      "locations_plural": "{{count}} مواقع",
      "paginationRange": "عرض {{start}}–{{end}} من {{total}}",
      "previous": "السابق",
      "next": "التالي",
      "resolveTitle": "حل القائمة",
      "resolveSubtitle": "SKU القائمة المختارة: {{sku}}",
      "selectListing": "اختر قائمة غير مرتبطة أولاً.",
      "modes": {
        "existing": "ربط بمنتج موجود",
        "create": "إنشاء منتج جديد"
      },
      "searchProducts": "ابحث عن المنتجات أو SKU…",
      "searchingProducts": "جارٍ البحث عن المنتجات…",
      "noProductsYet": "ابحث عن منتج لربط هذه القائمة.",
      "productAliases": "SKU إضافي واحد",
      "productAliases_plural": "{{count}} أكواد SKU إضافية",
      "mapAction": "ربط باسم SKU بديل",
      "mapping": "جارٍ الربط…",
      "successWithAlias": "تمت إضافة الاسم البديل {{sku}} وربط قائمة واحدة.",
      "successWithAlias_plural": "تمت إضافة الاسم البديل {{sku}} وربط {{count}} قوائم.",
      "successExisting": "تم ربط قائمة واحدة باستخدام SKU موجود.",
      "successExisting_plural": "تم ربط {{count}} قوائم باستخدام SKU موجود.",
      "createHelp": "ينشئ منتجاً في تلاق فقط. لن يتم استيراد مخزون القناة.",
      "createFields": {
        "sku": "SKU المنتج",
        "name": "اسم المنتج",
        "price": "السعر",
        "status": "الحالة"
      },
      "createAction": "إنشاء المنتج وربط القائمة",
      "creatingProduct": "جارٍ إنشاء المنتج…",
      "createMissingSku": "لا تحتوي هذه القائمة على SKU. أضف SKU في القناة أولاً، ثم أنشئ منتجاً منها.",
      "createSourceLoading": "جارٍ التحقق من مصدر كتالوج المنتجات قبل إنشاء المنتج…",
      "createSourceFailed": "تعذّر التحقق من مصدر كتالوج المنتجات. لا يزال الربط بمنتج موجود متاحاً، لكن إنشاء المنتجات معطّل حالياً.",
      "createDisabledExternal": "إنشاء المنتجات معطّل لأن مصدر الحقيقة لكتالوج المنتجات خارجي.",
      "createInvalidForm": "أدخل SKU واسم المنتج وسعراً غير سالب لإنشاء المنتج.",
      "createSuccessWithAlias": "تم إنشاء المنتج {{productSku}} وإضافة SKU القناة {{listingSku}} كاسم بديل وربط قائمة واحدة.",
      "createSuccessWithAlias_plural": "تم إنشاء المنتج {{productSku}} وإضافة SKU القناة {{listingSku}} كاسم بديل وربط {{count}} قوائم.",
      "createSuccess": "تم إنشاء المنتج {{productSku}} وربط قائمة واحدة.",
      "createSuccess_plural": "تم إنشاء المنتج {{productSku}} وربط {{count}} قوائم.",
      "errors": {
        "REQUEST_FAILED": "تعذّر تحديث القوائم غير المرتبطة. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لربط القوائم.",
        "CHANNEL_CONNECTION_NOT_FOUND": "لم يتم العثور على ربط القناة هذا.",
        "CHANNEL_LISTING_NOT_FOUND": "لم يتم العثور على هذه القائمة أو المنتج.",
        "CHANNEL_LISTING_ALREADY_MAPPED": "هذه القائمة مرتبطة بالفعل.",
        "CHANNEL_LISTING_SKU_REQUIRED": "لا تحتوي هذه القائمة على SKU صالح، لذلك لا يمكن ربطها باسم بديل.",
        "CHANNEL_LISTING_SKU_CONFLICT": "هذا الـ SKU يخص منتجاً آخر بالفعل. اختر ذلك المنتج أو صحح الـ SKU أولاً.",
        "CHANNEL_LISTING_RESOLVE_FAILED": "تعذّر ربط هذه القائمة. اختر منتجاً وحاول مرة أخرى.",
        "PRODUCT_CATALOG_EXTERNAL_SOURCE": "إنشاء المنتجات معطّل لأن مصدر الحقيقة لكتالوج المنتجات خارجي.",
        "PRODUCT_SKU_CONFLICT": "هذا الـ SKU يخص منتجاً آخر بالفعل. اختر SKU مختلفاً للمنتج أو اربطه بالمنتج الموجود.",
        "PRODUCT_INVALID_STATUS": "اختر حالة منتج صالحة."
      }
    },
    "inventory": {
      "description": "اختر من أين يقرأ تلاق المنتجات ومخزون المستودعات. يمكن إبقاء زوهو متصلاً أو جعل تلاق مصدر المخزون مباشرة.",
      "sourceLabel": "مصدر الحقيقة",
      "sourceDescription": "اختر بشكل منفصل من أين يقرأ تلاق بيانات كتالوج المنتجات والمخزون.",
      "changeSource": "تغيير المصدر",
      "source": {
        "catalog": "كتالوج المنتجات",
        "catalogDescription": "الأسماء والأوصاف والأسعار والتكلفة والصور.",
        "stock": "المخزون",
        "stockDescription": "كميات المستودعات/المواقع والتوفر.",
        "useZoho": "استخدم Zoho",
        "useTlaaq": "استخدم تلاق",
        "saving": "جارٍ الحفظ…",
        "error": "تعذر تحديث المصدر. حاول مرة أخرى."
      },
      "connectedSources": "المصادر المتصلة",
      "zoho": "Zoho Inventory",
      "connected": "متصل",
      "location": "Riyadh · Jeddah · Dammam",
      "stats": {
        "products": "المنتجات",
        "syncRules": "قواعد المزامنة",
        "lastRun": "آخر تشغيل",
        "lastRunValue": "قبل 4 دقائق",
        "notAvailable": "—",
        "productsPending": "ستظهر بعد أول سحب منتجات من زوهو",
        "productsImported": "المنتجات المحلية في هذه المساحة",
        "rulesPending": "واجهات قواعد المزامنة غير منفذة بعد",
        "rulesDeferred": "واجهات قواعد المزامنة مؤجلة لطلب لاحق",
        "lastRunPending": "لا يوجد تشغيل مسجل لزوهو بعد"
      },
      "runStatus": {
        "QUEUED": "في قائمة الانتظار",
        "RUNNING": "قيد التشغيل",
        "RATE_LIMITED": "محدود المعدل",
        "SUCCEEDED": "نجح",
        "SUCCEEDED_WITH_ISSUES": "نجح مع مشكلات",
        "FAILED": "فشل"
      },
      "requestTitle": "تحتاج مصدراً آخر؟",
      "requestBody": "أخبرنا إن كنت تريد ربط NetSuite أو Odoo أو نظام ERP مخصصاً في هذه المساحة.",
      "request": "طلب موصل",
      "viewApiDocs": "عرض وثائق API",
      "tlaaq": "تلاق",
      "tlaaqInventory": "مخزون تلاق",
      "tlaaqInventoryHint": "المخزون المحلي وتوزيعه على القنوات وخصم الطلبات التي ينفذها التاجر.",
      "currentSource": "المصدر الحالي",
      "openTlaaq": "فتح مخزون تلاق ←",
      "loading": "جاري التحميل",
      "pending": "قيد الانتظار",
      "notConnected": "غير متصل",
      "connectZohoHint": "اربط Zoho لسحب المنتجات والمستودعات والمخزون وإرسال الطلبات."
    },
    "tlaaqInventory": {
      "back": "المخزون",
      "title": "مخزون تلاق",
      "description": "تحكم في الكمية المنشورة للقنوات والمستودع الذي تُخصم منه الطلبات المنفذة بواسطة التاجر.",
      "manageWarehouses": "إدارة المستودعات",
      "loading": "جارٍ تحميل إعدادات مخزون تلاق…",
      "loadError": "تعذر تحميل ربط المستودعات. حاول مرة أخرى.",
      "allocation": {
        "title": "توزيع المخزون",
        "body": "يحدد كمية المخزون المتاح التي تُنشر لكل قناة متصلة.",
        "action": "عرض توزيع المخزون"
      },
      "deduction": {
        "title": "خصم الطلبات",
        "body": "يحدد المستودع المحلي الذي يُحجز ويُخصم منه مخزون الطلبات المنفذة بواسطة التاجر.",
        "needsAttention": "{{count}} يحتاج إلى إجراء"
      },
      "mappings": {
        "title": "ربط مستودعات التنفيذ",
        "body": "تتطلب كل قناة مدعومة مستودعاً افتراضياً واحداً، ويمكن لمواقع المزود أن تتجاوزه.",
        "locationCount": "ربط موقع واحد",
        "locationCount_other": "{{count}} عمليات ربط مواقع",
        "defaultOnly": "يستخدم المستودع الافتراضي",
        "default": "المستودع الافتراضي",
        "notConfigured": "المستودع الافتراضي مطلوب",
        "noDeduction": "لن تُخصم الطلبات من المخزون",
        "providerUnknown": "بانتظار إشارة تنفيذ موثوقة من هذا المزود",
        "edit": "تعديل الربط",
        "configure": "تعيين الافتراضي",
        "empty": "اربط قناة مبيعات لإعداد خصم الطلبات."
      },
      "editor": {
        "title": "ربط المستودع",
        "close": "إغلاق الربط",
        "defaultLabel": "مستودع التنفيذ الافتراضي",
        "defaultHelp": "مطلوب، ويُستخدم عندما لا ترسل القناة موقعاً أو لا يوجد ربط خاص للموقع.",
        "chooseWarehouse": "اختر مستودعاً في تلاق",
        "defaultRequired": "اختر مستودعاً افتراضياً قبل بدء خصم الطلبات.",
        "locations": "مواقع المزود المبلّغ عنها",
        "useDefault": "استخدام المستودع الافتراضي",
        "providerFulfilled": "الطلبات التي ينفذها المزود مستثناة. طلبات Amazon AFN وNoon FBN لا تخصم من مخزون تلاق المحلي.",
        "cancel": "إلغاء",
        "save": "حفظ الربط",
        "saving": "جارٍ الحفظ…",
        "saveError": "تعذر حفظ هذا الربط. حاول مرة أخرى."
      }
    },
    "inventoryZoho": {
      "actions": {
        "openZoho": "فتح في زوهو ↗",
        "runAll": "تشغيل كل القواعد",
        "manageConnection": "إدارة الاتصال",
        "newRule": "سياسة الطلبات",
        "viewDetails": "عرض التفاصيل ←",
        "editRule": "تعديل القاعدة",
        "connect": "ربط Zoho",
        "reconnect": "إعادة ربط Zoho",
        "reauthorize": "تجديد تفويض Zoho",
        "connecting": "جاري الربط…",
        "disconnect": "فصل الربط",
        "disconnecting": "جاري الفصل…",
        "pullMissingProducts": "سحب المنتجات والمخزون",
        "pullingProducts": "جاري سحب المنتجات…",
        "startingPull": "جاري بدء السحب…",
        "pullActive": "السحب قيد التشغيل",
        "orderAudit": "تدقيق طلبات زد المتزامنة",
        "setStockSource": "اجعل Zoho مصدر المخزون",
        "settingStockSource": "جاري ضبط المصدر…",
        "editDraft": "تعديل المسودة",
        "activateDraft": "تفعيل المسودة",
        "activating": "جاري التفعيل…",
        "enablePolicy": "تفعيل السياسة",
        "enablingPolicy": "جارٍ التفعيل…",
        "viewPolicy": "عرض السياسة",
        "copyToDraft": "إنشاء نسخة مسودة",
        "copyingPolicy": "جارٍ إنشاء النسخة…",
        "disablePolicy": "تعطيل السياسة",
        "disablingPolicy": "جارٍ التعطيل…",
        "archivePolicy": "حذف السياسة",
        "archivingPolicy": "جارٍ الحذف…"
      },
      "connection": {
        "connected": "متصل",
        "organization": "المؤسسة",
        "connectedBy": "متصل بواسطة لبنى · قبل أسبوعين",
        "loading": "جاري التحميل",
        "notConnected": "غير متصل",
        "connectHint": "اربط Zoho عبر OAuth قبل تشغيل سحب المنتجات أو مزامنة الطلبات.",
        "status": {
          "PENDING": "قيد الانتظار",
          "CONNECTED": "متصل",
          "DISCONNECTED": "غير متصل",
          "AUTH_EXPIRED": "انتهت صلاحية التفويض",
          "ERROR": "خطأ"
        }
      },
      "source": {
        "loading": "جاري فحص مصدر المخزون…",
        "loadingBody": "يتحقق تلاق من مالك المخزون قبل تفعيل استيراد مخزون Zoho.",
        "loadFailed": "تعذّر فحص مصدر المخزون",
        "loadFailedBody": "حدّث الصفحة أو حاول مرة أخرى قبل استيراد مخزون Zoho.",
        "zohoActive": "Zoho هو مصدر المخزون",
        "zohoActiveBody": "يمكن لسحب المخزون استيراد مواقع Zoho والكميات إلى مستودعات تلاق.",
        "tlaaqActive": "تلاق هو مصدر المخزون حالياً",
        "tlaaqActiveBody": "اجعل Zoho مصدر المخزون قبل استيراد لقطات المخزون والمواقع.",
        "externalActive": "يوجد مصدر آخر للمخزون حالياً",
        "externalActiveBody": "التحويل إلى Zoho سيستبدل مصدر المخزون الحالي لعمليات الاستيراد القادمة.",
        "confirmReplace": "يوجد مصدر متصل آخر يملك المخزون حالياً. هل تريد تحويل مصدر المخزون إلى Zoho؟ قد تستبدل عمليات الاستيراد القادمة الكميات المحلية المتعارضة."
      },
      "singleImport": {
        "action": "استيراد صنف واحد",
        "closeAction": "إغلاق استيراد الصنف",
        "title": "استيراد صنف واحد من Zoho",
        "subtitle": "اجلب صنفاً أُنشئ حديثاً باستخدام رمز SKU مطابق أو معرّف صنف Zoho من دون تشغيل سحب كامل للكتالوج.",
        "bounded": "بحث Zoho محدود",
        "lookup": { "sku": "رمز SKU مطابق", "itemId": "معرّف صنف Zoho" },
        "field": {
          "skuLabel": "رمز SKU المطابق",
          "skuPlaceholder": "أدخل رمز SKU كاملاً",
          "skuHelp": "تتم المطابقة مع الرمز كاملاً فقط. عند وجود نتيجة وحيدة يُستخدم طلب قائمة مفلتر وطلب تفاصيل واحد.",
          "itemIdLabel": "معرّف صنف Zoho",
          "itemIdPlaceholder": "أدخل معرّف الصنف في Zoho",
          "itemIdHelp": "الخيار الأوفر لطلبات الواجهة: يحتاج عادةً إلى طلب بحث واحد عن الصنف في Zoho."
        },
        "authority": {
          "loading": "جاري التحقق من صلاحية الكتالوج والمخزون…",
          "loadingBody": "يبقى الاستيراد معطلاً حتى يؤكد تلاق المصدر المالك لكل نطاق.",
          "loadFailed": "تعذّر التحقق من صلاحية الاستيراد",
          "loadFailedBody": "لن تفترض الواجهة أي ملكية. أعد المحاولة قبل استيراد الصنف.",
          "retry": "إعادة فحص الصلاحية",
          "serverRevalidates": "يعيد الخادم التحقق من الصلاحية الحالية مباشرة قبل الاستيراد.",
          "behavior": {
            "productAndStock": { "title": "Zoho يدير تفاصيل المنتج والمخزون", "body": "يمكن إنشاء هذا الصنف أو تحديثه مع صورته وربطه ومستودعاته ولقطة مخزونه." },
            "productOnly": { "title": "Zoho يدير تفاصيل المنتج فقط", "body": "يمكن إنشاء هذا الصنف أو تحديثه مع صورته وربطه، من دون تغيير المخزون أو المستودعات المحلية." },
            "createMissingAndStock": { "title": "إنشاء المنتج الناقص واستيراد مخزون Zoho", "body": "يمكن إنشاء المنتج إن كان مفقوداً. تبقى حقول المنتج الموجودة في تلاق كما هي، مع استيراد الربط ومخزون Zoho." },
            "stockOnly": { "title": "استيراد المخزون لمنتج محلي موجود", "body": "مصدر آخر يدير تفاصيل المنتج. يجب أن يطابق الصنف منتجاً محلياً موجوداً، ولا يتغير سوى ربط Zoho والمخزون." },
            "createMissingOnly": { "title": "إنشاء المنتج الناقص مع الحفاظ على البيانات المحلية", "body": "يمكن إنشاء منتج مفقود، بينما تبقى حقول المنتجات الموجودة والمخزون والمستودعات في تلاق من دون تغيير." },
            "blocked": { "title": "لا يمكن لهذا الاتصال استيراد الصنف", "body": "مصدر آخر يدير تفاصيل المنتج وZoho لا يدير المخزون، لذلك لا يوجد أثر مسموح لهذا الطلب." }
          }
        },
        "cancel": "إلغاء",
        "submit": "استيراد الصنف",
        "submitting": "جاري الاستيراد…",
        "outcomes": {
          "CREATED": "أُنشئ منتج من صنف Zoho",
          "REFRESHED": "تم تحديث المنتج الموجود من Zoho",
          "MATCHED": "تمت مطابقة صنف Zoho مع منتج موجود"
        },
        "resultSummary": "صفوف المخزون المستوردة: {{stock}} · المستودعات المنشأة: {{warehouses}} · الملاحظات: {{issues}}.",
        "errors": {
          "REQUEST_FAILED": "تعذّر استيراد صنف Zoho. حاول مرة أخرى.",
          "INVENTORY_ITEM_LOOKUP_INVALID": "أدخل رمز SKU مطابقاً واحداً أو معرّف صنف Zoho واحداً.",
          "INVENTORY_ITEM_NOT_FOUND": "لم يُعثر على صنف Zoho يطابق هذا المعرّف تماماً.",
          "INVENTORY_ITEM_LOOKUP_AMBIGUOUS": "توجد عدة أصناف في Zoho تحمل رمز SKU نفسه. عالج التكرار في Zoho ثم أعد المحاولة.",
          "INVENTORY_ITEM_IMPORT_NOT_ALLOWED": "صلاحيات الكتالوج والمخزون الحالية لا تسمح لهذا الصنف بتغيير أي بيانات.",
          "INVENTORY_ITEM_LOCAL_PRODUCT_NOT_FOUND": "يسمح هذا الإعداد باستيراد المخزون فقط بعد مطابقة الصنف مع منتج محلي موجود.",
          "INVENTORY_ITEM_MAPPING_CONFLICT": "يتعارض ربط صنف Zoho مع منتج محلي آخر. راجع الربط الحالي قبل إعادة المحاولة.",
          "INVENTORY_ITEM_PRODUCT_CONFLICT": "رمز SKU مستخدم لمنتج أو رمز إضافي آخر في مساحة العمل.",
          "INVENTORY_ITEM_INVALID_PROVIDER_ITEM": "أعاد Zoho صنفاً لا يمكن استيراد معرّفه أو رمز SKU الخاص به بأمان.",
          "INVENTORY_ITEM_IMPORT_FAILED": "أعاد Zoho الصنف، لكن تلاق لم يتمكن من إكمال الاستيراد بأمان.",
          "INVENTORY_CONNECTION_NOT_CONFIGURED": "اتصال Zoho غير مكتمل بعد.",
          "INVENTORY_CONNECTION_NOT_FOUND": "تعذّر العثور على اتصال Zoho هذا.",
          "INVENTORY_ADAPTER_NOT_REGISTERED": "استيراد صنف Zoho غير متاح في هذا التشغيل.",
          "INVENTORY_AUTH_EXPIRED": "انتهت صلاحية تفويض Zoho. أعد الاتصال ثم حاول مرة أخرى.",
          "INVENTORY_RATE_LIMITED": "قيّد Zoho معدل هذا البحث. انتظر قليلاً ثم أعد المحاولة.",
          "INVENTORY_PULL_FAILED": "فشل البحث عن الصنف في Zoho. أعد المحاولة أو راجع سجل طلبات المزوّد."
        }
      },
      "stats": {
        "products": "المنتجات",
        "productsSub": "↑ 4 اليوم",
        "warehouses": "المستودعات",
        "syncRules": "قواعد المزامنة",
        "syncRulesValue": "3 نشطة",
        "syncRulesSub": "0 متوقفة",
        "lastActivity": "آخر نشاط",
        "lastActivitySub": "دفع مخزون · OK",
        "notAvailable": "—",
        "loading": "جاري التحميل",
        "productsPending": "شغّل سحب المنتجات والمخزون لإنشاء منتجات Zoho الناقصة واستيراد مواقع المخزون.",
        "productsImported": "المنتجات المحلية في هذه المساحة",
        "productsPulled": "تم جلب {{fetched}} · تم تحديث {{updated}} موجودة",
        "warehousesPending": "ستظهر بعد استيراد المخزون من مواقع Zoho",
        "warehousesMapped": "مستودعات زوهو المربوطة",
        "syncRulesPending": "واجهات قواعد المزامنة غير منفذة بعد",
        "syncRulesDeferred": "إعداد قواعد المزامنة مؤجل لطلب لاحق",
        "syncRulesLoading": "جاري تحميل سياسات الطلبات",
        "syncRulesConfigured": "{{active}} نشطة · {{draft}} مسودة · {{disabled}} معطلة",
        "lastActivityPending": "لا يوجد نشاط مسجل لزوهو بعد"
      },
      "pull": {
        "successTitle": "اكتمل السحب",
        "summary": "تم جلب {{fetched}} منتجاً من Zoho. أُنشئ {{created}}، وحُدّث {{updated}}، وتُخطي {{skipped}}.",
        "issues": "توجد {{count}} مشكلة تحتاج مراجعة.",
        "issues_plural": "توجد {{count}} مشكلات تحتاج مراجعة.",
        "nextCursor": "أعاد Zoho صفحة أخرى. شغّل السحب مرة أخرى للمتابعة من المؤشر التالي.",
        "progressTitle": "تقدم سحب المنتجات",
        "progressDeterminate": "تم جلب {{fetched}} من {{total}} عنصر عبر {{pages}} صفحات.",
        "progressIndeterminate": "تم جلب {{fetched}} عنصر عبر {{pages}} صفحات.",
        "rateLimited": "قيّد Zoho معدل سحب العناصر. سيعيد تلاق المحاولة تلقائياً.",
        "rateLimitedWithTime": "قيّد Zoho معدل سحب العناصر. سيعيد تلاق المحاولة قرابة {{retryAt}}.",
        "failed": "فشل سحب المنتجات بالرمز {{code}}.",
        "unknownError": "UNKNOWN_ERROR",
        "finalCounters": "تم جلب {{fetched}}. أُنشئ {{created}}، وحُدّث {{updated}}، وتُخطي {{skipped}}. المشكلات: {{issues}}.",
        "status": {
          "QUEUED": "في قائمة الانتظار",
          "RUNNING": "قيد التشغيل",
          "RATE_LIMITED": "محدود المعدل",
          "SUCCEEDED": "نجح",
          "SUCCEEDED_WITH_ISSUES": "نجح مع مشكلات",
          "FAILED": "فشل"
        },
        "viewDetails": "عرض تفاصيل السحب"
      },
      "rules": {
        "title": "قواعد المزامنة",
        "subtitle": "أنشئ وفعّل السياسة المستخدمة عندما يرسل تلاق طلبات القنوات إلى زوهو.",
        "trigger": "المشغّل",
        "entity": "الكيان",
        "lastRun": "آخر تشغيل",
        "ok": "سليم",
        "issues": "مشكلات",
        "pullProducts": {
          "name": "سحب بيانات المنتجات الأساسية من زوهو"
        },
        "pushStock": {
          "name": "دفع تغييرات المخزون إلى زوهو"
        },
        "pushOrders": {
          "name": "دفع الطلبات المدفوعة إلى زوهو كأوامر بيع",
          "error": "طلب واحد بلا رمز ضريبي"
        },
        "emptyTitle": "لا توجد قواعد مزامنة بعد",
        "emptyBody": "استخدم منشئ سياسة الطلبات لإنشاء القيم الافتراضية وربط الدفع أو الشحن لطلبات زوهو.",
        "connectFirstBody": "اربط Zoho قبل إنشاء سياسة الطلبات المستخدمة لأوامر البيع والفواتير.",
        "loading": "جاري تحميل سياسات الطلبات…",
        "version": "الإصدار {{version}}",
        "noDefaults": "لا توجد قيم Zoho افتراضية محددة",
        "invoiceSource": "مصدر الفاتورة: {{source}}",
        "copyName": "نسخة من {{name}}",
        "confirmDisableActive": "تعطيل السياسة النشطة \"{{name}}\"؟ ستستخدم مزامنة طلبات Zoho الحمولة الافتراضية إلى أن يتم تفعيل سياسة أخرى.",
        "autoSend": {
          "title": "الإرسال التلقائي للطلبات إلى Zoho",
          "enabled": "الإرسال التلقائي مفعّل",
          "disabled": "الإرسال التلقائي متوقف",
          "toggleLabel": "تبديل الإرسال التلقائي لـ {{name}}",
          "help": "ينطبق فقط على الطلبات المستوردة أو المحدّثة مستقبلاً. يبقى زر الإرسال اليدوي إلى Zoho متاحاً عند إيقاف الإرسال التلقائي.",
          "activeOnlyHelp": "فعّل هذه السياسة قبل تفعيل الإرسال التلقائي. الإرسال اليدوي إلى Zoho منفصل عن هذه الأتمتة.",
          "saving": "جارٍ تحديث الإرسال التلقائي…"
        },
        "confirmArchiveDraft": "حذف مسودة السياسة \"{{name}}\"؟ لن تظهر هذه المسودة بعد الآن.",
        "confirmArchiveDisabled": "حذف السياسة المعطلة \"{{name}}\"؟ لن تكون متاحة للتفعيل لاحقاً."
      },
      "cadence": {
        "realtime": "فوري",
        "every15": "كل 15 دقيقة",
        "hourly": "كل ساعة",
        "daily0200": "يومياً 02:00 بتوقيت السعودية",
        "paymentCaptured": "عند تأكيد الدفع"
      },
      "entities": {
        "products": "المنتجات",
        "stock": "المخزون",
        "orders": "أوامر البيع"
      },
      "scopes": {
        "allWarehouses": "كل المستودعات",
        "riyadhJeddahDammam": "الرياض · جدة · الدمام",
        "exceptTrendyol": "كل القنوات ما عدا Trendyol"
      },
      "times": {
        "thirtyTwoSecondsAgo": "قبل 32 ثانية",
        "eightMinutesAgo": "قبل 8 دقائق",
        "twelveMinutesAgo": "قبل 12 دقيقة",
        "oneHourAgo": "قبل ساعة",
        "twoHoursAgo": "قبل ساعتين"
      },
      "locations": {
        "riyadh": "الرياض",
        "jeddah": "جدة",
        "dammam": "الدمام"
      },
      "activity": {
        "title": "النشاط الأخير",
        "headers": {
          "time": "الوقت",
          "rule": "القاعدة",
          "direction": "الاتجاه",
          "entity": "الكيان",
          "result": "النتيجة"
        },
        "results": {
          "fourItems": "تم دفع 4 عناصر",
          "twentyFourProducts": "تم تحديث 24 منتجاً",
          "missingTaxCode": "تم دفع 9 من 10 · طلب واحد بلا رمز ضريبي",
          "elevenItems": "تم دفع 11 عنصراً",
          "thirtyOneProducts": "تم تحديث 31 منتجاً"
        },
        "emptyTitle": "لا يوجد نشاط زوهو بعد",
        "emptyBody": "سجل استدعاءات المزود ومزامنة الطلبات محفوظان في الخلفية، لكن موجز النشاط المختصر غير مربوط بواجهة API بعد."
      },
      "drawer": {
        "untitledRule": "قاعدة بلا اسم",
        "newSyncRule": "قاعدة مزامنة جديدة",
        "editSyncRule": "تعديل قاعدة المزامنة",
        "setupStream": "إعداد مسار بيانات جديد",
        "close": "إغلاق محرر قاعدة المزامنة",
        "rulePreview": "معاينة القاعدة",
        "previewSentence": "{{cadence}}، {{action}} {{entity}} {{preposition}} Zoho Inventory.",
        "send": "إرسال",
        "pull": "سحب",
        "to": "إلى",
        "from": "من",
        "nameStatus": "الاسم والحالة",
        "ruleName": "اسم القاعدة",
        "enabled": "مفعلة",
        "enabledHint": "عند إيقافها لن تعمل القاعدة، لكن السجل يبقى محفوظاً.",
        "direction": "الاتجاه",
        "pullFromZoho": "سحب من زوهو",
        "pullFromZohoDesc": "زوهو هو المصدر الرئيسي. التحديثات تدخل إلى تلاق.",
        "pushToZoho": "دفع إلى زوهو",
        "pushToZohoDesc": "تلاق هو المصدر الرئيسي. التحديثات تخرج إلى زوهو.",
        "whatToSync": "ما الذي تتم مزامنته",
        "productsDesc": "رموز SKU والأسماء والأسعار والأوصاف.",
        "stockDesc": "الكميات لكل مستودع.",
        "ordersDesc": "تُدفع عند تأكيد الدفع.",
        "when": "التوقيت",
        "realtimeDesc": "تعمل عند كل تغيير.",
        "every15Desc": "أفضل لبيانات المنتجات الأساسية.",
        "hourlyDesc": "للمطابقة الخلفية.",
        "dailyDesc": "دفعة في ساعات الهدوء.",
        "scope": "النطاق",
        "scopeHint": "حدد المستودعات أو القنوات التي تنطبق عليها القاعدة.",
        "warehouses": "المستودعات",
        "allWarehouses": "كل المستودعات",
        "channels": "القنوات",
        "allChannels": "كل القنوات",
        "fieldMapping": "ربط الحقول",
        "deleteRule": "حذف القاعدة",
        "cancel": "إلغاء",
        "createRule": "إنشاء القاعدة",
        "saveChanges": "حفظ التغييرات"
      },
      "fieldMapping": {
        "tlaaqField": "حقل تلاق",
        "zohoField": "حقل زوهو",
        "sku": "SKU",
        "name": "الاسم",
        "price": "السعر (ر.س)",
        "quantity": "الكمية",
        "tax": "الضريبة",
        "noMapping": "لا يوجد ربط بعد"
      },
      "title": "Zoho Inventory",
      "errors": {
        "codes": {
          "REQUEST_FAILED": "فشل الطلب. حاول مرة أخرى.",
          "INVENTORY_CONNECTION_EXISTS": "يوجد ربط Zoho لهذه المساحة بالفعل.",
          "INVENTORY_CONNECT_FAILED": "تعذر بدء ربط Zoho. تحقق من إعدادات عميل Zoho.",
          "INVENTORY_ADAPTER_NOT_REGISTERED": "محول Zoho غير متاح في هذا النشر.",
          "INVENTORY_PRODUCT_PULL_SOURCE_MISMATCH": "نمط السحب هذا سيستبدل بيانات الكتالوج المحلية. استخدم سحب المنتجات الناقصة عندما تبقى تلاق هي المصدر، أو انقل مصدر الكتالوج إلى Zoho أولاً.",
          "INVENTORY_STOCK_PULL_SOURCE_MISMATCH": "يجب أن يكون Zoho مصدر المخزون قبل استيراد لقطات المخزون.",
          "INVENTORY_NOT_CONFIGURED": "لم يتم ربط Zoho بعد.",
          "INVENTORY_PULL_FAILED": "فشل سحب عناصر Zoho. حاول مرة أخرى أو راجع سجل استدعاءات المزود.",
          "INVENTORY_RATE_LIMITED": "قيّد Zoho معدل سحب العناصر. سيعيد تلاق المحاولة تلقائياً في التشغيلات غير المتزامنة.",
          "INVENTORY_SOURCE_AUTHORITY_ACTIVE": "انقل ملكية مصدر المنتجات والمخزون من Zoho قبل فصله.",
          "SOURCE_AUTHORITY_CONFLICT": "يوجد مصدر آخر مفعّل. أكد التغيير وحاول مرة أخرى.",
          "SOURCE_AUTHORITY_INVALID_DOMAIN": "اختر نطاق مصدر صالحاً.",
          "SOURCE_AUTHORITY_INVALID_OWNER": "اختر مالك مصدر صالحاً.",
          "SOURCE_AUTHORITY_INVENTORY_CONNECTION_NOT_FOUND": "تعذّر العثور على ربط المخزون.",
          "SOURCE_AUTHORITY_INVENTORY_NOT_CONNECTED": "اربط Zoho قبل جعله مصدر المخزون.",
          "ZOHO_ORDER_POLICY_INVALID": "راجع حقول السياسة وحاول مرة أخرى."
        }
      }
    },
    "inventoryZohoOrderAudit": {
      "back": "العودة إلى مخزون زوهو",
      "title": "تدقيق طلبات زوهو",
      "subtitle": "مقارنة للقراءة فقط بين طلبات زد المتزامنة حديثاً وحمولة أوامر البيع والفواتير المتوقعة حالياً في زوهو. لا يتم إنشاء أو حذف أو إصلاح أي مستندات زوهو من هذه الصفحة.",
      "readOnly": "تدقيق للقراءة فقط",
      "loading": "جارٍ تحميل التدقيق…",
      "loadingShort": "…",
      "notAvailable": "—",
      "yes": "نعم",
      "no": "لا",
      "orderNumber": "الطلب #{{id}}",
      "orderId": "طلب تلاق #{{id}}",
      "policyVersion": "السياسة #{{id}} · الإصدار {{version}}",
      "filters": {
        "days": "الفترة",
        "daysOption": "آخر {{count}} أيام",
        "limit": "الحد",
        "limitOption": "{{count}} طلباً"
      },
      "summary": {
        "scanned": "تم الفحص",
        "since": "منذ {{since}}"
      },
      "results": {
        "title": "نتائج التدقيق",
        "subtitle": "تم الإنشاء {{generatedAt}}"
      },
      "empty": {
        "title": "لا توجد طلبات مرشحة",
        "body": "لم تطابق أي طلبات زد متزامنة حديثاً فترة التدقيق وقواعد الترشيح المرتبطة بالشحن."
      },
      "missing": {
        "title": "اختر ربط زوهو أولاً",
        "body": "افتح مخزون زوهو واختر إجراء التدقيق من إعداد زوهو المتصل."
      },
      "fields": {
        "salesOrder": "أمر البيع",
        "invoice": "الفاتورة",
        "syncedAt": "وقت المزامنة",
        "policy": "السياسة"
      },
      "documents": {
        "expected": "متوقع",
        "found": "موجود",
        "remoteStatus": "حالة المستند"
      },
      "documentTypes": {
        "SALES_ORDER": "أمر بيع",
        "INVOICE": "فاتورة"
      },
      "differences": {
        "title": "فروقات على مستوى الطلب",
        "expected": "المتوقع",
        "actual": "الفعلي",
        "delta": "الفرق",
        "none": "لا توجد فروقات مسجلة لهذا المستند."
      },
      "classifications": {
        "OK": "سليم",
        "MISSING_SHIPPING_SERVICE_LINE": "سطر الشحن مفقود",
        "WRONG_SHIPPING_SERVICE_AMOUNT": "مبلغ الشحن غير صحيح",
        "WRONG_ENTITY_DISCOUNT": "خصم الكيان غير صحيح",
        "TOTAL_MISMATCH": "الإجمالي غير مطابق",
        "ZOHO_DOCUMENT_NOT_FOUND": "مستند زوهو غير موجود",
        "UNSAFE_MANUAL_DIFFERENCE": "تحتاج مراجعة يدوية"
      },
      "errors": {
        "REQUEST_FAILED": "تعذّر تحميل تدقيق الطلبات. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لعرض التدقيق.",
        "INVENTORY_CONNECTION_NOT_FOUND": "لم يتم العثور على ربط زوهو هذا.",
        "INVENTORY_NOT_CONFIGURED": "لم يتم ربط زوهو بعد.",
        "INVENTORY_ADAPTER_NOT_REGISTERED": "محول زوهو غير متاح في هذا النشر.",
        "ZOHO_ORDER_AUDIT_FAILED": "فشل تدقيق طلبات زوهو. حاول مرة أخرى أو قلّل الفترة."
      },
      "actions": {
        "fetchLatest": "جلب الأحدث",
        "fetchNextPage": "جلب الصفحة التالية"
      },
      "notRun": {
        "title": "لم يتم تشغيل التدقيق بعد",
        "body": "اختر الفترة والحد ثم اجلب أحدث مقارنة من زوهو."
      }
    },
    "orders": {
      "searchLabel": "البحث في الطلبات",
      "searchPlaceholder": "ابحث في الطلبات أو العملاء أو الهاتف…",
      "currencyFallback": "ر.س",
      "summaryLoading": "جاري تحميل الملخص…",
      "summaryTotal": "{{count}} طلب إجمالاً",
      "loading": "جاري تحميل الطلبات…",
      "emptyFiltered": "لا توجد طلبات تطابق البحث أو الفلتر.",
      "filters": {
        "dateFrom": "تاريخ الطلب من",
        "dateTo": "تاريخ الطلب إلى",
        "status": "الحالة",
        "channel": "القناة",
        "zoho": "حالة زوهو",
        "allChannels": "كل القنوات",
        "allStatuses": "كل الحالات",
        "last7Days": "آخر 7 أيام",
        "zohoAny": "زوهو: الكل"
      },
      "actions": {
        "refresh": "تحديث القائمة",
        "refreshing": "جاري التحديث…",
        "export": "تصدير الطلبات بصيغة XLSX",
        "exporting": "جارٍ تصدير الطلبات…",
        "openDetail": "فتح الطلب {{order}}",
        "closeDetail": "إغلاق التفاصيل",
        "refreshFromChannel": "تحديث من القناة",
        "refreshingFromChannel": "جارٍ التحديث من القناة…",
        "previewZoho": "معاينة حمولة زوهو",
        "openOrderRouting": "استخدام الطلب في التوجيه",
        "previewingZoho": "جاري المعاينة…",
        "sendToZoho": "إرسال إلى زوهو",
        "sendingZoho": "جارٍ الإرسال…",
        "resetZohoInvoice": "إعادة ضبط مزامنة الفاتورة",
        "resettingZohoInvoice": "جارٍ إعادة الضبط…",
        "resetZohoInvoiceConfirm": "سيؤدي هذا إلى إعادة ضبط حالة مزامنة الفاتورة محلياً في تلاق فقط. احذف أو ألغِ الفاتورة الخاطئة في زوهو أولاً إذا لزم الأمر. هل تريد المتابعة؟",
        "resetZohoSync": "إعادة ضبط مزامنة زوهو",
        "resettingZohoSync": "جارٍ إعادة الضبط…",
        "resetZohoSyncConfirm": "لا تتابع إلا بعد حذف أمر البيع والفاتورة أو الإشعار الدائن المرتبط به من زوهو. سينسى تلاق جميع معرّفات مستندات زوهو المرتبطة ويسمح بإرسال الطلب من جديد. قد يؤدي الاستمرار مع بقاء هذه المستندات في زوهو إلى إنشاء نسخ مكررة. هل تريد المتابعة؟",
        "sendZoho": {
          "NONE": "لا يوجد إجراء زوهو",
          "CREATE_SALES_ORDER": "إنشاء أمر بيع",
          "CONFIRM_SALES_ORDER": "تأكيد أمر البيع",
          "CREATE_INVOICE": "إنشاء فاتورة",
          "VOID_SALES_ORDER": "إلغاء أمر البيع",
          "CREATE_CREDIT_NOTE": "إنشاء إشعار دائن",
          "RETRY": "إعادة الإرسال إلى زوهو"
        }
      },
      "pullNew": "سحب الجديد",
      "pending": "قيد الانتظار",
      "table": {
        "order": "الطلب",
        "channel": "القناة",
        "date": "التاريخ",
        "status": "الحالة",
        "payment": "الدفع",
        "customer": "العميل",
        "total": "الإجمالي",
        "zoho": "زوهو",
        "carrier": "شركة الشحن"
      },
      "status": {
        "NEW": "جديد",
        "IN_PROGRESS": "قيد التنفيذ",
        "COMPLETED": "مكتمل",
        "CANCELLED": "ملغي",
        "UNKNOWN": "غير معروف",
        "new": "جديد",
        "processing": "قيد المعالجة",
        "ready": "جاهز",
        "shipped": "تم الشحن",
        "cancelled": "ملغي"
      },
      "zoho": {
        "NOT_CONFIGURED": "غير مضبوط",
        "READY": "جاهز",
        "SALES_ORDER_CREATED": "تم إنشاء أمر البيع",
        "SALES_ORDER_CONFIRMED": "تم تأكيد أمر البيع",
        "INVOICE_CREATED": "تم إنشاء الفاتورة",
        "SALES_ORDER_VOIDED": "تم إلغاء أمر البيع",
        "CREDIT_NOTE_APPLIED": "تم تطبيق الإشعار الدائن",
        "FAILED": "فشل",
        "handoffHelp": "يتبع الإرسال إلى زوهو إجراء السياسة النشطة المطابق لحالة هذا الطلب في القناة.",
        "reconnectHelp": "Zoho Inventory غير متصل. سجلات المزامنة السابقة متاحة للقراءة فقط. أعد ربط زوهو من صفحة المخزون لاستئناف إرسال الطلبات.",
        "notConfiguredHelp": "إرسال الطلبات إلى زوهو غير مضبوط بعد. هذا الإجراء معطل حتى تتوفر الميزة.",
        "nextActions": {
          "NONE": "لا يوجد إجراء زوهو",
          "CREATE_SALES_ORDER": "إنشاء أمر بيع",
          "CONFIRM_SALES_ORDER": "تأكيد أمر البيع",
          "CREATE_INVOICE": "إنشاء فاتورة",
          "VOID_SALES_ORDER": "إلغاء أمر البيع",
          "CREATE_CREDIT_NOTE": "إنشاء إشعار دائن",
          "RETRY": "إعادة الإرسال إلى زوهو"
        },
        "reasons": {
          "NONE": "جاهز",
          "ZOHO_INTEGRATION_NOT_AVAILABLE": "Zoho Inventory غير متصل.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "لا توجد سياسة طلبات زوهو نشطة تطابق هذه القناة.",
          "ZOHO_ORDER_POLICY_NO_ACTION_MAPPING": "لا تحتوي السياسة النشطة على ربط إجراء لهذه الحالة.",
          "ZOHO_ORDER_POLICY_INVALID": "تحتوي سياسة طلبات زوهو النشطة على مشاكل مانعة.",
          "ZOHO_ORDER_POLICY_CHANNEL_NOT_SCOPED": "هذه القناة غير مشمولة في السياسة النشطة.",
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "إحدى مراجع سياسة زوهو قديمة أو غير نشطة.",
          "ZOHO_SALES_ORDER_ID_REQUIRED_FOR_VOID": "يتطلب الإلغاء معرّف أمر بيع موجوداً في زوهو.",
          "ZOHO_INVOICE_ID_REQUIRED_FOR_CREDIT_NOTE": "يتطلب إنشاء إشعار دائن معرّف فاتورة زوهو موجوداً.",
          "ZOHO_CREDIT_NOTE_SOURCE_INVALID": "لا يمكن استخدام فاتورة زوهو هذه لإنشاء إشعار دائن.",
          "ZOHO_CREDIT_NOTE_ID_MISSING": "لم يُرجع زوهو معرّف الإشعار الدائن.",
          "ZOHO_INVOICE_ALREADY_CREATED": "لهذا الطلب فاتورة زوهو بالفعل.",
          "ZOHO_ORDER_ALREADY_INVOICED": "لهذا الطلب فاتورة زوهو بالفعل ولا يمكن إلغاؤه.",
          "ZOHO_ORDER_ALREADY_VOIDED": "أمر البيع في زوهو ملغى بالفعل."
        }
      },
      "zohoPreview": {
        "policyId": "معرّف السياسة",
        "policySource": "مصدر السياسة",
        "policyVersion": "إصدار السياسة",
        "action": "الإجراء المخطط",
        "actionMappingId": "معرّف ربط الإجراء",
        "paymentMappingId": "معرّف ربط الدفع",
        "shippingMappingId": "معرّف ربط الشحن",
        "warehouseOverrideRuleId": "معرّف استبدال المستودع",
        "warnings": "تحذيرات",
        "blockingErrors": "أخطاء مانعة",
        "noWarnings": "لا توجد تحذيرات لهذه الحمولة.",
        "noBlockingErrors": "لا توجد أخطاء مانعة لهذه الحمولة.",
        "field": "الحقل",
        "externalId": "المعرّف الخارجي",
        "salesOrderPayload": "حمولة أمر البيع",
        "invoicePayload": "حمولة الفاتورة",
        "sources": {
          "ACTIVE_POLICY": "السياسة النشطة",
          "IMPLICIT_DEFAULT": "الإعداد الافتراضي الضمني"
        },
        "codes": {
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "مرجع في سياسة زوهو قديم أو غير نشط.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "لا توجد سياسة طلبات زوهو نشطة تطابق هذه القناة.",
          "ZOHO_ORDER_POLICY_NO_ACTION_MAPPING": "لا تحتوي السياسة النشطة على ربط إجراء لهذه الحالة.",
          "ZOHO_ORDER_POLICY_INVALID": "راجع سياسة طلبات زوهو النشطة ثم حاول مرة أخرى.",
          "ZOHO_ORDER_POLICY_CHANNEL_NOT_SCOPED": "هذه القناة غير مشمولة في السياسة النشطة.",
          "ZOHO_SALES_ORDER_ID_PENDING": "ستتضمن حمولة الفاتورة معرّف أمر البيع من زوهو بعد إنشاء أمر البيع.",
          "ZOHO_ORDER_POLICY_VOID_ORDER_UNSUPPORTED": "لا يمكن إكمال إجراء الإلغاء لهذا الطلب."
        }
      },
      "detail": {
        "title": "تفاصيل الطلب",
        "back": "العودة إلى الطلبات",
        "tabs": { "overview": "نظرة عامة", "noon": "تنفيذ نون", "zoho": "الإرسال إلى زوهو", "activity": "النشاط" },
        "loading": "جاري تحميل تفاصيل الطلب…",
        "externalId": "المعرّف الخارجي",
        "lastUpdated": "آخر تحديث",
        "customer": "العميل",
        "email": "البريد الإلكتروني",
        "phone": "الهاتف",
        "placedAt": "وقت الطلب",
        "payment": "الدفع",
        "paymentStatus": "حالة الدفع",
        "paymentMethod": "طريقة الدفع",
        "paymentType": "نوع الدفع",
        "paymentTransactionStatus": "حالة العملية",
        "delivery": "التوصيل",
        "shippingCompany": "شركة الشحن",
        "shippingMethod": "طريقة الشحن",
        "fulfillmentChannel": "قناة التنفيذ",
        "fulfillmentStatus": "حالة التنفيذ",
        "deliveryAddress": "عنوان التوصيل",
        "totals": "الإجماليات",
        "subtotal": "المجموع الفرعي",
        "tax": "الضريبة",
        "shipping": "الشحن",
        "discount": "الخصم",
        "total": "الإجمالي",
        "invoiceBreakdown": "تفصيل الفاتورة",
        "invoiceDescription": "الوصف",
        "invoiceCode": "الرمز",
        "invoiceAmount": "المبلغ",
        "noInvoiceBreakdown": "لا يوجد تفصيل فاتورة محفوظ لهذا الطلب بعد.",
        "items": "المنتجات",
        "lineItems": "بنود الطلب",
        "itemsSummary": "{{lines}} بنود · {{units}} وحدات",
        "pricesIn": "الأسعار بـ {{currency}}",
        "item": "البند",
        "sku": "SKU",
        "quantity": "الكمية",
        "unitPrice": "سعر الوحدة",
        "lineTotal": "إجمالي البند",
        "lineReference": "مرجع البند",
        "noLineItems": "لا توجد بنود مخزنة لهذا الطلب بعد.",
        "channelSku": "SKU الشريك في القناة",
        "channelItem": "عنصر القناة",
        "localSku": "SKU المنتج في تلاق",
        "zohoItem": "عنصر زوهو",
        "openProduct": "فتح المنتج {{name}}",
        "unmappedHelp": "لا يوجد منتج محلي مرتبط. اربط قائمة القناة أو أنشئ منتجاً مطابقاً.",
        "mapping": { "LISTING_MATCH": "مرتبط بالقائمة", "SKU_MATCH": "مطابق عبر SKU", "UNMAPPED": "المنتج غير مرتبط", "localProduct": "المنتج غير مرتبط", "zohoItem": "عنصر زوهو غير مرتبط" },
        "mappingHelp": { "localProduct": "لا يوجد منتج محلي مرتبط. اربط قائمة القناة أو أنشئ منتجاً مطابقاً.", "zohoItem": "هذا المنتج غير مرتبط بعنصر في زوهو. افتح ربط المنتج لإصلاحه." },
        "mappingError": {
          "title": "ربط عنصر زوهو مطلوب",
          "body": "لا توجد روابط لعناصر زوهو لرموز المنتجات التالية: {{skus}}. لذلك لم يرسل تلاق هذا الطلب إلى زوهو. أصلح الربط قبل الإرسال مجدداً.",
          "nextAction": "إصلاح ربط المنتج",
          "cardHelp": "لا يمكن إرسال هذا الطلب حتى يتم ربط كل منتج بعنصر في زوهو.",
          "viewSku": "عرض رمز المنتج المفقود",
          "openMapping": "فتح ربط المنتج"
        },
        "zohoAction": "إرسال إلى زوهو",
        "zohoDetails": "تفاصيل زوهو",
        "zohoStatus": "حالة زوهو",
        "zohoNextAction": "الإجراء التالي",
        "zohoReason": "السبب",
        "zohoLastError": "آخر خطأ من زوهو",
        "zohoPolicyAction": "إجراء السياسة",
        "zohoSalesOrderId": "معرّف أمر البيع",
        "zohoInvoiceId": "معرّف الفاتورة",
        "zohoCreditNoteId": "معرّف الإشعار الدائن",
        "zohoSyncedAt": "وقت المزامنة",
        "invoiceReportedBy": "تفصيل الفاتورة · كما ورد من {{provider}}",
        "invoiceRows": "تفصيل الفاتورة من {{provider}} · {{count}} صفوف",
        "recentActivity": "النشاط الأخير",
        "viewAllActivity": "عرض الكل ({{count}})",
        "providerCalls": "سجل نداءات المزوّد",
        "noProviderCalls": "لا يوجد سجل نداءات مزوّد مرتبط بهذا الطلب بعد.",
        "provider": "المزوّد",
        "method": "الطريقة",
        "endpoint": "المسار",
        "result": "النتيجة"
      },
      "noon": {
        "title": "عمليات طلب نون", "help": "راجع التوفر واربط كيساً مطبوعاً مسبقاً ثم أنشئ الشحنة بشكل صريح.", "loading": "جارٍ تحميل عمليات نون…", "retry": "إعادة المحاولة", "unsupported": "تنفيذ نون غير مدعوم لهذا الطلب.",
        "reviewTitle": "تأكيد توفر المنتجات", "reviewHelp": "تحقق من أحدث مخزون المستودعات ثم حدّد بوضوح توفر كل منتج.", "available": "متوفر", "outOfStock": "غير متوفر", "saveReview": "حفظ التوفر", "quantity": "الكمية {{count}}", "localSku": "رمز المنتج", "noonItem": "منتج نون",
        "stockTitle": "مخزون المستودعات", "stockScope": "نطاق مخزون المستودعات", "mappedWarehouse": "مستودع نون", "allWarehouses": "كل المستودعات", "stockSource": "المصدر: {{source}}", "stockUpdated": "آخر تحديث {{date}}", "stockSourceZoho": "زوهو", "stockSourceTlaaq": "تلاق", "availableUnits": "متاح", "noMappedWarehouse": "لا يوجد مستودع محلي مرتبط بقناة نون هذه.", "stockGuidance": "المخزون للمساعدة فقط، والقرار النهائي لتوفر المنتج في هذا الطلب يعود إليك.",
        "fulfillmentSummary": "ملخص التنفيذ", "noonWarehouse": "مستودع نون", "mappedTlaaqWarehouse": "مستودع تلاق المرتبط", "notMapped": "غير مرتبط", "items": "المنتجات", "itemsSummary": "{{lines}} أسطر · {{units}} وحدات", "summaryHelp": "أرصدة المستودعات موحّدة في تلاق. مصدر المخزون الحالي: {{source}}.",
        "bagTitle": "ربط الكيس المطبوع مسبقاً", "bagHelp": "امسح رمز QR بقارئ الكاميرا المتصل أو أدخل رقم AWB يدوياً. حفظ المسودة لا ينشئ شحنة.", "bagCode": "رمز الكيس / AWB", "bagPlaceholder": "امسح أو أدخل رمز الكيس", "saveBag": "حفظ مسودة الكيس",
        "draftTitle": "مسودة الشحنة", "draftNote": "تم حفظ المسودة ولم تُنشأ الشحنة بعد.", "ambiguousNote": "أعادت نون نتيجة غير مؤكدة. طابق النتيجة باستخدام رقم AWB ورقم الشحنة نفسيهما ولا تمسح كيساً آخر.", "successNote": "تم إنشاء الشحنة. أظهرها في Seller Lab؛ لا حاجة إلى طباعة ملصق.", "shipment": "رقم الشحنة", "create": "إنشاء الشحنة", "reconcile": "مطابقة النتيجة", "cancel": "إلغاء العملية",
        "confirmCreateTitle": "إنشاء شحنة نون؟", "confirmCreateBody": "سينشئ هذا الإجراء النهائي الشحنة باستخدام الكيس المحفوظ.", "confirmCreate": "إنشاء الشحنة", "confirmCancelTitle": "إلغاء عملية نون؟", "confirmCancelBody": "سيتم إلغاء عملية التنفيذ المحفوظة.", "confirmCancel": "إلغاء العملية", "keepEditing": "رجوع",
        "states": { "REVIEW": "مراجعة التوفر", "BAG_REQUIRED": "الكيس مطلوب", "DRAFT": "تم حفظ المسودة", "CREATED": "تم الإنشاء", "SUCCESS": "تم الإنشاء", "MANIFESTED": "تم الإظهار", "AMBIGUOUS": "المطابقة مطلوبة", "RECONCILIATION_REQUIRED": "المطابقة مطلوبة", "CANCELLED": "ملغاة" },
        "errors": { "REQUEST_FAILED": "فشلت عملية نون. حاول مرة أخرى.", "NOON_FBPI_BAG_CODE_INVALID": "رمز الكيس أو AWB غير صالح.", "NOON_FBPI_AWB_DUPLICATE": "رقم AWB مرتبط بشحنة أخرى." }
      },
      "history": {
        "title": "سجل الطلب",
        "empty": "لا يوجد سجل حالة محفوظ لهذا الطلب بعد.",
        "orderReceived": "تم استلام الطلب من {{provider}}",
        "statusReported": "أبلغ {{provider}} عن الحالة: {{status}}",
        "paymentReported": "أبلغ {{provider}} عن الدفع: {{status}}",
        "orderUpdated": "أبلغ {{provider}} عن تحديث للطلب"
      },
      "empty": {
        "title": "لا توجد طلبات بعد",
        "body": "ستظهر طلبات القنوات المرتبطة هنا بعد سحبها أو استقبالها عبر الويب هوك."
      },
      "pagination": "عرض {{from}}–{{to}} من {{total}} طلب",
      "paginationPrev": "السابق",
      "paginationNext": "التالي",
      "export": {
        "errors": {
          "codes": {
            "REQUEST_FAILED": "تعذّر تصدير الطلبات. حاول مرة أخرى.",
            "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى قبل تصدير الطلبات.",
            "ORDER_INVALID_STATUS": "اختر حالة طلب صحيحة قبل التصدير.",
            "ORDER_INVALID_PROVIDER": "اختر مزوّد طلبات صحيحاً قبل التصدير.",
            "ORDER_INVALID_ZOHO_SYNC_STATUS": "اختر حالة زوهو صحيحة قبل التصدير.",
            "ORDER_EXPORT_TOO_LARGE": "حجم التصدير كبير جداً. ضيّق نطاق الفلاتر ليشمل 5,000 طلب أو 25,000 بند طلب كحد أقصى."
          }
        }
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "تعذر تحميل الطلبات. حاول مرة أخرى.",
          "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة.",
          "ORDER_NOT_FOUND": "لم يتم العثور على الطلب.",
          "ORDER_INVALID_STATUS": "اختر حالة طلب صحيحة.",
          "ORDER_INVALID_PROVIDER": "اختر مزوّد طلبات صحيحاً.",
          "ORDER_INVALID_ZOHO_SYNC_STATUS": "اختر حالة زوهو صحيحة.",
          "ORDER_REFRESH_UNAVAILABLE": "لا يمكن تحديث هذا الطلب لأن ربط القناة غير متصل.",
          "ORDER_REFRESH_FAILED": "تعذّر تحديث هذا الطلب من قناته. حاول مرة أخرى.",
          "CHANNEL_AUTH_EXPIRED": "انتهى تفويض القناة. أعد ربط القناة ثم حاول مرة أخرى.",
          "ZOHO_ORDER_PRE_SEND_REFRESH_UNAVAILABLE": "تم منع الإرسال إلى زوهو لأن القناة لا تستطيع تحديث الطلب حالياً. تحقق من الاتصال ثم حاول مرة أخرى.",
          "ZOHO_ORDER_PRE_SEND_REFRESH_AUTH_EXPIRED": "تم منع الإرسال إلى زوهو لانتهاء صلاحية تفويض القناة. أعد ربط القناة ثم حاول مرة أخرى.",
          "ZOHO_ORDER_PRE_SEND_REFRESH_FAILED": "تم منع الإرسال إلى زوهو لتعذّر جلب أحدث بيانات الطلب من القناة. حاول مرة أخرى.",
          "PROVIDER_RATE_LIMITED": "تم بلوغ حد معدل الطلبات في زوهو. انتظر قليلاً ثم حاول مرة أخرى.",
          "ZOHO_ORDER_ITEM_MAPPING_NOT_FOUND": "منتج واحد أو أكثر في الطلب غير مرتبط بعنصر في زوهو. أصلح روابط المنتجات المحددة قبل الإرسال مجدداً.",
          "ZOHO_INTEGRATION_NOT_AVAILABLE": "اربط Zoho Inventory قبل معاينة هذا الطلب.",
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "مرجع في سياسة زوهو قديم أو غير نشط.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "لا توجد سياسة طلبات زوهو نشطة تطابق هذه القناة.",
          "ZOHO_ORDER_POLICY_NO_ACTION_MAPPING": "لا تحتوي السياسة النشطة على ربط إجراء لهذه الحالة.",
          "ZOHO_ORDER_POLICY_INVALID": "راجع سياسة طلبات زوهو النشطة ثم حاول مرة أخرى.",
          "ZOHO_ORDER_POLICY_CHANNEL_NOT_SCOPED": "هذه القناة غير مشمولة في السياسة النشطة.",
          "ZOHO_SALES_ORDER_ID_REQUIRED_FOR_VOID": "يتطلب الإلغاء معرّف أمر بيع موجوداً في زوهو.",
          "ZOHO_ORDER_ALREADY_INVOICED": "لهذا الطلب فاتورة زوهو بالفعل ولا يمكن إلغاؤه.",
          "ZOHO_ORDER_ALREADY_VOIDED": "أمر البيع في زوهو ملغى بالفعل.",
          "ZOHO_INVOICE_RESET_NOT_ALLOWED": "لا يمكن إعادة ضبط مزامنة الفاتورة إلا بعد وجود معرّف أمر بيع ومعرّف فاتورة من زوهو لهذا الطلب.",
          "ZOHO_SYNC_RESET_NOT_ALLOWED": "لا يمكن إعادة ضبط مزامنة زوهو قبل وجود مستند زوهو مرتبط بهذا الطلب.",
          "ZOHO_SALES_ORDER_RECONCILIATION_AMBIGUOUS": "يطابق هذا الطلب أكثر من أمر بيع في زوهو. عالج التطابق في زوهو ثم حاول مرة أخرى.",
          "ZOHO_INVOICE_RECONCILIATION_AMBIGUOUS": "تطابق هذا الطلب أكثر من فاتورة في زوهو. عالج التطابق في زوهو ثم حاول مرة أخرى.",
          "ZOHO_INVOICE_RECONCILIATION_REQUIRED": "يشير زوهو إلى أن أمر البيع مفوتر بالفعل، لكن تلاق لم يتمكن من تحديد الفاتورة. اربطها أو عالجها في زوهو ثم حاول مرة أخرى.",
          "ZOHO_ORDER_POLICY_VOID_ORDER_UNSUPPORTED": "لا يمكن إكمال إجراء الإلغاء لهذا الطلب."
        }
      },
      "payment": {
        "card": "بطاقة",
        "cod": "دفع عند الاستلام"
      },
      "dates": {
        "apr24": "24 أبريل",
        "apr25": "25 أبريل",
        "apr26": "26 أبريل"
      }
    },
    "products": {
      "description": "كتالوج رئيسي لسجلات المنتجات والأسعار والصور وقوائم القنوات المرتبطة.",
      "searchPlaceholder": "ابحث عن المنتجات أو SKU…",
      "actions": {
        "resync": "إعادة مزامنة المحدد",
        "export": "تصدير مخزون XLSX",
        "newProduct": "منتج جديد",
        "openDetail": "فتح المنتج {{name}}"
      },
      "filters": {
        "category": "الفئة",
        "channel": "القناة",
        "syncStatus": "حالة المزامنة",
        "status": "الحالة",
        "allStatuses": "كل الحالات",
        "allChannels": "كل القنوات"
      },
      "stats": {
        "total": "إجمالي المنتجات",
        "inSync": "متزامنة",
        "attention": "تحتاج انتباهاً",
        "outOfStock": "نفد المخزون",
        "active": "نشطة",
        "draft": "مسودات",
        "activeOnPage": "نشطة في هذه الصفحة",
        "draftOnPage": "مسودات في هذه الصفحة"
      },
      "table": {
        "product": "المنتج",
        "sku": "SKU",
        "stock": "المخزون",
        "listings": "القوائم",
        "sync": "المزامنة",
        "price": "السعر",
        "status": "الحالة",
        "channelSync": "مزامنة القنوات",
        "updated": "آخر تحديث",
        "select": "تحديد",
        "selectRow": "تحديد {{name}}"
      },
      "pagination": "عرض {{from}}–{{to}} من {{total}} منتج",
      "price": "{{value}} ر.س",
      "categories": {
        "racquets": "مضارب",
        "supplements": "مكملات"
      },
      "items": {
        "pureDrive": {
          "name": "Babolat Pure Drive · G3"
        },
        "pureDriveLite": {
          "name": "Babolat Pure Drive Lite · G2"
        },
        "evoDrive": {
          "name": "Babolat Evo Drive · G3"
        },
        "evoStrike": {
          "name": "Babolat Evo Strike · G2"
        },
        "proteinBar": {
          "name": "Low Sugar Protein Bar · Box of 12"
        },
        "lowSugar": {
          "name": "Low Sugar Protein Bar · Single"
        }
      },
      "sync": {
        "synced": "متزامن",
        "drift": "اختلاف",
        "error": "خطأ"
      },
      "lastSync": {
        "2s": "2s ago",
        "5s": "5s ago",
        "8s": "8s ago",
        "11s": "11s ago",
        "1m": "1m ago",
        "12m": "12m ago"
      },
      "warnings": {
        "lowStockJeddah": "مخزون منخفض في جدة",
        "amazonDraft": "قائمة أمازون ما زالت مسودة"
      },
      "errors": {
        "outOfStockRelisting": "نفد المخزون؛ امنع إعادة النشر",
        "codes": {
          "REQUEST_FAILED": "تعذر تحميل المنتجات. حاول مرة أخرى.",
          "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة.",
          "VALIDATION_FAILED": "راجع الحقول وحاول مرة أخرى.",
          "PRODUCT_SKU_CONFLICT": "يوجد منتج بهذا SKU بالفعل.",
          "PRODUCT_IMAGE_TOO_LARGE": "الصورة أكبر من حجم الرفع المسموح.",
          "PRODUCT_IMAGE_TYPE_UNSUPPORTED": "استخدم صورة JPEG أو PNG أو WebP.",
          "PRODUCT_IMAGE_STORAGE_DISABLED": "تخزين الصور غير مفعّل حالياً.",
          "PRODUCT_IMAGE_STORAGE_NOT_CONFIGURED": "تخزين الصور غير مضبوط.",
          "PRODUCT_IMAGE_KEY_FORBIDDEN": "مفتاح الصورة غير مسموح لهذه المنظمة.",
          "PRODUCT_IMAGE_LIMIT_EXCEEDED": "يمكن إرفاق حتى 10 صور لكل منتج.",
          "PRODUCT_IMAGE_IN_USE": "هذه الصورة مرتبطة بمنتج بالفعل.",
          "PRODUCT_IMAGE_DELETE_FAILED": "تعذر تنظيف الصورة المرفوعة.",
          "PRODUCT_NOT_FOUND": "لم يتم العثور على المنتج.",
          "PRODUCT_INVALID_STATUS": "اختر حالة منتج صحيحة.",
          "PRODUCT_INVALID_LISTED_PROVIDER": "اختر مزوداً صالحاً للمنتجات المدرجة.",
          "PRODUCT_CATALOG_EXTERNAL_SOURCE": "تُدار تفاصيل المنتج من مصدر الكتالوج المتصل. لا يزال بإمكانك تعديل رموز SKU الإضافية."
        }
      },
      "export": {
        "exporting": "جارٍ التصدير…",
        "errors": {
          "codes": {
            "REQUEST_FAILED": "تعذر تصدير مخزون المنتجات. حاول مرة أخرى.",
            "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لتصدير مخزون المنتجات.",
            "PRODUCT_INVALID_STATUS": "اختر حالة منتج صحيحة قبل التصدير.",
            "PRODUCT_INVALID_LISTED_PROVIDER": "اختر مزوداً صالحاً للمنتجات المدرجة قبل التصدير."
          }
        }
      },
      "searchLabel": "البحث في المنتجات",
      "phaseOne": "المرحلة 1",
      "status": {
        "ACTIVE": "نشط",
        "INACTIVE": "غير نشط",
        "DRAFT": "مسودة"
      },
      "loading": "جاري تحميل المنتجات…",
      "emptyFiltered": "لا توجد منتجات تطابق البحث أو الفلتر.",
      "paginationPrev": "السابق",
      "paginationNext": "التالي",
      "imageCount": "{{count}} صور",
      "options": {
        "count": "{{count}} خيارات",
        "withoutSku": "خيارات بلا SKU",
        "totalAcross": "الإجمالي · {{count}} خيارات",
        "available": "متاح",
        "availableCount": "{{quantity}} متاح",
        "show": "عرض خيارات {{name}}",
        "hide": "إخفاء خيارات {{name}}",
        "loading": "جارٍ تحميل الخيارات…",
        "loadError": "تعذّر تحميل الخيارات.",
        "retry": "أعد المحاولة",
        "rowLabel": "خيار {{option}} من {{parent}}",
        "linkHint": "بدون SKU · مربوط بخيار سلة",
        "title": "الخيارات",
        "subtitleEditable": "المخزون محفوظ في كل خيار. حفظ أي خيار يرسل مخزونه إلى الخيار المطابق في سلة.",
        "subtitleReadOnly": "{{source}} هي مصدر مخزون هذه الخيارات. يعرض تلاق آخر ما سحبه — عدّل المخزون في {{source}}.",
        "totalSummary": "الإجمالي {{total}} عبر {{count}} خيارات",
        "stockSource": "مصدر المخزون: {{source}}",
        "tlaaq": "تلاق",
        "note": "هذه الخيارات بلا SKU في سلة، لذلك يربط تلاق كل خيار برقم خيار سلة. تتزامن مع سلة فقط — زوهو والقنوات الأخرى تطابق بالـ SKU ولا تراها. أضف SKU في سلة وسينتقل الخيار إلى منتج مستقل في السحب التالي، مع مخزونه وروابطه.",
        "loadingDetail": "جارٍ تحميل الخيارات والمخزون…",
        "loadErrorDetail": "تعذّر تحميل خيارات هذا المنتج. حاول مرة أخرى.",
        "wasCommitted": "كان {{was}} · {{committed}} محجوز",
        "committed": "{{quantity}} محجوز",
        "editOption": "تعديل الخيار · {{option}}",
        "saveChanges": "حفظ التغييرات",
        "activationHint": "يؤدي تفعيل هذا الخيار إلى جدولة إرسال مخزونه وفق قواعد التوزيع. يبقى المنتج الرئيسي والخيارات الأخرى دون تغيير.",
        "statusFor": "حالة {{option}}",
        "noSku": "بدون SKU",
        "retryPush": "إعادة الإرسال",
        "parentSkuNone": "— الخيارات أدناه بلا SKU",
        "headers": {
          "option": "الخيار",
          "onHandCode": "المتوفر · {{code}}",
          "salla": "سلة",
          "sallaSource": "سلة (المصدر)"
        },
        "sync": {
          "blocked": "لا تتم المزامنة: {{status}}",
          "inSync": "متزامن · {{quantity}}",
          "matchesSalla": "مطابق لسلة",
          "sallaShows": "سلة تعرض {{quantity}}",
          "notPushed": "لم يُرسل بعد",
          "willPush": "الإرسال التالي: {{quantity}}",
          "pushedAt": "أُرسل {{date}}",
          "pulledAt": "سُحب {{date}}",
          "pushing": "جارٍ إرسال {{quantity}} إلى سلة…",
          "startedNow": "بدأ الآن",
          "pushFailed": "فشل الإرسال",
          "stillShows": "سلة ما زالت تعرض {{quantity}}"
        },
        "parentStock": {
          "warning": "كان لهذا المنتج مخزون خاص قبل ربط خياراته. هذا المخزون لا يُرسل إلى سلة. انقله إلى الخيارات أو اجعله 0.",
          "notSynced": "متوفر · غير متزامن",
          "setToZero": "اجعله 0"
        },
        "released": {
          "message": "أصبح لكل خيارات هذا المنتج SKU خاص وانتقلت إلى منتجات مستقلة. لم يعد لهذا المنتج خيارات.",
          "archive": "أرشفة المنتج",
          "dismiss": "إخفاء"
        }
      },
      "channelSyncTooltip": "قوائم القنوات المرتبطة بهذا المنتج.",
      "channelSync": {
        "empty": "لا توجد قوائم مرتبطة",
        "listingCount": "{{channel}} · قائمة واحدة",
        "listingCount_plural": "{{channel}} · {{count}} قوائم",
        "multiCount": "{{count}} قوائم مرتبطة",
        "quantity": "{{quantity}} متاح",
        "infinite": "∞ متاح"
      }
    },
    "productsEmpty": {
      "title": "كتالوجك فارغ",
      "body": "أنشئ أول منتج يدوياً، أو اربط قناة واسحب المنتجات صراحةً عندما تكون جاهزاً.",
      "startPrompt": "كيف تريد أن تبدأ؟",
      "recommended": "موصى به",
      "zoho": {
        "title": "ربط Zoho Inventory",
        "body": "سحب المنتجات والمستودعات والمخزون من زوهو في مرحلة لاحقة.",
        "cta": "ربط زوهو"
      },
      "csv": {
        "title": "استيراد CSV",
        "body": "استيراد CSV مؤجل لإصدار منفصل.",
        "cta": "رفع CSV"
      },
      "channel": {
        "title": "استيراد من قناة",
        "body": "اربط متجراً، واختر مصدر الحقيقة، ثم اسحب المنتجات من صفحة القنوات.",
        "cta": "الذهاب إلى القنوات"
      },
      "or": "أو",
      "manual": "إنشاء منتج واحد يدوياً",
      "comingSoon": "قريباً"
    },
    "productDetail": {
      "product": {
        "name": "Babolat Pure Drive · G3",
        "category": "مضارب",
        "description": "مضرب تنس احترافي بإطار 300 غرام ونمط أوتار 16x19 وتخفيف Cortex. الأكثر مبيعاً عبر سلة ونون."
      },
      "breadcrumbProducts": "المنتجات",
      "zoho": "Zoho",
      "inStock": "متوفر",
      "lastSync": "آخر مزامنة",
      "lastSyncValue": "قبل ثانيتين",
      "price": "{{value}} ر.س",
      "actions": {
        "resync": "إعادة المزامنة الآن",
        "edit": "تعديل المنتج",
        "back": "العودة إلى المنتجات"
      },
      "tabs": {
        "master": "البيانات الرئيسية"
      },
      "master": {
        "title": "المنتج الرئيسي",
        "fields": {
          "sku": "SKU",
          "altSkus": "رموز SKU إضافية",
          "name": "الاسم",
          "category": "الفئة",
          "masterPrice": "السعر الرئيسي",
          "barcode": "الباركود",
          "weight": "الوزن",
          "dimensions": "الأبعاد",
          "description": "الوصف",
          "status": "الحالة",
          "cost": "التكلفة",
          "salePrice": "سعر التخفيض",
          "taxRate": "نسبة الضريبة",
          "updated": "آخر تحديث"
        },
        "sourcePrefix": "المصدر:",
        "sourceSuffix": "Zoho Inventory · item 190027",
        "phaseOneNote": "هذه البيانات الرئيسية قابلة للتعديل في المرحلة 1. قوائم القنوات المرتبطة تعرض بيانات المزوّد، وتبقى إجراءات النشر للمعاينة فقط."
      },
      "stock": {
        "title": "مخزون مستودعات المصدر",
        "subtitle": "الوحدات المتاحة بعد حجوزات القنوات.",
        "readOnly": "المخزون مملوك لـ {{source}} · للقراءة فقط في تلاق. عدّل المخزون في المصدر؛ كميات القنوات منفصلة.",
        "channelHint": "هذا مخزون المصدر لهذا الصنف في الكتالوج. افتح تبويب المتجر للاطلاع على قائمته المرتبطة وكميات المخزون المرصودة في القناة.",
        "source": "مصدر المخزون",
        "sourceUnknown": "جارٍ التحميل أو غير متاح",
        "ownership": "مصدر المخزون: {{source}}. يمكن تعديل مخزون تلاق فقط هنا؛ مخزون المصدر الخارجي للقراءة فقط.",
        "loading": "جارٍ تحميل المخزون…",
        "empty": "لا توجد مستودعات بعد. أنشئ مستودعاً من صفحة المستودعات لإدارة المخزون لكل موقع.",
        "headers": {
          "warehouse": "المستودع",
          "onHand": "المتوفر",
          "committed": "محجوز",
          "available": "متاح"
        },
        "actions": {
          "edit": "تعديل",
          "save": "حفظ",
          "cancel": "إلغاء"
        },
        "errors": {
          "generic": "تعذّر تحديث المخزون. حاول مرة أخرى.",
          "REQUEST_FAILED": "تعذّر تحميل المخزون. حاول مرة أخرى.",
          "PRODUCT_NOT_FOUND": "لم يتم العثور على المنتج.",
          "PRODUCT_STOCK_VERSION_CONFLICT": "تم تعديل المخزون منذ بدء التحرير. أعدنا تحميل الصف — حاول مرة أخرى.",
          "PRODUCT_STOCK_INVALID_QUANTITY": "أدخل عدداً صحيحاً غير سالب لا يقل عن المخزون المحجوز."
        }
      },
      "zohoRefresh": {
        "action": "تحديث من Zoho",
        "refreshing": "جارٍ التحديث…",
        "success": "تم تحديث المنتج من Zoho.",
        "successWithIssues": "تم تحديث المنتج من Zoho مع {{count}} مشكلة.",
        "successWithIssues_plural": "تم تحديث المنتج من Zoho مع {{count}} مشكلات.",
        "errors": {
          "REQUEST_FAILED": "تعذّر تحديث هذا المنتج من Zoho. حاول مرة أخرى.",
          "PRODUCT_ZOHO_REFRESH_SOURCE_MISMATCH": "يجب أن يكون Zoho مصدر المنتجات قبل تحديث هذا المنتج.",
          "PRODUCT_ZOHO_REFRESH_NOT_FOUND": "تعذّر العثور على عنصر Zoho المطابق لهذا المنتج.",
          "PRODUCT_ZOHO_REFRESH_AMBIGUOUS": "توجد عدة عناصر Zoho تطابق SKU هذا المنتج. عالج تكرار SKU في Zoho ثم حاول مرة أخرى.",
          "INVENTORY_CONNECTION_NOT_CONFIGURED": "Zoho غير متصل.",
          "INVENTORY_ADAPTER_NOT_REGISTERED": "تحديث Zoho غير متاح في هذا النشر.",
          "INVENTORY_AUTH_EXPIRED": "انتهى تفويض Zoho. أعد ربط Zoho ثم حاول مرة أخرى.",
          "INVENTORY_PULL_FAILED": "فشل تحديث Zoho. حاول مرة أخرى أو راجع سجل اتصالات المزوّد.",
          "INVENTORY_RATE_LIMITED": "قيّد Zoho هذا التحديث بسبب معدل الطلبات. حاول لاحقاً."
        }
      },
      "singleImportNotice": {
        "outcomes": {
          "CREATED": "أُنشئ المنتج من صنف Zoho",
          "REFRESHED": "تم تحديث المنتج من صنف Zoho",
          "MATCHED": "تمت مطابقة صنف Zoho مع هذا المنتج"
        },
        "subtitle": "حمّلت صفحة التفاصيل المنتج المحفوظ المعتمد. ملخص الاستيراد هذا مؤقت.",
        "dismiss": "إخفاء ملخص الاستيراد",
        "catalogLabel": "سلوك الكتالوج",
        "catalog": {
          "SOURCE_SYNC": "طُبقت تفاصيل المنتج من Zoho",
          "IMPORT_MISSING": "أُنشئ المنتج المفقود مع الحفاظ على الحقول الموجودة",
          "LISTINGS_ONLY": "تحديث الربط فقط مع الحفاظ على تفاصيل المنتج"
        },
        "stockLabel": "صفوف المخزون المستوردة",
        "warehousesLabel": "المستودعات المنشأة",
        "issuesLabel": "الملاحظات",
        "issueDetails": "بنود تحتاج إلى مراجعة",
        "issueCount": "تكرار واحد",
        "issueCount_plural": "{{count}} تكرارات",
        "issueCount_other": "{{count}} تكرارات"
      },
      "channel": {
        "listingTitle": "قوائم القنوات",
        "empty": "لا توجد قائمة لهذه القناة بعد.",
        "createListing": "إنشاء قائمة",
        "listing": "قائمة {{channel}}",
        "mappedSubtitle": "قائمة مرتبطة من {{channel}}.",
        "mappedCount": "قائمة مرتبطة واحدة",
        "mappedCount_plural": "{{count}} قوائم مرتبطة",
        "live": "منشورة",
        "notListed": "غير مدرجة",
        "viewOn": "عرض على {{channel}} ↗",
        "unlist": "إلغاء الإدراج",
        "fieldsTitle": "حقول القائمة",
        "stockRowsTitle": "كميات فروع المزوّد",
        "stockRowsEmpty": "لم يرجع {{channel}} أي صفوف كميات للمستودعات.",
        "variantStockScope": "كميات المخزون المرصودة تخص معرّف النسخة {{variantId}} لهذه القائمة. رمز SKU وحده لا يحدد الخيار.",
        "listingStockScope": "كميات المخزون المرصودة في القناة منفصلة عن مخزون مستودعات المصدر.",
        "branch": "الفرع / الموقع",
        "observedIn": "الكمية المرصودة في {{channel}}",
        "submittedTarget": "آخر كمية مستهدفة مرسلة",
        "unknownQuantity": "غير معروفة",
        "notFetched": "لم يُجلب مخزون هذا الموقع",
        "notSubmitted": "لم تُرسل",
        "pendingBody": "أُرسلت الكمية — بانتظار التأكيد. حدّث مخزون القناة لجلب أحدث الكميات. لا يوجد تحديث تلقائي.",
        "confirmedBody": "جلب أحدث للمخزون يعرض الكمية المستهدفة المرسلة لهذه القائمة وهذا الموقع. لا يؤكد ذلك الخيارات أو المواقع الأخرى.",
        "observedAt": "آخر جلب للمخزون",
        "submittedQuantity": "الكمية المرسلة",
        "submittedAt": "آخر إرسال",
        "confirmed": "مؤكد بعد الجلب",
        "awaitingConfirmation": "بانتظار التأكيد",
        "noonRefresh": "تحديث مخزون القناة",
        "noonRefreshing": "جارٍ تحديث مخزون القناة…",
        "noonRefreshFailed": "تعذّر تحديث مخزون القناة. لم تتغير البيانات المعروضة سابقًا. حاول مرة أخرى.",
        "quantityInfinite": "∞",
        "fields": {
          "title": "العنوان",
          "priceOverride": "سعر مخصص",
          "category": "الفئة",
          "status": "الحالة",
          "channelId": "معرّف القناة",
          "lastPublished": "آخر نشر",
          "externalProductId": "معرّف المنتج الخارجي",
          "externalVariantId": "معرّف النسخة الخارجي",
          "sku": "SKU القائمة",
          "lastSeen": "آخر جلب للقائمة",
          "lastStockPushed": "آخر إرسال للمخزون",
          "warehouse": "المستودع",
          "externalLocationId": "معرّف الموقع الخارجي",
          "quantity": "الكمية المرصودة"
        },
        "defaultCategory": "رياضة / تنس",
        "amazonCategory": "الرياضة والأنشطة الخارجية",
        "liveAt": "منشور بسعر {{price}} ر.س",
        "recentOn": "نشاط حديث على {{channel}}",
        "notListedSubtitle": "هذا المنتج غير مدرج على {{channel}}.",
        "notListedTitle": "المنتج غير مدرج على {{channel}}",
        "notListedBody": "لا توجد قائمة {{channel}} مرتبطة بهذا المنتج. اربط القائمة أو استوردها قبل مزامنة المخزون أو نشر التحديثات.",
        "noonNotListedBody": "لم يتم استيراد قائمة نون لهذا المنتج بعد. لا يزال بإمكانك دفع المخزون باستخدام رمز SKU للمنتج، وسترفض نون التحديث إذا لم يكن الرمز مدرجاً لديها.",
        "stockPush": {
          "title": "دفع المخزون يدوياً",
          "titleForBranch": "دفع المخزون يدوياً · {{location}}",
          "body": "ادفع كمية متاحة مطلقة من تلاق إلى قائمة {{channel}} هذه.",
          "bodyForBranch": "هذه القائمة و{{location}} فقط. لا تتغير الخيارات والمواقع الأخرى.",
          "variantScope": "فقط {{title}}، النسخة {{variantId}}، في هذا الموقع.",
          "absoluteTarget": "إعادة المحاولة تُرسل الكمية المستهدفة نفسها، ولا تضيف هذه الكمية مرة أخرى.",
          "setOptionQuantity": "ضبط مخزون الخيار المحدد على {{quantity}}",
          "setListingQuantity": "ضبط مخزون القائمة على {{quantity}}",
          "noonBody": "ادفع كمية متاحة مطلقة إلى نون باستخدام رمز SKU المحلي والمستودع المحدد.",
          "noonSku": "رمز SKU:",
          "noonWarehouse": "المستودع:",
          "action": "دفع المخزون",
          "actionForBranch": "دفع {{location}}",
          "loadingStock": "جارٍ تحميل المخزون المحلي…",
          "quantityLabel": "الكمية المتاحة",
          "localAvailable": "المخزون المحلي المتاح حالياً: {{quantity}}",
          "exceedsLocalWarning": "هذه الكمية أعلى من المتاح محلياً حالياً. يمكنك دفعها إذا كان ذلك مقصوداً.",
          "submit": "دفع إلى القناة",
          "submitting": "جارٍ الدفع…",
          "cancel": "إلغاء",
          "success": "تم قبول الطلب: أُرسلت {{quantity}} وحدة إلى {{channel}}. راجع أحدث كمية مرصودة في القناة للتأكد.",
          "unsupportedProvider": "دفع المخزون يدوياً غير مفعّل لـ {{channel}}.",
          "capabilityReasons": {
            "CHANNEL_OPERATION_NOT_IMPLEMENTED": "دفع المخزون يدوياً غير مدعوم لـ {{channel}} بعد.",
            "CHANNEL_OPERATION_FEATURE_DISABLED": "دفع المخزون يدوياً لـ {{channel}} معطّل في الإعدادات.",
            "CHANNEL_CONNECTION_NOT_READY": "اربط {{channel}} قبل دفع المخزون.",
            "CHANNEL_SOURCE_AUTHORITY_REQUIRED": "{{channel}} هي مصدر المخزون المعتمد، لذلك لن يدفع تلاق المخزون إليها.",
            "NOON_FBPI_WAREHOUSE_REQUIRED": "حدد مستودع نون FBPI قبل دفع المخزون."
          },
          "sourceOwned": "{{channel}} هي مصدر المخزون المعتمد، لذلك لن يدفع تلاق المخزون إليها.",
          "noStockLocations": "لا تحتوي هذه القائمة على مواقع مخزون لدى المزوّد. اسحب القوائم مع صفوف المخزون من {{channel}} قبل دفع الكمية.",
          "itemReasons": {
            "NO_PRODUCT_MAPPING": "هذه القائمة لم تعد مرتبطة بمنتج.",
            "NO_STOCK_LOCATIONS": "لا توجد مواقع مخزون لدى المزوّد لهذه القائمة.",
            "EXCLUDED_BY_ALLOCATION_RULE": "تجاوزت أتمتة توزيع المخزون هذا المنتج لأنه مستثنى من القاعدة.",
            "PROVIDER_ERROR": "رفضت القناة تحديث المخزون. تحقق من ربط القناة ثم حاول مرة أخرى.",
            "UNEXPECTED_ERROR": "فشل تحديث مخزون القناة بشكل غير متوقع. حاول مرة أخرى."
          },
          "errors": {
            "CHANNEL_STOCK_PUSH_SOURCE_CONNECTION": "هذه القناة تملك المخزون للمنظمة، لذلك لا يمكن لتلاق دفع المخزون إليها.",
            "CHANNEL_STOCK_PUSH_UNSUPPORTED": "دفع المخزون يدوياً غير مدعوم لهذا المزوّد بعد.",
            "CHANNEL_STOCK_PUSH_INVALID_QUANTITY": "أدخل رقماً صحيحاً غير سالب.",
            "CHANNEL_STOCK_PUSH_FEATURE_DISABLED": "دفع مخزون نون يدوياً معطّل في الإعدادات.",
            "CHANNEL_STOCK_PUSH_PRODUCT_SKU_REQUIRED": "يجب أن يحتوي المنتج على رمز SKU قبل دفع المخزون إلى نون.",
            "NOON_FBPI_WAREHOUSE_REQUIRED": "حدد مستودع نون FBPI قبل دفع المخزون.",
            "CHANNEL_CONNECTION_NOT_FOUND": "لم يتم العثور على ربط القناة.",
            "PRODUCT_NOT_FOUND": "لم يتم العثور على المنتج.",
            "CHANNEL_AUTH_EXPIRED": "انتهى تفويض القناة. أعد ربط القناة ثم حاول مرة أخرى.",
            "CHANNEL_LISTING_NOT_FOUND": "لم يتم العثور على هذه القائمة أو المنتج.",
            "REQUEST_FAILED": "تعذّر دفع المخزون إلى القناة. حاول مرة أخرى."
          }
        }
      },
      "activity": {
        "2s": "قبل ثانيتين",
        "8m": "قبل 8 دقائق",
        "1h": "قبل ساعة",
        "yesterday": "أمس",
        "saleOne": "تم حجز وحدة واحدة من الرياض",
        "revalidated": "تمت إعادة التحقق من القائمة بنجاح",
        "saleTwo": "تم حجز وحدتين من جدة",
        "priceUpdate": "تم تحديث السعر المخصص"
      },
      "emptyValue": "—",
      "loading": "جاري تحميل المنتج…",
      "lastUpdated": "آخر تحديث",
      "imageCount": "{{count}} صور",
      "weightValue": "{{value}} غ",
      "taxValue": "{{value}}٪",
      "images": {
        "title": "الصور",
        "empty": "لا توجد صور للمنتج بعد."
      },
      "channelTabs": {}
    },
    "onboarding": {
      "signup": {
        "title": "أنشئ مساحة عملك",
        "subtitle": "ابدأ بحسابك ثم اربط أول قناة.",
        "fullName": "الاسم الكامل",
        "fullNamePlaceholder": "لبنى القحطاني",
        "email": "البريد الإلكتروني للعمل",
        "emailPlaceholder": "lubna@yourstore.sa",
        "storeName": "اسم المتجر",
        "storeNamePlaceholder": "Fitneeds",
        "storeNameHint": "سيصبح هذا اسم مساحة العمل في تلاق.",
        "password": "كلمة المرور",
        "createAccount": "إنشاء الحساب",
        "continueGoogle": "المتابعة باستخدام Google",
        "terms": "بالمتابعة فإنك توافق على شروط تلاق وسياسة الخصوصية."
      },
      "common": {
        "back": "رجوع",
        "continue": "متابعة"
      },
      "steps": {
        "createAccount": "الحساب",
        "connectStore": "ربط المتجر",
        "sourceOfTruth": "المصدر والاستيراد",
        "youreSet": "جاهز"
      },
      "connect": {
        "title": "اربط أول متجر",
        "subtitle": "اختر السوق أو الواجهة التي تريد أن يراقبها تلاق أولاً.",
        "popular": "الأكثر استخداماً",
        "connect": "ربط",
        "skip": "تخطي الآن"
      },
      "channels": {
        "salla": "Salla",
        "zid": "Zid",
        "amazon": "Amazon",
        "noon": "Noon",
        "trendyol": "Trendyol"
      },
      "source": {
        "title": "أين تدير المنتجات والمخزون؟",
        "subtitle": "ربطت {{channel}}. اختر هل هذا المتجر أم تلاق هو مالك الكتالوج والمخزون قبل استيراد أي شيء.",
        "recommended": "موصى به",
        "almostDone": "اقتربنا من النهاية",
        "options": {
          "tlaaq": {
            "title": "استخدام تلاق كنظامي",
            "sub": "الأفضل للعمليات الجديدة",
            "body": "أدر المنتجات والمستودعات والمخزون مباشرة داخل تلاق. يمكنك أيضاً استيراد منتجات {{channel}} الناقصة كبداية.",
            "meta": "أسرع إعداد"
          },
          "channel": {
            "title": "استخدام متجر {{channel}}",
            "sub": "عكس بيانات المتجر",
            "body": "المنتجات والمخزون موجودة بالفعل في {{channel}}. سيسحبها تلاق ويزامنها مع القنوات الأخرى.",
            "meta": "موصى به إذا كان المتجر يعمل"
          },
          "zoho": {
            "title": "ربط Zoho Inventory",
            "sub": "لمستخدمي زوهو الحاليين",
            "body": "أبقِ زوهو كمصدر رئيسي ودع تلاق يزامن القنوات.",
            "meta": "موصى به إذا كان زوهو يعمل"
          },
          "skip": {
            "title": "قرر لاحقاً",
            "sub": "استكشف أولاً",
            "body": "افتح مساحة العمل واضبط المخزون من الإعدادات."
          }
        },
        "pull": {
          "title": "هل تريد سحب المنتجات الآن؟",
          "channelBody": "سنستورد المنتجات والأسعار والمخزون الحالي من {{channel}}. يمكنك تشغيل ذلك لاحقاً من صفحة القنوات أيضاً.",
          "tlaaqBody": "سننشئ منتجات محلية للأكواد الآمنة الناقصة من {{channel}}. لن تستبدل تغييرات المتجر المستقبلية بيانات تلاق.",
          "now": "استيراد الآن",
          "later": "استيراد لاحقاً"
        }
      },
      "welcome": {
        "title": "أنت جاهز للبيع في كل مكان",
        "body": "سيحافظ تلاق على حركة المنتجات والطلبات والمخزون عبر قنواتك.",
        "dashboard": "فتح لوحة التحكم"
      },
      "signOut": "تسجيل الخروج"
    },
    "settings": {
      "groups": {
        "workspace": "مساحة العمل",
        "operations": "العمليات",
        "system": "النظام"
      },
      "sections": {
        "workspace": {
          "title": "Workspace profile",
          "description": "Organization name, domain, and default locale."
        },
        "branding": {
          "title": "Branding",
          "description": "Logo, colors, and invoice identity."
        },
        "members": {
          "title": "Members & roles",
          "description": "Invite teammates and tune access."
        },
        "inventory": {
          "title": "Inventory rules",
          "description": "Source of truth, stock buffers, and reconciliation."
        },
        "orders": {
          "title": "Order rules",
          "description": "Routing, fraud holds, and fulfillment preferences."
        },
        "shipping": {
          "title": "Shipping",
          "description": "Carrier defaults and delivery promises."
        },
        "tax": {
          "title": "Tax & invoices",
          "description": "VAT IDs, tax codes, and invoice numbering."
        },
        "notifications": {
          "title": "Notifications",
          "description": "Email, Slack, and WhatsApp alerts."
        },
        "api": {
          "title": "API keys",
          "description": "Manage integrations and webhook secrets."
        },
        "audit": {
          "title": "Audit log",
          "description": "Review security and configuration changes."
        },
        "danger": {
          "title": "Danger zone",
          "description": "Export or delete workspace data."
        }
      },
      "inventoryRules": {
        "title": "قواعد المخزون",
        "description": "اضبط كيف يقرأ تلاق المخزون ويحميه ويطابقه.",
        "source": {
          "title": "Source of truth",
          "caption": "Current source",
          "zoho": "Zoho Inventory",
          "detail": "Products and stock are read from Zoho before publishing to channels.",
          "switch": "Switch source"
        },
        "buffer": {
          "title": "Stock buffer",
          "caption": "Keep units unavailable to channels to reduce overselling.",
          "row": "Reserve buffer per SKU",
          "units": "units",
          "applyTo": "Apply to every warehouse"
        },
        "outOfStock": {
          "title": "When product is out of stock",
          "caption": "Choose what Tlaaq does on each channel.",
          "delist": {
            "title": "Delist from marketplaces",
            "description": "Hide products from Amazon, Noon, and Trendyol when stock hits zero."
          },
          "zero": {
            "title": "Keep listing, push zero stock",
            "description": "Recommended for Salla and Zid storefronts."
          }
        },
        "reconciliation": {
          "title": "Reconciliation",
          "caption": "Catch drift between Tlaaq, Zoho, and each channel.",
          "schedule": "Schedule",
          "scheduleValue": "Every 15 minutes",
          "threshold": "Alert threshold",
          "thresholdUnits": "units difference",
          "lastRun": "Last run",
          "lastRunValue": "4 minutes ago",
          "checked": "3,289 SKUs checked",
          "noDrift": "No drift detected"
        }
      },
      "actions": {
        "save": "حفظ التغييرات",
        "discard": "تجاهل"
      },
      "genericComingSoon": "سيأتي قسم الإعدادات هذا قريباً."
    },
    "syncRuleWizard": {
      "breadcrumb": {
        "inventory": "المخزون",
        "zoho": "Zoho Inventory",
        "orderPolicy": "سياسة الطلبات"
      },
      "title": "منشئ سياسة طلبات زوهو",
      "subtitle": "حدّد القنوات التي تملكها سياسة طلبات Zoho، واضبط القيم المشتركة، واربط حالات الطلب بإجراءات Zoho، وأضف قواعد الدفع والشحن والمستودعات.",
      "loading": "جارٍ التحميل…",
      "emptyValue": "—",
      "noConnection": {
        "title": "اربط Zoho أولاً",
        "body": "افتح إعداد Zoho واربط حساب مخزون قبل إنشاء سياسة الطلبات."
      },
      "actions": {
        "refreshMasterData": "تحديث بيانات Zoho الرئيسية",
        "refreshingMasterData": "جارٍ التحديث…",
        "refreshChannelMethods": "تحديث طرق القناة",
        "refreshingChannelMethods": "جارٍ تحديث الطرق…",
        "add": "إضافة",
        "createDraft": "إنشاء مسودة سياسة",
        "creatingDraft": "جارٍ إنشاء المسودة…",
        "saveDraft": "حفظ مسودة السياسة",
        "savingDraft": "جاري حفظ المسودة…",
        "activateDraft": "تفعيل السياسة المنشأة",
        "activating": "جارٍ التفعيل…",
        "backToZoho": "العودة إلى إعداد Zoho",
        "resetDefaultActions": "إعادة إجراءات الحالة الافتراضية",
        "addActionMapping": "إضافة ربط إجراء",
        "fbnPreset": "استخدام تنفيذ FBN",
        "flexPreset": "استخدام بادئة SKU لفليكس F-",
        "addAdvancedRule": "إضافة قاعدة متقدمة",
        "addWarehouseOverride": "إضافة استبدال مستودع",
        "remove": "إزالة",
        "clear": "مسح",
        "searchProducts": "البحث في المنتجات",
        "removeCondition": "إزالة شرط {{condition}}",
        "removePaymentMapping": "إزالة ربط الدفع",
        "removeShippingMapping": "إزالة ربط الشحن"
      },
      "notices": {
        "masterDataRefreshed": "تم تحديث بيانات Zoho الرئيسية.",
        "channelMethodsRefreshed": "تم تحديث طرق القناة.",
        "draftCreated": "تم إنشاء مسودة السياسة.",
        "draftUpdated": "تم حفظ مسودة السياسة.",
        "policyActivated": "تم تفعيل السياسة."
      },
      "defaults": {
        "policyName": "سياسة طلبات Zoho الافتراضية"
      },
      "placeholders": {
        "selectOptional": "استخدام افتراضي Zoho",
        "allPolicyChannels": "كل قنوات السياسة",
        "selectRequired": "اختر قيمة من Zoho",
        "manualOrObserved": "قيمة يدوية أو مرصودة",
        "noShippingCondition": "بدون شرط شحن",
        "addCondition": "أضف شرطاً…",
        "allConditionsAdded": "تمت إضافة كل الشروط",
        "paymentMethod": "بطاقة، دفع عند الاستلام، محفظة…",
        "paymentStatus": "مدفوع، مؤكد، قيد الانتظار…",
        "paymentMethodType": "COD، CARD، BNPL…",
        "paymentMethodExternalId": "معرّف دفع من المزود…",
        "shippingCompany": "Aramex، SMSA…",
        "shippingMethod": "سريع، في نفس اليوم…",
        "shippingMethodExternalId": "معرّف توصيل من المزود…",
        "shippingMethodCode": "redbox، aramex…",
        "rawStatus": "حالة قناة غير موحدة…",
        "rawStatuses": "delivered، shipped…",
        "priority": "100",
        "paymentMethodCode": "COD، CARD…",
        "fulfillmentChannel": "FBN، MFN، FLEX…",
        "fulfillmentStatus": "ready، shipped…",
        "skuPrefix": "F-",
        "searchServiceItems": "ابحث عن منتجات الخدمة بالرمز أو الاسم…"
      },
      "fields": {
        "name": "اسم السياسة",
        "invoiceSourceMode": "مصدر الفاتورة",
        "customer": "العميل",
        "warehouse": "المستودع",
        "defaultWarehouse": "المستودع الافتراضي",
        "defaultPaymentTerms": "شروط الدفع الافتراضية",
        "defaultDeliveryMethod": "طريقة التوصيل الافتراضية",
        "salesPerson": "مندوب المبيعات",
        "paymentTerms": "شروط الدفع",
        "zohoPaymentTerms": "شروط الدفع في Zoho",
        "paymentFeeServiceItem": "عنصر خدمة رسوم الدفع أو الدفع عند الاستلام",
        "deliveryMethod": "طريقة التوصيل",
        "zohoDeliveryMethod": "طريقة التوصيل في Zoho",
        "shippingFeeServiceItem": "عنصر خدمة رسوم الشحن",
        "createInvoice": "إنشاء فاتورة",
        "confirmOrder": "تأكيد أمر البيع",
        "voidOrder": "إلغاء الطلبات الملغاة غير المدعومة",
        "serviceItemSearch": "البحث عن عناصر الخدمة",
        "paymentMethod": "نص طريقة الدفع",
        "paymentStatus": "حالة الدفع",
        "paymentMethodCode": "رمز طريقة الدفع",
        "paymentMethodType": "نوع طريقة الدفع",
        "paymentMethodExternalId": "معرّف طريقة الدفع",
        "channelPaymentMethod": "طريقة دفع القناة",
        "shippingCondition": "شرط الشحن",
        "channelDeliveryOption": "خيار توصيل القناة",
        "shippingMethodExternalId": "معرّف طريقة الشحن",
        "shippingMethodCode": "رمز طريقة الشحن",
        "shippingCompany": "شركة الشحن",
        "shippingMethod": "طريقة الشحن",
        "addPaymentCondition": "إضافة شرط دفع",
        "addShippingCondition": "إضافة شرط شحن",
        "reportingTag": "وسم التقرير",
        "reportingTagOption": "خيار وسم التقرير",
        "rulePriority": "أولوية القاعدة",
        "mappingPriority": "الأولوية",
        "lifecycleAction": "إجراء Zoho",
        "orderStatuses": "حالات الطلب",
        "rawStatuses": "الحالات الأصلية",
        "channelProvider": "مزود القناة",
        "channelConnectionId": "معرّف ربط القناة",
        "channelConnection": "القناة",
        "mappingChannelScope": "حصرها على قناة",
        "orderStatus": "حالة الطلب",
        "rawStatus": "الحالة الأصلية",
        "fulfillmentChannel": "قناة التنفيذ",
        "fulfillmentStatus": "حالة التنفيذ",
        "skuMatchScope": "نطاق مطابقة SKU",
        "skuMatchOperator": "عامل مطابقة SKU",
        "skuMatchValue": "قيمة مطابقة SKU",
        "overrideCustomer": "استبدال العميل",
        "overrideWarehouse": "استبدال المستودع",
        "targetWarehouse": "المستودع الهدف",
        "overrideSalesPerson": "استبدال مندوب المبيعات",
        "overridePaymentTerms": "استبدال شروط الدفع",
        "overrideDeliveryMethod": "استبدال طريقة التوصيل",
        "overrideReportingTag": "استبدال وسم التقرير",
        "overrideReportingTagOption": "استبدال خيار وسم التقرير",
        "createInvoiceOverride": "استبدال إنشاء الفاتورة",
        "confirmOrderOverride": "استبدال تأكيد الطلب",
        "voidOrderOverride": "استبدال إلغاء الطلب"
      },
      "base": {
        "title": "القيم الافتراضية الأساسية",
        "body": "تطبق قيم Zoho هذه ما لم يستبدلها ربط الدفع أو الشحن."
      },
      "channels": {
        "title": "القنوات",
        "body": "اختر روابط القنوات التي تملكها سياسة Zoho هذه. لا يمكن أن يكون للقناة أكثر من سياسة نشطة واحدة لكل ربط Zoho.",
        "empty": "لا توجد روابط قنوات متاحة بعد."
      },
      "invoiceSource": {
        "modes": {
          "LOCAL_ORDER": "استخدام سطور الطلب المحلية في تلاق",
          "ZOHO_SALES_ORDER_SNAPSHOT": "استخدام أحدث لقطة من أمر البيع في Zoho"
        },
        "help": {
          "LOCAL_ORDER": "تُنشأ الفواتير من سطور الطلب المحفوظة في تلاق. يتم تجاهل التعديلات اليدوية التي تمت داخل Zoho.",
          "ZOHO_SALES_ORDER_SNAPSHOT": "قبل إنشاء الفاتورة، يجلب تلاق أحدث أمر بيع من Zoho وينشئ الفاتورة من تلك اللقطة دون تغيير الطلب المحلي."
        },
        "scopeHelp": "ينطبق هذا الإعداد على كل القنوات المحددة في هذه السياسة. استخدم سياسة منفصلة للقنوات التي تحتاج مصدراً مختلفاً للفاتورة."
      },
      "commonDefaults": {
        "title": "قيم Zoho المشتركة",
        "body": "تنطبق قيم البيانات الرئيسية هذه على كل إجراء مطابق ما لم تختر قواعد الدفع أو الشحن أو المستودع قيمة أكثر تحديداً."
      },
      "actionMappings": {
        "title": "ربط حالات الطلب بالإجراءات",
        "body": "اربط حالات طلبات القنوات الموحدة، ومعها الحالات الأصلية الاختيارية، بإجراء Zoho الذي يجب أن ينفذه زر الإرسال إلى Zoho."
      },
      "paymentMappings": {
        "title": "تعريفات الدفع",
        "body": "حدّد بيانات الدفع في طلب القناة التي يجب ربطها بقيمة شروط دفع في Zoho. اترك حصر القناة فارغاً ليطبق الربط على كل القنوات المحددة أعلاه.",
        "empty": "لا يوجد ربط دفع بعد."
      },
      "shippingMappings": {
        "title": "تعريفات الشحن",
        "body": "حدّد بيانات الشحن في طلب القناة التي يجب ربطها بطريقة توصيل في Zoho. اترك حصر القناة فارغاً ليطبق الربط على كل القنوات المحددة أعلاه.",
        "empty": "لا يوجد ربط شحن بعد."
      },
      "mappingSections": {
        "orderConditionsTitle": "شروط مطابقة الطلب",
        "paymentOrderConditionsBody": "هذه الحقول تأتي من بيانات طلب القناة. احصرها على قناة فقط عندما يحتاج متجر محدد من القنوات المختارة إلى قاعدة أدق.",
        "shippingOrderConditionsBody": "هذه الحقول تأتي من بيانات طلب القناة. احصرها على قناة فقط عندما يحتاج متجر محدد من القنوات المختارة إلى قاعدة أدق.",
        "noConditions": "لم تُحدَّد شروط بعد. أضف فقط الحقول التي يجب أن تطابقها هذه القاعدة.",
        "definitionsCount": "{{count}} محفوظة",
        "zohoResultTitle": "نتيجة Zoho",
        "paymentResultBody": "عند مطابقة شروط الطلب، يرسل تلاق قيمة شروط الدفع هذه إلى Zoho.",
        "shippingResultBody": "عند مطابقة شروط الطلب، يرسل تلاق طريقة التوصيل هذه إلى Zoho."
      },
      "channelMethods": {
        "emptyPayment": "لا توجد طرق دفع مخزنة لقنوات Zid المحددة بعد. حدّث الطرق أو أدخل القيم المرصودة يدوياً.",
        "emptyShipping": "لا توجد خيارات توصيل مخزنة لقنوات Zid المحددة بعد. حدّث الطرق أو أدخل القيم المرصودة يدوياً.",
        "missingShippingScope": "يتطلب اكتشاف خيارات التوصيل صلاحية Zid shipping.read. ما زال بإمكان السياسات الحالية الحفظ باستخدام معرّف الشحن أو رمزه أو الشركة أو الطريقة يدوياً."
      },
      "serviceItems": {
        "empty": "لم يتم اختيار عنصر خدمة.",
        "paymentHelper": "اختياري. لرسوم الدفع أو الدفع عند الاستلام في Zid/Mazeed، يرسل تلاق منتج خدمة Zoho المسحوب كسطر خاضع للضريبة بدلاً من تعديل Zoho الأصلي.",
        "shippingHelper": "اختياري. لرسوم الشحن في Zid/Mazeed، يرسل تلاق منتج خدمة Zoho المسحوب كسطر خاضع للضريبة بدلاً من shipping_charge في Zoho.",
        "searching": "جارٍ البحث…",
        "noResults": "لم يتم العثور على منتجات.",
        "error": "تعذّر البحث في المنتجات. حاول مرة أخرى.",
        "selectedProduct": "المنتج المحدد #{{id}}"
      },
      "advancedRules": {
        "title": "قواعد الاستثناء المتقدمة",
        "body": "أضف استبدالات مشروطة حسب القناة أو حالة الطلب أو التنفيذ أو أنماط SKU قبل الرجوع إلى القيم الأساسية.",
        "empty": "لا توجد قواعد استثناء متقدمة بعد.",
        "summary": "الأولوية {{priority}} · الحالة {{status}} · SKU {{sku}}"
      },
      "warehouseOverrides": {
        "title": "استبدالات المستودعات",
        "body": "وجّه الطلبات المطابقة إلى مستودع Zoho محدد باستخدام شروط القناة أو الحالة أو الدفع أو الشحن أو التنفيذ أو SKU مثل FBN وبادئات Flex.",
        "empty": "لا توجد استبدالات مستودعات بعد.",
        "summary": "الأولوية {{priority}} · الحالة {{status}} · المستودع {{warehouse}}"
      },
      "skuScopes": {
        "ANY_LINE": "أي سطر يطابق",
        "ALL_LINES": "كل الأسطر تطابق",
        "NO_LINE": "لا يوجد سطر يطابق"
      },
      "skuOperators": {
        "EXACT": "يساوي",
        "PREFIX": "يبدأ بـ",
        "SUFFIX": "ينتهي بـ",
        "CONTAINS": "يحتوي"
      },
      "actionOverrides": {
        "INHERIT": "وراثة الإجراء الأساسي",
        "YES": "نعم",
        "NO": "لا"
      },
      "lifecycleActions": {
        "CREATE_SALES_ORDER": "إنشاء أمر بيع",
        "CONFIRM_SALES_ORDER": "تأكيد أمر البيع",
        "CREATE_INVOICE": "إنشاء فاتورة",
        "VOID_SALES_ORDER": "إلغاء أمر البيع",
        "CREATE_CREDIT_NOTE": "إنشاء إشعار دائن"
      },
      "orderStatuses": {
        "NEW": "جديد",
        "IN_PROGRESS": "قيد التنفيذ",
        "COMPLETED": "مكتمل",
        "CANCELLED": "ملغي",
        "UNKNOWN": "غير معروف"
      },
      "active": {
        "title": "السياسة النشطة",
        "summary": "{{channels}} قناة · المستودع الافتراضي {{warehouse}}",
        "emptyTitle": "لا توجد سياسة نشطة",
        "emptyBody": "أنشئ وفعّل سياسة قبل تجربة معاينات طلبات Zoho."
      },
      "autoSend": {
        "title": "الإرسال التلقائي للطلبات إلى Zoho",
        "enabled": "الإرسال التلقائي مفعّل",
        "disabled": "الإرسال التلقائي متوقف",
        "toggleLabel": "تبديل الإرسال التلقائي لـ {{name}}",
        "help": "ينطبق فقط على الطلبات المستوردة أو المحدّثة مستقبلاً. يبقى زر الإرسال اليدوي إلى Zoho متاحاً عند إيقاف الإرسال التلقائي.",
        "activeOnlyHelp": "فعّل هذه السياسة قبل تفعيل الإرسال التلقائي. الإرسال اليدوي إلى Zoho منفصل عن هذه الأتمتة.",
        "saving": "جارٍ تحديث الإرسال التلقائي…"
      },
      "draft": {
        "title": "مسودات السياسات",
        "createTitle": "مسودة السياسة",
        "createBody": "احفظ هذا النموذج كمسودة، ثم فعّله من صفحة إعداد Zoho.",
        "editTitle": "تعديل مسودة السياسة",
        "editBody": "تحدّث التغييرات الإصدار {{version}} مباشرة إلى أن يتم تفعيله.",
        "empty": "لا توجد مسودات سياسات بعد.",
        "version": "الإصدار {{version}}",
        "viewTitle": "عرض السياسة",
        "viewBody": "هذا الإصدار {{version}} بحالة {{status}} للقراءة فقط. لتغييره، أنشئ نسخة مسودة من صفحة إعداد Zoho."
      },
      "deferred": {
        "title": "سلوك الإرسال",
        "body": "يستخدم الإرسال إلى Zoho حالة طلب القناة المطابقة لإنشاء أمر البيع أو تأكيده أو إصدار فاتورة أو إلغائه حسب هذه الربوط."
      },
      "validation": {
        "channelsRequired": "اختر قناة واحدة على الأقل قبل الحفظ.",
        "actionsRequired": "احتفظ بربط إجراء واحد على الأقل قبل الحفظ.",
        "paymentMappingNeedsCriteria": "أضف قيمة مطابقة دفع واحدة على الأقل، أو استخدم شروط الدفع الافتراضية أعلاه.",
        "shippingMappingNeedsCriteria": "أضف قيمة مطابقة شحن واحدة على الأقل، أو استخدم طريقة التوصيل الافتراضية أعلاه.",
        "paymentMappingsInvalid": "يحتاج كل تعريف دفع إلى شروط دفع وقيمة مطابقة دفع واحدة على الأقل.",
        "shippingMappingsInvalid": "يحتاج كل تعريف شحن إلى طريقة توصيل وقيمة مطابقة شحن واحدة على الأقل."
      },
      "status": {
        "DRAFT": "مسودة",
        "ACTIVE": "نشطة",
        "DISABLED": "معطلة",
        "ARCHIVED": "مؤرشفة"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "فشل الطلب. حاول مرة أخرى.",
          "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "لا توجد سياسة نشطة بعد.",
          "ZOHO_ORDER_POLICY_INVALID": "راجع حقول السياسة وحاول مرة أخرى.",
          "ZOHO_ORDER_POLICY_REFERENCE_NOT_FOUND": "إحدى قيم Zoho المحددة غير موجودة. حدّث البيانات الرئيسية وحاول مرة أخرى.",
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "إحدى قيم Zoho المحددة قديمة. حدّث البيانات الرئيسية واختر قيمة نشطة.",
          "ZOHO_ORDER_POLICY_VOID_ORDER_UNSUPPORTED": "لا يمكن إكمال إجراء الإلغاء لهذه السياسة.",
          "ZOHO_MASTER_DATA_REFRESH_FAILED": "فشل تحديث بيانات Zoho الرئيسية. حاول مرة أخرى.",
          "ZOHO_MASTER_DATA_CATEGORY_INVALID": "اختر فئة بيانات رئيسية مدعومة في Zoho.",
          "INVENTORY_CONNECTION_NOT_CONFIGURED": "Zoho غير متصل بعد.",
          "INVENTORY_CONNECTION_NOT_FOUND": "تعذّر العثور على ربط Zoho هذا.",
          "INVENTORY_PROVIDER_UNSUPPORTED": "مزود المخزون هذا غير مدعوم لهذا الإجراء.",
          "INVENTORY_NOT_CONFIGURED": "Zoho غير متصل بعد.",
          "INVENTORY_AUTH_EXPIRED": "انتهى تفويض Zoho. أعد الربط ثم حاول مرة أخرى.",
          "INVENTORY_PULL_FAILED": "فشل تحديث بيانات Zoho الرئيسية. حاول مرة أخرى."
        }
      }
    },
    "zidOAuth": {
      "submitting": {
        "title": "جارٍ إنهاء ربط زد",
        "body": "نتبادل رمز التفويض مع زد. عادةً تستغرق العملية ثوانٍ قليلة."
      },
      "error": {
        "title": "تعذّر إنهاء ربط زد",
        "back": "العودة إلى القنوات"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "تعذّر إنهاء ربط زد. حاول لاحقاً.",
          "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لإنهاء ربط زد.",
          "CHANNEL_OAUTH_STATE_INVALID": "انتهت صلاحية رابط الربط أو سبق استخدامه. ابدأ عملية الربط من جديد من القنوات.",
          "CHANNEL_OAUTH_CALLBACK_FAILED": "رفض زد إكمال الربط. حاول الربط مرة أخرى.",
          "CHANNEL_CONNECTION_NOT_FOUND": "تعذّر العثور على ربط القناة الذي بدأ هذه العملية.",
          "CHANNEL_AUTH_EXPIRED": "انتهى تفويض زد. ابدأ عملية ربط جديدة.",
          "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "هذه المؤسسة في تلاق مرتبطة بالفعل بمتجر زد مختلف.",
          "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "ما زلنا ننشئ مهمة الاستيراد. أبقِ هذه الصفحة مفتوحة قليلاً.",
          "CHANNEL_ONBOARDING_INCOMPLETE": "مهمة الاستيراد ليست جاهزة لإعادة المحاولة بعد.",
          "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "تعذّرت جدولة مهمة الاستيراد. جرّب إعادة المحاولة من هذه الصفحة."
        }
      },
      "chain": {
        "backToZid": "العودة إلى زد",
        "installed": "تم التثبيت",
        "redirectedFrom": "تم التحويل من",
        "fillDetails": "أكمل التفاصيل",
        "configured": "تم الإعداد",
        "redirecting": "جارٍ التحويل",
        "next": "التالي",
        "zidApps": "تطبيقات زد"
      },
      "demo": {
        "store": "Layali Home"
      },
      "form": {
        "fromZid": "من زد",
        "eyebrow": "ربط زد OAuth",
        "title": "أكمل ربط متجر زد",
        "description": "سحبنا ما شاركه زد. أكد تفاصيل مساحة العمل واختر كيفية إدارة المخزون.",
        "connectedAs": "متصل باسم",
        "merchantId": "معرّف التاجر",
        "workspaceName": "اسم مساحة العمل",
        "ownerEmail": "بريد المالك",
        "phone": "الهاتف",
        "phonePlaceholder": "+966 5x xxx xxxx",
        "source": "مصدر المخزون",
        "useTlaaq": "استخدام مخزون تلاق",
        "simplest": "أبسط إعداد",
        "connectZoho": "ربط زوهو لاحقاً",
        "fromSettings": "متاح من الإعدادات",
        "consent": "أسمح لتلاق بمزامنة المنتجات والطلبات والمخزون مع زد.",
        "readScopes": "نطاقات القراءة: المنتجات، الطلبات، ملف المتجر",
        "finish": "إنهاء الإعداد",
        "footer": "يمكنك فصل زد في أي وقت من القنوات."
      },
      "success": {
        "title": "تم ربط زد",
        "bodyShort": "تم ربط متجر زد بتلاق. يمكنك إدارته من القنوات.",
        "bodyPrefix": "ننشئ مساحة العمل لـ",
        "bodySuffix": "ونجهز أول مزامنة.",
        "whatHappened": "ما الذي حدث",
        "channelConnected": "تم ربط القناة",
        "subscription": "تم اكتشاف الاشتراك",
        "workspacePrefix": "مساحة العمل",
        "workspaceSuffix": "تم إنشاؤها",
        "seconds": "سيتم تحويلك إلى تلاق خلال ثوانٍ.",
        "back": "العودة إلى اللوحة"
      },
      "import": {
        "title": "أول استيراد من زد",
        "subtitle": "يستورد تلاق المنتجات والمخزون والطلبات الحديثة في الخلفية.",
        "queuedTitle": "يجري تجهيز الاستيراد",
        "queuedBody": "اكتمل الربط. ننتظر ظهور مهمة الاستيراد وسنحدّث هذه الشاشة تلقائياً.",
        "products": "المنتجات والمخزون",
        "orders": "الطلبات الحديثة",
        "retry": "إعادة الاستيراد",
        "retrying": "جارٍ إعادة المحاولة…",
        "refreshFailed": "تعذّر تحديث تقدم الاستيراد. سنواصل المحاولة.",
        "issueCount": "{{count}} منتجات تحتاج مراجعة بعد الاستيراد.",
        "status": {
          "QUEUED": "في الانتظار",
          "RUNNING": "جارٍ",
          "COMPLETED": "مكتمل",
          "COMPLETED_WITH_ISSUES": "مكتمل مع مشكلات",
          "FAILED": "فشل"
        },
        "stepStatus": {
          "PENDING": "بانتظار",
          "RUNNING": "جارٍ",
          "SUCCEEDED": "تم",
          "SUCCEEDED_WITH_ISSUES": "تم مع مشكلات",
          "FAILED": "فشل",
          "SKIPPED": "تم التخطي"
        },
        "counters": {
          "products": "المنتجات",
          "stock": "صفوف المخزون",
          "orders": "الطلبات"
        }
      },
      "footer": {
        "cancel": "إلغاء",
        "security": "تسليم OAuth آمن من زد."
      }
    },
    "sallaInvitation": {
      "eyebrow": "سلة · ربط المتجر",
      "continue": { "title": "اربط متجر سلة", "body": "أنشئ حسابًا أو سجّل الدخول لمراجعة الدعوة. ستؤكد المتجر والمنشأة قبل إجراء أي ربط." },
      "confirm": { "title": "تأكيد ربط المتجر", "body": "راجع متجر سلة الذي تم التحقق منه والمنشأة التي سيتم ربطه بها." },
      "loading": { "title": "جارٍ التحقق من الدعوة", "body": "نتحقق من الدعوة قبل عرض بيانات المتجر." },
      "invalid": { "title": "لم يعد هذا الرابط صالحًا", "body": "قد تكون الدعوة منتهية الصلاحية أو سبق استخدامها. تواصل مع الدعم للمساعدة بشأن الدعوة." },
      "nonowner": { "title": "يجب أن يؤكد المالك الربط", "body": "لا يمكن لحسابك الحالي ربط متجر بهذه المنشأة. تابع باستخدام حساب مالك المنشأة." },
      "conflict": { "title": "هذا المتجر مرتبط بالفعل", "body": "يوجد ربط آخر لهذا المتجر أو المنشأة. تواصل مع الدعم لحل المشكلة. لم يتم نقل أي ربط." },
      "unavailable": { "title": "تعذّر التحقق من الدعوة", "body": "حاول مرة أخرى للتحقق من حالتها الحالية. لن يتم إجراء أي ربط دون تأكيدك." },
      "store": "متجر سلة الذي تم التحقق منه",
      "organization": "المنشأة المستقبلة · أنت المالك",
      "register": "إنشاء حساب",
      "login": "تسجيل الدخول",
      "confirmAction": "تأكيد الربط",
      "confirming": "جارٍ الربط…",
      "cancel": "إلغاء",
      "back": "العودة إلى تلاق",
      "switchAccount": "استخدام حساب آخر",
      "support": "التواصل مع الدعم",
      "retry": "حاول مرة أخرى",
      "importHint": "بعد التأكيد، يستورد تلاق المنتجات والمخزون ثم الطلبات الحديثة. يمكنك متابعة التقدم قبل فتح القنوات.",
      "authHint": "تُحفظ الدعوة أثناء تسجيل الدخول. بعد تأكيد المالك، يمكنك متابعة أول استيراد.",
      "privacyHint": "حفاظًا على أمانك، لا تُعرض بيانات المتجر هنا."
    },
    "sallaOAuth": {
      "submitting": {
        "title": "جارٍ إنهاء ربط سلة",
        "body": "نتبادل رمز التفويض مع سلة. عادةً تستغرق العملية ثوانٍ قليلة."
      },
      "error": {
        "title": "تعذّر إنهاء ربط سلة",
        "back": "العودة إلى القنوات"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "تعذّر إنهاء ربط سلة. حاول لاحقاً.",
          "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لإنهاء ربط سلة.",
          "CHANNEL_OAUTH_STATE_INVALID": "انتهت صلاحية رابط الربط أو سبق استخدامه. ابدأ عملية الربط من جديد من القنوات.",
          "CHANNEL_OAUTH_CALLBACK_FAILED": "رفضت سلة إكمال الربط. حاول الربط مرة أخرى.",
          "CHANNEL_CONNECTION_NOT_FOUND": "تعذّر العثور على ربط القناة الذي بدأ هذه العملية.",
          "CHANNEL_CONNECT_FAILED": "تعذّر بدء ربط سلة. حاول مرة أخرى من القنوات.",
          "CHANNEL_AUTH_EXPIRED": "انتهى تفويض سلة. ابدأ عملية ربط جديدة.",
          "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "متجر سلة هذا مرتبط بالفعل بمؤسسة أخرى في تلاق.",
          "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "ما زلنا ننشئ مهمة الاستيراد. أبقِ هذه الصفحة مفتوحة قليلاً.",
          "CHANNEL_ONBOARDING_INCOMPLETE": "مهمة الاستيراد ليست جاهزة لإعادة المحاولة بعد.",
          "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "تعذّرت جدولة مهمة الاستيراد. جرّب إعادة المحاولة من هذه الصفحة."
        }
      },
      "success": {
        "title": "تم ربط سلة",
        "bodyShort": "تم ربط متجرك. تابع أول استيراد أدناه أو انتقل إلى القنوات.",
        "back": "الانتقال إلى القنوات"
      },
      "import": {
        "title": "أول استيراد من سلة",
        "subtitle": "تُستورد المنتجات والمخزون أولًا، ثم الطلبات الحديثة.",
        "queuedTitle": "يجري تجهيز الاستيراد",
        "queuedBody": "اكتمل الربط. ننتظر ظهور مهمة الاستيراد وسنحدّث هذه الشاشة تلقائياً.",
        "products": "المنتجات والمخزون",
        "orders": "الطلبات الحديثة",
        "retry": "إعادة الاستيراد",
        "retrying": "جارٍ إعادة المحاولة…",
        "refreshFailed": "تعذّر تحديث تقدم الاستيراد. سنواصل المحاولة.",
        "issueCount": "{{count}} منتجات تحتاج مراجعة بعد الاستيراد.",
        "errors": {
          "CHANNEL_APP_SUBSCRIPTION_INACTIVE": "تم ربط متجرك، لكن لم يتمكّن تلاق من تأكيد وجود اشتراك نشط لتطبيق سلة، لذلك لا يمكن متابعة الاستيراد الآن. تحقّق من اشتراك سلة ثم أعد المحاولة.",
          "generic": "تعذّر متابعة الاستيراد. حاول مرة أخرى أو تواصل مع الدعم إذا استمرت المشكلة."
        },
        "status": {
          "QUEUED": "في الانتظار",
          "RUNNING": "جارٍ",
          "COMPLETED": "مكتمل",
          "COMPLETED_WITH_ISSUES": "مكتمل مع مشكلات",
          "FAILED": "فشل"
        },
        "stepStatus": {
          "PENDING": "بانتظار",
          "RUNNING": "جارٍ",
          "SUCCEEDED": "تم",
          "SUCCEEDED_WITH_ISSUES": "تم مع مشكلات",
          "FAILED": "فشل",
          "SKIPPED": "تم التخطي"
        },
        "counters": {
          "products": "المنتجات",
          "stock": "صفوف المخزون",
          "orders": "الطلبات"
        }
      },
      "footer": {
        "security": "تسليم OAuth آمن من سلة."
      }
    },
    "amazonOAuth": {
      "submitting": {
        "title": "جارٍ إنهاء ربط أمازون",
        "body": "نتبادل رمز تفويض SP-API مع أمازون. عادةً تستغرق العملية ثوانٍ قليلة."
      },
      "error": {
        "title": "تعذّر إنهاء ربط أمازون",
        "back": "العودة إلى القنوات"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "تعذّر إنهاء ربط أمازون. حاول لاحقاً.",
          "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لإنهاء ربط أمازون.",
          "CHANNEL_PROVIDER_UNSUPPORTED": "وصول أمازون التجريبي غير مفعّل لهذه المساحة أو لهذا البائع.",
          "CHANNEL_OAUTH_STATE_INVALID": "انتهت صلاحية رابط الربط أو سبق استخدامه. ابدأ عملية الربط من جديد من القنوات.",
          "CHANNEL_OAUTH_CALLBACK_FAILED": "رفضت أمازون إكمال الربط. حاول الربط مرة أخرى.",
          "CHANNEL_CONNECTION_NOT_FOUND": "تعذّر العثور على ربط القناة الذي بدأ هذه العملية.",
          "CHANNEL_CONNECT_FAILED": "تعذّر بدء ربط أمازون. حاول مرة أخرى من القنوات.",
          "CHANNEL_AUTH_EXPIRED": "انتهى تفويض أمازون. ابدأ عملية ربط جديدة.",
          "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "حساب بائع أمازون هذا مرتبط بالفعل بمؤسسة أخرى في تلاق.",
          "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "ما زلنا ننشئ مهمة الاستيراد. أبقِ هذه الصفحة مفتوحة قليلاً.",
          "CHANNEL_ONBOARDING_INCOMPLETE": "مهمة الاستيراد ليست جاهزة لإعادة المحاولة بعد.",
          "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "تعذّرت جدولة مهمة الاستيراد. جرّب إعادة المحاولة من هذه الصفحة."
        }
      },
      "success": {
        "title": "تم ربط أمازون",
        "bodyShort": "تم ربط حساب بائع أمازون بتلاق. يمكنك إدارته من القنوات.",
        "back": "العودة إلى اللوحة"
      },
      "import": {
        "title": "أول استيراد من أمازون",
        "subtitle": "يستورد تلاق القوائم ورؤوس الطلبات الحديثة في الخلفية.",
        "queuedTitle": "يجري تجهيز الاستيراد",
        "queuedBody": "اكتمل الربط. ننتظر ظهور مهمة الاستيراد وسنحدّث هذه الشاشة تلقائياً.",
        "products": "المنتجات والقوائم",
        "orders": "الطلبات الحديثة",
        "retry": "إعادة الاستيراد",
        "retrying": "جارٍ إعادة المحاولة…",
        "refreshFailed": "تعذّر تحديث تقدم الاستيراد. سنواصل المحاولة.",
        "issueCount": "{{count}} منتجات تحتاج مراجعة بعد الاستيراد.",
        "status": {
          "QUEUED": "في الانتظار",
          "RUNNING": "جارٍ",
          "COMPLETED": "مكتمل",
          "COMPLETED_WITH_ISSUES": "مكتمل مع مشكلات",
          "FAILED": "فشل"
        },
        "stepStatus": {
          "PENDING": "بانتظار",
          "RUNNING": "جارٍ",
          "SUCCEEDED": "تم",
          "SUCCEEDED_WITH_ISSUES": "تم مع مشكلات",
          "FAILED": "فشل",
          "SKIPPED": "تم التخطي"
        },
        "counters": {
          "products": "القوائم",
          "orders": "الطلبات"
        }
      },
      "footer": {
        "security": "تسليم SP-API OAuth آمن من أمازون."
      }
    },
    "sallaEmail": {
      "tabs": {
        "welcome": "الترحيب",
        "reminder": "تذكير",
        "report": "تقرير"
      },
      "meta": {
        "welcome": {
          "subject": "🎉 Tlaaq is wired up — let's connect your other stores",
          "when": "Sent immediately on install"
        },
        "reminder": {
          "subject": "Your Salla store is live on Tlaaq, but it's lonely",
          "when": "Sent 48h after install if no other channels"
        },
        "report": {
          "subject": "Week one on Tlaaq: 247 orders, zero oversells",
          "when": "Sent 7 days after first sync"
        }
      },
      "previewMode": "وضع المعاينة",
      "from": "من: {{email}}",
      "common": {
        "hiSara": "مرحباً سارة",
        "hiSaraPlain": "مرحباً سارة"
      },
      "actions": {
        "connect": "ربط ←",
        "connectPlain": "ربط",
        "openTlaaq": "فتح تلاق",
        "openOneClick": "فتح تلاق · ربط بنقرة واحدة ←",
        "fullReport": "عرض التقرير الكامل ←"
      },
      "channels": {
        "noonDesc": "Saudi Arabia · noon.com",
        "amazonDesc": "Saudi marketplace · amazon.sa",
        "zidDesc": "Saudi storefront · zid.sa",
        "trendyolDesc": "Saudi marketplace · trendyol.com"
      },
      "welcome": {
        "heroLine1": "تم ربط سلة.",
        "heroLine2": "لنضف متاجرك الأخرى.",
        "heroBodyPrefix": "أنهى تلاق مزامنة كتالوج سلة لديك.",
        "imported": "تم استيراد 1,847 منتجاً",
        "heroBodySuffix": "وأصبح المخزون تحت مراقبتنا.",
        "next2Minutes": "الدقيقتان التاليتان",
        "connectSecondChannel": "اربط قناة ثانية — نقرة واحدة لكل قناة",
        "openWorkspace": "افتح مساحة عمل تلاق",
        "workspaceHint": "رابط موقّع مسبقاً · صالح 7 أيام · لا حاجة لتعيين كلمة مرور",
        "whatWeDid": "ما أنجزناه لك",
        "checks": {
          "imported": "Imported 1,847 products from Salla",
          "mapped": "Mapped all SKUs · auto-matched 100% on first pass",
          "watching": "Started watching Salla stock for changes",
          "bundled": "Bundled Tlaaq into your Salla bill — no extra invoice"
        }
      },
      "footer": {
        "help": "تحتاج مساعدة لربط متجر آخر؟",
        "reply": "رد على هذا البريد",
        "walkthrough": "أو احجز جولة 15 دقيقة.",
        "riyadh": "الرياض",
        "unsubscribe": "إلغاء الاشتراك"
      },
      "reminder": {
        "title": "متجر سلة لديك يعمل على تلاق. لكنه الوحيد.",
        "bodyPrefix": "هدف تلاق هو إبقاء المخزون متزامناً عبر",
        "multiple": "عدة",
        "bodySuffix": "قنوات. حالياً ربطت سلة فقط.",
        "pickChannel": "اختر القناة التي تسبب أكثر إلغاءات:",
        "amazonDesc": "Highest oversell penalty",
        "noonDesc": "Fastest growing in KSA",
        "zidDesc": "If you have a second storefront",
        "trendyolDesc": "Strong in fashion & home",
        "headsUp": "تنبيه:",
        "headsUpBody": "if you don't connect a second channel within 14 days, your Salla bundle continues but Tlaaq won't really earn its keep.",
        "tellUsWhy": "أخبرنا بالسبب",
        "improve": "هذا يساعدنا على التحسين.",
        "reason": "You are getting this because you installed Tlaaq from Salla 48 hours ago."
      },
      "report": {
        "title": "الأسبوع الأول: 247 طلباً، بلا بيع زائد.",
        "body": "مرحباً سارة، هذا ما أنجزه تلاق لك عبر سلة ونون وأمازون منذ الاثنين.",
        "stats": {
          "orders": "طلبات متزامنة",
          "stock": "تحديثات مخزون مدفوعة",
          "oversells": "حوادث بيع زائد"
        },
        "byChannel": "حسب القناة",
        "schedule": "يرسل كل اثنين الساعة 9 صباحاً بتوقيت السعودية.",
        "switchMonthly": "التحويل إلى شهري"
      },
      "trigger": {
        "prefix": "تم تشغيله بواسطة webhook من سلة",
        "suffix": "لا يوجد تحويل متصفح؛ يبقى التاجر على سلة"
      }
    },
    "productForm": {
      "createTitle": "إنشاء منتج",
      "editTitle": "تعديل المنتج",
      "subtitle": "احفظ SKU الرئيسي والسعر والضريبة والوزن ومفاتيح الصور التي ستستخدمها مزامنة القنوات لاحقاً.",
      "loading": "جاري تحميل المنتج…",
      "sections": {
        "master": "البيانات الرئيسية",
        "images": "الصور"
      },
      "fields": {
        "sku": "SKU",
        "name": "الاسم",
        "description": "الوصف",
        "descriptionPlaceholder": "اكتب وصفاً للمنتج في الكتالوج الداخلي.",
        "status": "الحالة",
        "price": "السعر",
        "cost": "التكلفة",
        "salePrice": "سعر التخفيض",
        "weightGrams": "الوزن",
        "taxRate": "نسبة الضريبة"
      },
      "units": {
        "sar": "ر.س",
        "grams": "غ",
        "percent": "٪"
      },
      "actions": {
        "cancel": "إلغاء",
        "create": "إنشاء المنتج",
        "save": "حفظ التغييرات",
        "saving": "جاري الحفظ…"
      },
      "validation": {
        "required": "SKU والاسم مطلوبان.",
        "altSkuUnique": "يجب أن يكون كل SKU فريداً."
      },
      "altSkus": {
        "title": "رموز SKU إضافية",
        "add": "إضافة SKU آخر",
        "remove": "إزالة",
        "placeholder": "SKU بديل مستخدم في قناة أخرى"
      },
      "images": {
        "dropTitle": "اسحب الصور هنا",
        "helper": "JPEG أو PNG أو WebP حتى 5 م.ب. يتم الرفع مباشرة إلى التخزين.",
        "fileInput": "رفع صور المنتج",
        "chooseFiles": "اختيار ملفات",
        "uploading": "جاري الرفع…",
        "empty": "لم يتم رفع صور بعد.",
        "altText": "النص البديل",
        "primary": "رئيسية",
        "setPrimary": "اجعلها رئيسية",
        "moveUp": "تحريك للأعلى",
        "moveDown": "تحريك للأسفل",
        "remove": "إزالة",
        "errors": {
          "PRODUCT_IMAGE_TYPE_UNSUPPORTED": "استخدم صورة JPEG أو PNG أو WebP.",
          "PRODUCT_IMAGE_TOO_LARGE": "الصورة أكبر من 5 م.ب.",
          "uploadFailed": "فشل رفع الصورة. حاول مرة أخرى."
        }
      }
    },
    "zohoOAuth": {
      "submitting": {
        "title": "جاري ربط Zoho Inventory",
        "body": "نراجع رمز التفويض من Zoho ونحفظ بيانات الاعتماد بشكل مشفر."
      },
      "success": {
        "title": "تم ربط Zoho Inventory",
        "body": "يمكن لتلاق الآن سحب المنتجات والمستودعات والمخزون من Zoho وإرسال أوامر البيع أو الفواتير.",
        "back": "العودة إلى إعداد Zoho"
      },
      "error": {
        "title": "فشل ربط Zoho",
        "back": "العودة إلى إعداد Zoho"
      },
      "footer": {
        "security": "رموز OAuth مشفرة عند التخزين ولا تظهر في المتصفح."
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "تعذر إكمال رجوع Zoho. حاول الربط مرة أخرى.",
          "INVENTORY_OAUTH_CALLBACK_FAILED": "رفض Zoho الرجوع أو أعاد استجابة ناقصة.",
          "INVENTORY_OAUTH_STATE_INVALID": "انتهت جلسة ربط Zoho. ابدأ الربط مرة أخرى.",
          "INVENTORY_CONNECT_FAILED": "تعذر الاتصال بـ Zoho. تحقق من إعدادات OAuth.",
          "INVENTORY_EXTERNAL_ACCOUNT_CONFLICT": "هذا الربط في تلاق مرتبط بمؤسسة Zoho مختلفة بالفعل."
        }
      }
    },
    "inventoryZohoPullRunDetail": {
      "back": "العودة إلى Zoho",
      "title": "تفاصيل سحب Zoho",
      "subtitle": "راجع مشكلات العناصر والصفوف المتخطاة وفشل التشغيل في سحب المنتجات هذا.",
      "runId": "التشغيل #{{id}}",
      "loading": "جارٍ تحميل تفاصيل السحب…",
      "notAvailable": "—",
      "missing": {
        "title": "اختر تشغيل سحب أولاً",
        "body": "افتح Zoho Inventory واختر عرض تفاصيل السحب من عملية مكتملة أو فاشلة."
      },
      "stats": {
        "fetched": "تم الجلب",
        "products": "المنتجات المتغيرة",
        "skipped": "الصفوف المتخطاة",
        "issues": "المشكلات",
        "pages": "الصفحات: {{count}}",
        "productsBody": "أُنشئ {{created}} · حُدّث {{updated}}",
        "skippedBody": "{{products}} منتجات · {{stock}} صفوف مخزون",
        "updated": "آخر تحديث {{date}}"
      },
      "groups": {
        "title": "أسباب المشكلات",
        "subtitle": "مجمعة على مستوى التشغيل بالكامل. اختر سبباً لتصفية الصفوف أدناه.",
        "allReasons": "كل الأسباب",
        "reasonFilter": "{{reason}} ({{count}})",
        "empty": "لم تُسجل أسباب على مستوى العناصر لهذا التشغيل.",
        "sample": "مثال SKU {{sku}} · العنصر {{external}}",
        "count": "العناصر: {{count}}"
      },
      "items": {
        "title": "صفوف المشكلات",
        "subtitle": "تُرتب الصفوف حسب صفحة السحب وترتيب المشكلة في نتيجة Zoho.",
        "searchPlaceholder": "ابحث عن SKU أو معرّف عنصر Zoho…",
        "search": "بحث"
      },
      "table": {
        "reason": "السبب",
        "sku": "SKU",
        "externalProductId": "معرّف عنصر Zoho",
        "page": "الصفحة",
        "row": "الصف"
      },
      "pagination": {
        "range": "عرض {{start}}–{{end}} من {{total}}",
        "page": "صفحة {{page}} من {{totalPages}}",
        "previous": "السابق",
        "next": "التالي"
      },
      "empty": {
        "historicalTitle": "لم تُسجل تفاصيل لهذا التشغيل",
        "historicalBody": "يحتوي هذا التشغيل القديم على عدادات تخطي أو مشكلات، لكن تسجيل التفاصيل على مستوى العناصر لم يكن متاحاً حينها.",
        "cleanTitle": "لا توجد مشكلات على مستوى العناصر",
        "cleanBody": "اكتمل هذا التشغيل دون صفوف مشكلات مسجلة.",
        "filteredTitle": "لا توجد صفوف مطابقة",
        "filteredBody": "غيّر مرشح السبب أو عبارة البحث لعرض المزيد من الصفوف.",
        "failedNoItemsTitle": "لم تُسجل مشكلات على مستوى العناصر",
        "failedNoItemsBody": "توقف هذا التشغيل قبل أن يعيد Zoho صفوف عناصر تحتوي على تفاصيل مشكلات. استخدم إرشادات الفشل أعلاه، ثم ابدأ سحباً جديداً بعد إصلاح المشكلة."
      },
      "errors": {
        "REQUEST_FAILED": "تعذّر تحميل تفاصيل السحب. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لعرض تفاصيل السحب.",
        "INVENTORY_CONNECTION_NOT_FOUND": "لم يتم العثور على ربط Zoho هذا."
      },
      "issueCodes": {
        "INVALID_SKU": {
          "title": "SKU غير صالح",
          "action": "صحح رمز SKU في Zoho حتى يصبح صالحاً في تلاق، ثم أعد تشغيل السحب."
        },
        "MISSING_SKU": {
          "title": "SKU مفقود",
          "action": "أضف SKU إلى عنصر Zoho قبل استيراده إلى تلاق."
        },
        "MISSING_EXTERNAL_ITEM_ID": {
          "title": "معرّف عنصر Zoho مفقود",
          "action": "لم يرسل Zoho معرّف عنصر ثابتاً. حدّث العنصر في المصدر ثم أعد السحب."
        },
        "DUPLICATE_PROVIDER_SKU": {
          "title": "SKU مكرر في المصدر",
          "action": "يوجد عنصران أو أكثر في Zoho بنفس SKU. اجعل كل SKU فريداً قبل الاستيراد."
        },
        "PRODUCT_UNMAPPED_LISTINGS_ONLY": {
          "title": "لا يوجد منتج مطابق في وضع الربط فقط",
          "action": "تم ضبط هذا التشغيل لربط المنتجات الموجودة فقط. أنشئ المنتج أو استورده ثم أعد التشغيل."
        },
        "PRODUCT_MAPPING_CONFLICT": {
          "title": "تعارض في ربط المنتج",
          "action": "هذا العنصر من Zoho مربوط بمنتج آخر. راجع الربط الحالي قبل إعادة التشغيل."
        },
        "PRODUCT_MAPPING_PRIMARY_SKU_CONFLICT": {
          "title": "تعارض ربط SKU الأساسي",
          "action": "هذا العنصر من Zoho مربوط بمنتج له SKU أساسي مختلف. راجع الربط قبل إعادة التشغيل."
        },
        "SKU_CONFLICT": {
          "title": "SKU يخص منتجاً آخر",
          "action": "غيّر SKU أو ادمج سجلات المنتجات المحلية قبل إعادة السحب."
        },
        "ZOHO_IMAGE_NOT_FOUND": {
          "title": "صورة Zoho غير موجودة",
          "action": "أعاد Zoho رابط صورة لم يعد موجوداً. حدّث الصورة في Zoho إن كانت مطلوبة."
        },
        "ZOHO_IMAGE_NOT_ACCEPTABLE": {
          "title": "تعذّر تنزيل صورة Zoho",
          "action": "رفض Zoho تنزيل الصورة. استبدل الصورة في Zoho أو ارفعها يدوياً في تلاق."
        },
        "PRODUCT_IMAGE_TOO_LARGE": {
          "title": "صورة المنتج كبيرة جداً",
          "action": "استخدم صورة أصغر في Zoho أو ارفع نسخة مضغوطة في تلاق."
        },
        "ZOHO_IMAGE_EMPTY": {
          "title": "صورة Zoho فارغة",
          "action": "أعاد Zoho ملف صورة فارغاً. استبدل الصورة في Zoho ثم أعد السحب."
        },
        "STOCK_PRODUCT_UNMAPPED": {
          "title": "منتج المخزون غير مربوط",
          "action": "تعذّر استيراد المخزون لأن عنصر Zoho غير مربوط بمنتج محلي."
        },
        "DUPLICATE_PROVIDER_SKU_STOCK_SKIPPED": {
          "title": "تخطي المخزون بسبب SKU مكرر",
          "action": "حل تكرار SKU في Zoho قبل استيراد مخزون هذا العنصر."
        },
        "DUPLICATE_PRODUCT_STOCK_SKIPPED": {
          "title": "تخطي المخزون بسبب منتج ملتبس",
          "action": "طابق أكثر من منتج محلي هذا SKU. حدد المنتج الصحيح قبل استيراد المخزون."
        },
        "MISSING_STOCK_LOCATION": {
          "title": "موقع المخزون مفقود",
          "action": "يوجد صف مخزون بلا موقع Zoho. أضف الموقع في Zoho قبل إعادة التشغيل."
        },
        "DUPLICATE_STOCK_LOCATION_SKIPPED": {
          "title": "تم تخطي موقع مخزون مكرر",
          "action": "أرسل Zoho أكثر من صف مخزون للموقع نفسه. أبقِ صفاً واحداً لكل موقع."
        },
        "INFINITE_STOCK_UNSUPPORTED": {
          "title": "المخزون غير المحدود غير مدعوم",
          "action": "يستورد تلاق الكميات المحددة فقط. استبدل المخزون غير المحدود بكمية في Zoho."
        },
        "MISSING_STOCK_QUANTITY": {
          "title": "كمية المخزون مفقودة",
          "action": "أضف كمية متاحة في صف مخزون Zoho قبل استيراده."
        },
        "NEGATIVE_STOCK_CLAMPED": {
          "title": "تم تصفير المخزون السالب",
          "action": "استورد تلاق صف المخزون لكنه حوّل الكميات السالبة إلى صفر."
        },
        "INVALID_ADDITIONAL_SKU": {
          "title": "SKU إضافي غير صالح",
          "action": "نظّف قيمة SKU الإضافية في Zoho قبل استيراد الأسماء البديلة."
        },
        "ADDITIONAL_SKU_PRODUCT_CONFLICT": {
          "title": "SKU إضافي يتعارض مع منتج",
          "action": "هذا الاسم البديل يخص منتجاً آخر. أزل التعارض قبل إعادة التشغيل."
        },
        "ADDITIONAL_SKU_AMBIGUOUS": {
          "title": "SKU إضافي ملتبس",
          "action": "طابق أكثر من منتج محلي SKU إضافياً. حل تكرار الاسم البديل أولاً."
        },
        "ADDITIONAL_SKU_CONFLICT": {
          "title": "تعارض SKU إضافي",
          "action": "تعذّر حفظ SKU الإضافي. راجع الأسماء البديلة الموجودة ثم أعد التشغيل."
        },
        "UNKNOWN": {
          "title": "مشكلة غير معروفة",
          "action": "راجع عنصر Zoho وأعد السحب. إن استمرت المشكلة، تواصل مع الدعم مرفقاً رمز السبب."
        }
      },
      "failureCodes": {
        "INVENTORY_CONNECTION_NOT_FOUND": {
          "title": "لم يتم العثور على ربط Zoho",
          "action": "ارجع إلى المخزون وأعد ربط Zoho قبل تشغيل سحب جديد."
        },
        "INVENTORY_CONNECTION_NOT_CONFIGURED": {
          "title": "ربط Zoho غير مكتمل",
          "action": "أكمل تفويض Zoho قبل إعادة تشغيل سحب المنتجات."
        },
        "INVENTORY_AUTH_EXPIRED": {
          "title": "انتهت صلاحية تفويض Zoho",
          "action": "جدّد تفويض Zoho، ثم ابدأ سحباً جديداً للمنتجات والمخزون."
        },
        "INVENTORY_PRODUCT_PULL_SOURCE_MISMATCH": {
          "title": "مصدر المنتجات غير متوافق",
          "action": "اجعل Zoho مصدر كتالوج المنتجات أو اختر وضع سحب يناسب المصدر الحالي."
        },
        "INVENTORY_STOCK_PULL_SOURCE_MISMATCH": {
          "title": "مصدر المخزون غير متوافق",
          "action": "اجعل Zoho مصدر المخزون قبل استيراد لقطات مخزون Zoho."
        },
        "INVENTORY_PULL_FAILED": {
          "title": "فشل سحب Zoho",
          "action": "لم يكتمل السحب من Zoho. أعد المحاولة لاحقاً وتحقق من حالة Zoho إن تكرر الفشل."
        },
        "INVENTORY_RATE_LIMITED": {
          "title": "قيّد Zoho معدل السحب",
          "action": "سيعيد تلاق محاولة السحب المحدود تلقائياً. ابدأ سحباً جديداً فقط بعد انتهاء فترة الانتظار."
        },
        "INVENTORY_ADAPTER_NOT_REGISTERED": {
          "title": "موصل Zoho غير متاح",
          "action": "تكامل Zoho غير متاح في هذه البيئة. تواصل مع الدعم."
        },
        "INVENTORY_PROVIDER_UNSUPPORTED": {
          "title": "مزود المخزون غير مدعوم",
          "action": "يشير هذا التشغيل إلى مزود لا يستطيع تلاق سحب المخزون منه."
        },
        "REQUEST_FAILED": {
          "title": "تعذّر تحميل تفاصيل السحب",
          "action": "حدّث الصفحة أو حاول مرة أخرى بعد بضع دقائق."
        },
        "UNAUTHORIZED": {
          "title": "انتهت الجلسة",
          "action": "سجّل الدخول مرة أخرى لعرض هذا التشغيل."
        },
        "UNKNOWN": {
          "title": "فشل السحب",
          "action": "راجع رمز الخطأ وأعد السحب. إذا تكرر، تواصل مع الدعم.",
          "code": "UNKNOWN_ERROR"
        }
      }
    }
  },
  "stockAllocation": {
    "title": "قواعد توزيع المخزون",
    "description": "اختر مستودعات تلاق التي تغذي كل متجر زد أو سلة أو نون FBPI متصل والنسبة التي تُنشر من هذه المستودعات والمنتجات التي يجب أن تتجاوزها الأتمتة. يبقى الدفع اليدوي للمخزون من تفاصيل المنتج كما هو.",
    "workspaceTitle": "توزيع المخزون",
    "workspaceDescription": "أدر قواعد التوزيع وراجع كل تحديث آلي للمخزون.",
    "tabs": {
      "label": "أقسام توزيع المخزون",
      "rules": "القواعد",
      "activity": "النشاط"
    },
    "loading": "جارٍ تحميل قواعد توزيع المخزون…",
    "emptyWarehouses": "لم يتم اختيار مستودعات",
    "emptyPercent": "غير محددة",
    "unknownWarehouse": "المستودع #{{id}}",
    "noWarehouses": "لا توجد مستودعات بعد. أنشئ مستودعات قبل تفعيل أتمتة التوزيع.",
    "summary": "المسودة الحالية: {{percent}}٪ من {{warehouses}}.",
    "saved": "تم حفظ قاعدة توزيع المخزون لـ {{name}}.",
    "status": {
      "enabled": "مفعّلة",
      "disabled": "معطّلة"
    },
    "actions": {
      "back": "العودة إلى القنوات",
      "saveFor": "حفظ {{name}}",
      "saving": "جارٍ الحفظ…"
    },
    "fields": {
      "enabled": "الأتمتة",
      "enabledAria": "تبديل التوزيع لـ {{name}}",
      "percent": "نسبة التوزيع",
      "percentAria": "نسبة التوزيع لـ {{name}}",
      "percentSuffix": "٪",
      "percentHint": "يدفع تلاق ناتج floor(توفر المستودعات المختارة × هذه النسبة).",
      "targetSallaBranch": "فرع سلة المستهدف",
      "targetSallaBranchAria": "فرع سلة المستهدف لـ {{name}}",
      "targetSallaBranchPlaceholder": "اختر الفرع",
      "targetSallaBranchHint": "اختر فرعًا مرصودًا في قوائم سلة لاستقبال المخزون من مستودعات تلاق المحددة. لا يتطلب التوزيع ربط موقع داخلي.",
      "targetSallaBranchEmpty": "لم تُرصد فروع لهذا المتجر. اجلب مخزون قوائم سلة أو حدّثه ثم أعد تحميل هذه الصفحة.",
      "targetSallaBranchUnavailable": "الفرع المحدد سابقًا غير متاح — اختر فرعًا آخر",
      "warehouses": "المستودعات"
    },
    "availability": {
      "ready": "يمكن لهذه القناة المتصلة استقبال المخزون الموزع من تلاق.",
      "noonReady": "يرسل التوزيع جميع رموز المنتجات المحلية النشطة إلى مستودع FBPI المحدد في إعدادات قناة نون. يجب أن تطابق رموز SKU رموز الشريك في نون. مستودعات FBN غير مدعومة.",
      "unsupported": "توزيع المخزون غير مدعوم لـ {{provider}} بعد. المزودون المدعومون هم زد وسلة ونون FBPI.",
      "disconnected": "اربط هذه القناة قبل تفعيل توزيع المخزون. الحالة الحالية: {{status}}.",
      "sourceOwned": "هذه القناة تملك المخزون، لذلك لا يدفع تلاق المخزون إليها. حوّل مصدر المخزون إلى تلاق قبل تفعيل التوزيع."
    },
    "overAllocation": {
      "title": "توزيع المستودع يتجاوز 100٪",
      "body": "هذه المستودعات تتجاوز الحد لكل مستودع: {{warehouses}}. عدّل النسب قبل الاعتماد على الأتمتة.",
      "warehouseTotal": "إجمالي التوزيع المحدد: {{total}}٪",
      "selectedWarning": "واحد أو أكثر من المستودعات المحددة يتجاوز حد 100٪."
    },
    "exclusions": {
      "title": "المنتجات المستثناة",
      "hint": "ستتجاوز الأتمتة هذه المنتجات المدرجة في القناة. يبقى الدفع اليدوي للمخزون من تفاصيل المنتج متاحاً.",
      "noonHint": "ستتجاوز الأتمتة هذه المنتجات المحلية في ربط نون هذا. يبقى الدفع اليدوي للمخزون من تفاصيل المنتج متاحاً.",
      "noonSearchLabel": "البحث في المنتجات المحلية",
      "noonNoResults": "لا توجد منتجات محلية تطابق هذا البحث.",
      "empty": "لا توجد منتجات مستثناة من هذه القناة بعد.",
      "unknownProduct": "المنتج #{{id}}",
      "unknownSku": "SKU غير متاح",
      "searchLabel": "البحث في منتجات القناة",
      "searchAria": "البحث عن منتجات لاستثنائها لـ {{name}}",
      "searchPlaceholder": "ابحث باسم المنتج أو SKU",
      "search": "بحث",
      "searching": "جارٍ البحث…",
      "searchError": "تعذّر البحث عن منتجات هذه القناة. حاول مرة أخرى.",
      "noResults": "لا توجد منتجات مدرجة في القناة تطابق هذا البحث.",
      "add": "إضافة",
      "addAria": "إضافة {{name}} إلى المنتجات المستثناة",
      "selected": "محدد",
      "selectedAria": "{{name}} محدد مسبقاً للاستثناء",
      "remove": "إزالة",
      "removeAria": "إزالة {{name}} من المنتجات المستثناة"
    },
    "empty": {
      "title": "لا توجد روابط قنوات بعد",
      "body": "أنشئ واربط قناة زد أو سلة أو نون FBPI قبل إعداد توزيع المخزون."
    },
    "activity": {
      "loading": "جارٍ تحميل نشاط توزيع المخزون…",
      "error": "تعذّر تحميل نشاط توزيع المخزون.",
      "tryAgain": "حاول مرة أخرى",
      "runLabel": "تشغيل المزامنة",
      "partialTitle": "تم الإرسال جزئياً إلى {{provider}}",
      "failedTitle": "فشلت مزامنة المخزون مع {{provider}}",
      "successTitle": "تم إرسال المخزون إلى {{provider}}",
      "progress": "تم إرسال {{percent}}٪ بنجاح. قبول الطلب لا يؤكد مخزون القناة. أصلح المنتجات المرفوضة ثم أعد محاولة هذه العناصر فقط.",
      "download": "تنزيل التقرير",
      "retry": "إعادة المنتجات الفاشلة",
      "retrying": "جارٍ إعادة المحاولة…",
      "retryAccepted": "اكتمل تشغيل الإعادة #{{id}} وتم تحديد نتائجه.",
      "retryFailed": "تعذّرت إعادة المنتجات الفاشلة. تحقق من ربط القناة وحاول مجدداً.",
      "downloadFailed": "تعذّر تنزيل التقرير. حاول مجدداً.",
      "status": { "RUNNING": "قيد التشغيل", "SUCCEEDED": "تم قبول الطلب", "PARTIAL_FAILURE": "تحتاج مراجعة", "FAILED": "فشلت" },
      "trigger": { "RULE_SAVED": "حفظ القاعدة", "STOCK_UPDATED": "تحديث المخزون", "CHANNEL_ORDER_STOCK_CHANGED": "طلب قناة غيّر المخزون", "INVENTORY_IMPORT": "استيراد المخزون", "ZOHO_ORDER_STOCK_RECONCILIATION": "مطابقة طلب Zoho", "FAILED_ITEMS_RETRY": "إعادة المنتجات الفاشلة" },
      "metrics": { "attempted": "تمت المحاولة", "pushed": "تم الإرسال", "failed": "تحتاج مراجعة", "skipped": "تم التجاوز" },
      "empty": { "title": "لا يوجد نشاط مزامنة بعد", "body": "ستظهر التشغيلات هنا بعد أن تنشر قاعدة توزيع مفعّلة المخزون." },
      "items": {
        "title": "منتجات تحتاج إلى مراجعة", "count": "{{count}} منتج فاشل", "count_plural": "{{count}} منتجات فاشلة", "search": "البحث بالمنتج أو SKU", "reason": "السبب", "allReasons": "كل الأسباب", "product": "المنتج", "sku": "SKU", "quantity": "الكمية المطلوبة", "action": "الإجراء", "viewProduct": "عرض المنتج", "noMatches": "لا توجد منتجات فاشلة تطابق هذه الفلاتر.", "previous": "السابق", "next": "التالي", "page": "صفحة {{page}} من {{pages}}"
      },
      "reasons": { "SKU_NOT_FOUND": "غير موجود في القناة المتصلة", "PROVIDER_ERROR": "رفض المزود هذا التحديث", "UNEXPECTED_ERROR": "استجابة غير متوقعة من المزود", "UNKNOWN": "استجابة مزود غير معروفة" }
    },
    "errors": {
      "codes": {
        "NOON_FBPI_WAREHOUSE_REQUIRED": "حدد مستودع FBPI في إعدادات قناة نون قبل تفعيل التوزيع.",
        "REQUEST_FAILED": "تعذّر تحديث قواعد توزيع المخزون. حاول مرة أخرى.",
        "UNAUTHORIZED": "انتهت جلستك. سجّل الدخول مرة أخرى لإدارة توزيع المخزون.",
        "CHANNEL_STOCK_ALLOCATION_UNAVAILABLE": "لا يمكن تفعيل هذه القناة لتوزيع المخزون.",
        "CHANNEL_STOCK_ALLOCATION_PERCENT_INVALID": "أدخل نسبة توزيع من 0 إلى 100.",
        "CHANNEL_STOCK_ALLOCATION_WAREHOUSES_REQUIRED": "اختر مستودعاً واحداً على الأقل قبل تفعيل التوزيع.",
        "CHANNEL_STOCK_ALLOCATION_TARGET_LOCATION_REQUIRED": "اختر فرع سلة الهدف قبل تفعيل التوزيع.",
        "CHANNEL_STOCK_ALLOCATION_CAP_EXCEEDED": "أحد المستودعات موزع بأكثر من 100٪. خفّض قاعدة أخرى أو هذه النسبة قبل الحفظ.",
        "CHANNEL_STOCK_ALLOCATION_EXCLUDED_PRODUCT_NOT_FOUND": "لم يتم العثور على أحد المنتجات المستثناة. أزله وابحث عنه من جديد قبل الحفظ.",
        "CHANNEL_STOCK_ALLOCATION_EXCLUDED_PRODUCT_NOT_LISTED": "أحد المنتجات المستثناة لم يعد مدرجاً في هذه القناة. أزله وابحث عنه من جديد قبل الحفظ.",
        "CHANNEL_CONNECTION_NOT_FOUND": "لم يتم العثور على ربط القناة هذا.",
        "CHANNEL_AUTH_EXPIRED": "انتهى تفويض القناة. أعد الربط للمتابعة.",
        "CHANNEL_STOCK_PUSH_SOURCE_CONNECTION": "هذه القناة تملك المخزون، لذلك لا يستطيع تلاق الدفع إليها.",
        "CHANNEL_STOCK_PUSH_UNSUPPORTED": "دفع المخزون غير مدعوم لهذا المزود بعد."
      }
    }
  },
  "admin": {
    "common": {
      "actions": "الإجراءات",
      "refresh": "تحديث",
      "retry": "إعادة المحاولة",
      "none": "لا يوجد",
      "platform": "المنصة",
      "allOrganizations": "كل المؤسسات"
    },
    "shell": {
      "badge": "مشرف"
    },
    "nav": {
      "label": "تنقل المشرف",
      "home": "لوحة المشرف",
      "organizations": "المؤسسات",
      "apiCalls": "استدعاءات API",
      "scheduledTasks": "المهام الفاشلة",
      "providerProxy": "وكيل المزود"
    },
    "meta": {
      "home": {
        "title": "لوحة المشرف",
        "subtitle": "نظرة دعم داخلية عبر المؤسسات"
      },
      "organizations": {
        "title": "المؤسسات",
        "subtitle": "بيانات دليل آمنة لعمليات الدعم"
      },
      "organizationDetail": {
        "title": "تفاصيل المؤسسة",
        "subtitle": "المستخدمون وبيانات الربط وصحة المزود والحصص"
      },
      "apiCalls": {
        "title": "إحصاءات استدعاءات API",
        "subtitle": "حجم استدعاءات المزودين والفشل والحصص والصحة"
      },
      "stockDiagnostics": {
        "title": "تشخيص مزامنة المخزون",
        "subtitle": "نتائج عناصر المزود المنقحة وسياق المجدول"
      },
      "scheduledTasks": {
        "title": "المهام المجدولة الفاشلة",
        "subtitle": "فحص وإعادة محاولة تنفيذات db-scheduler الفاشلة"
      },
      "providerProxy": {
        "title": "منضدة وكيل المزود",
        "subtitle": "إعادة إصدار استدعاءات المزود عبر المحولات الإنتاجية دون كشف الاعتمادات"
      }
    },
    "severity": {
      "CRITICAL": "حرجة",
      "HIGH": "عالية",
      "MEDIUM": "متوسطة",
      "LOW": "منخفضة",
      "WARNING": "تحذير"
    },
    "home": {
      "loading": "جارٍ تحميل لوحة المشرف…",
      "error": {
        "title": "تعذّر تحميل لوحة المشرف",
        "body": "لم تستجب نقاط ملخص المشرف. أعد المحاولة أو تحقق من جلستك."
      },
      "warning": {
        "pill": "مساحة للدعم فقط",
        "title": "أدوات عابرة للمستأجرين وتتطلب حذراً",
        "body": "تعرض شاشات المشرف بيانات تشغيلية عبر المؤسسات. لا تتصفح طلبات أو منتجات أو عملاء أو اعتمادات أو رموز أو أسرار التجار من هذه المساحة.",
        "cta": "فتح المؤسسات"
      },
      "stats": {
        "organizations": "المؤسسات",
        "users": "المستخدمون",
        "connections": "الروابط",
        "failedTasks": "المهام الفاشلة",
        "apiCalls": "استدعاءات API"
      },
      "attention": {
        "title": "قائمة الانتباه",
        "subtitle": "إشارات تشغيلية مرتبة من المزودين والحصص والروابط والمهام المجدولة.",
        "emptyTitle": "لا توجد عناصر انتباه",
        "emptyBody": "لا توجد إشارات انتباه للمشرف حالياً.",
        "count": "{{count}} عنصر",
        "count_plural": "{{count}} عناصر"
      },
      "tools": {
        "title": "أدوات المشرف",
        "organizations": "المؤسسات والمستخدمون",
        "apiCalls": "إحصاءات استدعاءات API",
        "scheduledTasks": "المهام المجدولة الفاشلة",
        "providerProxy": "منضدة وكيل المزود"
      }
    },
    "attention": {
      "title": {
        "SCHEDULED_TASK_FAILED": "فشلت مهمة مجدولة بشكل متكرر",
        "PROVIDER_HEALTH_NEEDS_ATTENTION": "صحة المزود تحتاج إلى انتباه",
        "API_QUOTA_PRESSURE": "ضغط على حصة API للمزود",
        "CHANNEL_CONNECTION_NEEDS_ATTENTION": "ربط القناة يحتاج إلى انتباه",
        "INVENTORY_CONNECTION_NEEDS_ATTENTION": "ربط المخزون يحتاج إلى انتباه"
      },
      "detail": {
        "SCHEDULED_TASK_RETRY_AVAILABLE": "فشلت مهمة مجدولة عدة مرات ويمكن إعادة محاولتها من صفحة المهام الفاشلة.",
        "API_QUOTA_EXCEEDED": "وصلت حصة المزود إلى حد اليوم.",
        "API_QUOTA_NEAR_LIMIT": "حصة المزود قريبة من حد اليوم.",
        "DEGRADED": "صحة المزود متدهورة.",
        "DOWN": "صحة المزود متوقفة.",
        "AUTH_EXPIRED": "انتهى التفويض ويجب إعادة ربط الاتصال.",
        "DISCONNECTED": "ربط المزود غير متصل.",
        "ERROR": "ربط المزود في حالة خطأ."
      }
    },
    "organizations": {
      "loading": "جارٍ تحميل المؤسسات…",
      "error": {
        "title": "تعذّر تحميل المؤسسات",
        "body": "لم تستجب نقطة دليل المؤسسات."
      },
      "filters": {
        "search": "بحث",
        "searchPlaceholder": "اسم المؤسسة أو رقمها"
      },
      "empty": {
        "title": "لا توجد مؤسسات",
        "body": "لا توجد مؤسسات تطابق البحث الحالي."
      },
      "connectionSummary": "{{connected}} من {{total}} متصلة",
      "actions": {
        "open": "فتح"
      },
      "table": {
        "organization": "المؤسسة",
        "users": "المستخدمون",
        "connections": "الروابط",
        "latestActivity": "آخر نشاط",
        "created": "أُنشئت"
      },
      "invitations": {
        "title": "دعوات الوضع السهل لسلة",
        "subtitle": "استعد الدعوات النشطة دون تغيير ملكية المتجر أو المؤسسة.",
        "success": "أُرسلت دعوة جديدة للتاجر رقم {{merchantId}}، ولم يعد الرابط السابق صالحاً.",
        "protectedRecipient": "حُذف بعد انتهاء الصلاحية",
        "unclaimed": "لم تُطالب به مؤسسة",
        "empty": {
          "title": "لا توجد دعوات تحتاج إلى متابعة",
          "body": "ستظهر هنا دعوات الوضع السهل لسلة التي لم تتم المطالبة بها."
        },
        "status": {
          "PENDING": "قيد الانتظار",
          "EXPIRED": "منتهية"
        },
        "table": {
          "store": "المتجر",
          "recipient": "المستلم المتحقق منه",
          "organization": "المؤسسة المحفوظة",
          "status": "الحالة",
          "expires": "تنتهي"
        },
        "actions": {
          "resend": "إعادة إرسال الدعوة",
          "recovery": "خطوات الاستعادة"
        },
        "dialog": {
          "resendTitle": "هل تريد إعادة إرسال الدعوة؟",
          "resendBody": "سيتحقق تلاق من حساب سلة الحالي، ويبطل الرابط السابق، ثم يرسل رابطاً جديداً إلى بريد الحساب المتحقق منه. لا يمكن تغيير ملكية المتجر أو المؤسسة من هنا.",
          "expiredTitle": "يلزم تفويض جديد من سلة",
          "expiredBody": "انتهت صلاحية هذا التفويض وحُذفت بياناته الحساسة. لا يستطيع المشرف إحياءه أو نقل المتجر.",
          "expiredStepOne": "اطلب من التاجر تفويض تلاق أو إعادة تثبيته من سلة.",
          "expiredStepTwo": "انتظر ظهور دعوة جديدة قيد الانتظار هنا.",
          "expiredStepThree": "لا تطلب أو تلصق روابط الدعوات أو رموز الوصول أو محتوى webhooks في تذكرة دعم.",
          "confirm": "تحقق وأعد الإرسال",
          "sending": "جارٍ التحقق والإرسال…",
          "recentlySent": "أُرسلت مؤخراً",
          "close": "إغلاق",
          "error": "تعذرت إعادة إرسال الدعوة. حدّث القائمة وتأكد من أن تفويض سلة ما زال نشطاً."
        }
      }
    },
    "organizationDetail": {
      "loading": "جارٍ تحميل تفاصيل المؤسسة…",
      "back": "العودة إلى المؤسسات",
      "missing": {
        "title": "لم تُحدد مؤسسة",
        "body": "ارجع إلى الدليل واختر مؤسسة."
      },
      "error": {
        "title": "تعذّر تحميل تفاصيل المؤسسة",
        "body": "لم تستجب نقطة دليل المشرف لهذه المؤسسة."
      },
      "stats": {
        "users": "المستخدمون",
        "channels": "القنوات",
        "inventory": "المخزون"
      },
      "users": {
        "title": "المستخدمون",
        "emptyTitle": "لا يوجد مستخدمون",
        "emptyBody": "لا تحتوي هذه المؤسسة على مستخدمين.",
        "table": {
          "name": "الاسم",
          "role": "الدور",
          "status": "الحالة",
          "locale": "اللغة",
          "lastLogin": "آخر دخول",
          "created": "أُنشئ"
        }
      },
      "channelConnections": {
        "title": "روابط القنوات",
        "emptyTitle": "لا توجد روابط قنوات",
        "emptyBody": "لا تحتوي هذه المؤسسة على روابط قنوات."
      },
      "inventoryConnections": {
        "title": "روابط المخزون",
        "emptyTitle": "لا توجد روابط مخزون",
        "emptyBody": "لا تحتوي هذه المؤسسة على روابط مخزون."
      },
      "connections": {
        "openProxy": "فتح الوكيل",
        "quotaEditor": {
          "label": "الحد اليومي لـ {{provider}}",
          "save": "حفظ الحد",
          "saving": "جارٍ الحفظ…",
          "useDefault": "استخدام الافتراضي",
          "error": "تعذّر تحديث حد حصة المزود. حاول مرة أخرى."
        },
        "table": {
          "connection": "الرابط",
          "status": "الحالة",
          "health": "الصحة",
          "quota": "الحصة",
          "latestActivity": "آخر نشاط"
        }
      }
    },
    "apiCalls": {
      "loading": "جارٍ تحميل إحصاءات استدعاءات API…",
      "error": {
        "title": "تعذّر تحميل إحصاءات API",
        "body": "لم تستجب نقطة المقاييس."
      },
      "filters": {
        "organization": "المؤسسة",
        "provider": "المزود",
        "providerPlaceholder": "ZID، SALLA، ZOHO…",
        "from": "من",
        "to": "إلى",
        "apply": "تطبيق الفلاتر",
        "retentionHint": "تتوفر سجلات تدقيق استدعاءات API لآخر ٩٠ يوماً.",
        "rangeError": "اختر نطاقاً زمنياً لا يتجاوز ٩٠ يوماً ضمن مدة الاحتفاظ بالسجلات."
      },
      "summary": {
        "auditedAttempts": "المحاولات المدققة",
        "successes": "الاستجابات الناجحة",
        "failures": "الفشل",
        "localRejections": "الرفض المحلي",
        "quotaUsage": "استدعاءات الحصة المستخدمة"
      },
      "trend": {
        "title": "اتجاه المحاولات خلال 7 أيام",
        "dayLabel": "{{day}}: {{attempts}} محاولة مدققة",
        "successes": "{{count}} استجابة ناجحة",
        "failures": "{{count}} حالة فشل",
        "localRejections": "{{count}} حالة رفض محلي معروفة"
      },
      "quotaHealth": {
        "title": "صحة حصة المزود",
        "emptyTitle": "لا يوجد نشاط لحصص المزودين",
        "emptyBody": "لا توجد سجلات حصص أو صحة مزود تطابق الفلاتر الحالية.",
        "quotaLabel": "الحصة",
        "providerLabel": "المزود",
        "notRecorded": "لم يُسجل صف حصة خلال هذه الفترة.",
        "usage": "{{used}} / {{limit}} · {{percent}}"
      },
      "attribution": {
        "title": "إسناد الطلبات",
        "coverage": "ترتبط {{percent}} من المحاولات المدققة بطلب منظم.",
        "linkedAttempts": "المحاولات المرتبطة بطلب",
        "distinctOrders": "الطلبات المرتبطة المميزة",
        "limitation": "تشمل الطلبات المميزة فقط مراجع CHANNEL_ORDER المنظمة. تبقى المحاولات التاريخية وغير المرتبطة بلا إسناد، ولا يتوفر إسناد موثوق لقناة."
      },
      "operations": {
        "title": "تفصيل العمليات",
        "emptyTitle": "لا توجد عمليات",
        "emptyBody": "لا توجد عمليات مدققة تطابق الفلاتر الحالية.",
        "orderCoverage": "إسناد الطلبات"
      },
      "calls": {
        "title": "بيانات الاستدعاءات المجمعة الخام",
        "emptyTitle": "لا توجد استدعاءات",
        "emptyBody": "لا توجد استدعاءات API تطابق الفلاتر الحالية.",
        "table": {
          "day": "اليوم",
          "organization": "المؤسسة",
          "provider": "المزود",
          "endpoint": "المسار",
          "status": "الحالة",
          "count": "الاستدعاءات",
          "failures": "الفشل"
        }
      },
      "actions": {
        "organization": "المؤسسة",
        "proxy": "الوكيل",
        "stockDiagnostics": "تشخيص مزامنة المخزون",
        "diagnostics": "التشخيص"
      },
      "quotas": {
        "title": "استخدام الحصص",
        "emptyTitle": "لا توجد صفوف حصص",
        "emptyBody": "لا توجد صفوف استخدام حصص تطابق الفلاتر الحالية."
      },
      "health": {
        "title": "صحة المزود",
        "emptyTitle": "لا توجد صفوف صحة",
        "emptyBody": "لا توجد صفوف صحة مزود تطابق الفلاتر الحالية.",
        "failures": "{{count}} حالات فشل متتالية"
      },
      "providerHint": "المزودون في هذه النتيجة: {{providers}}"
    },
    "scheduledTasks": {
      "loading": "جارٍ تحميل المهام المجدولة الفاشلة…",
      "title": "المهام المجدولة الفاشلة",
      "subtitle": "تظهر هنا التنفيذات الفاشلة فقط. أعد المحاولة بحذر؛ يجب أن تكون المعالجات قابلة للتكرار.",
      "diagnostics": "التشخيص",
      "error": {
        "title": "تعذّر تحميل المهام الفاشلة",
        "body": "لم تستجب نقطة المهام المجدولة."
      },
      "empty": {
        "title": "لا توجد مهام مجدولة فاشلة",
        "body": "كل المهام المجدولة سليمة."
      },
      "table": {
        "task": "المهمة",
        "instance": "المثيل",
        "lastFailure": "آخر فشل",
        "executionTime": "وقت التنفيذ",
        "failures": "الفشل"
      },
      "retry": {
        "action": "إعادة المحاولة",
        "retrying": "جارٍ الإعادة…",
        "confirm": "هل تريد إعادة محاولة {{taskName}} للمثيل {{instanceId}}؟",
        "accepted": "تم قبول إعادة المحاولة. حُدثت قائمة المهام الفاشلة.",
        "failed": "فشل طلب إعادة المحاولة. تحقق من حالة المهمة وحاول مجدداً."
      }
    },
    "stockDiagnostics": {
      "loading": "جارٍ تحميل تشخيص مزامنة المخزون…",
      "run": "تشغيل التوزيع",
      "title": "تشخيص مزامنة مخزون {{provider}}",
      "inspectConnection": "فحص المؤسسة",
      "transport": "نتيجة النقل",
      "transportCompleted": "اكتمل طلب المزود وتم تحليل نتائج العناصر",
      "itemResult": "نتيجة مستوى العنصر",
      "itemRejected": "{{count}} عناصر مرفوضة",
      "itemAccepted": "قُبلت كل العناصر",
      "taskName": "مهمة المجدول",
      "taskInstance": "مثيل المهمة",
      "retry": "إعادة العناصر الفاشلة فقط",
      "retrying": "جارٍ إعادة المحاولة…",
      "retryFailed": "تعذّرت إعادة العناصر الفاشلة. تحقق من الربط وحاول مجدداً.",
      "codes": "توزيع رموز المزود",
      "metrics": { "attempted": "تمت المحاولة", "pushed": "تم الإرسال", "failed": "فشلت", "skipped": "تم التجاوز" },
      "table": { "product": "المنتج", "sku": "SKU", "quantity": "الكمية", "code": "رمز المزود", "message": "رسالة المزود المنقحة" },
      "empty": { "title": "لا توجد تشغيلات توزيع", "body": "سيظهر تشخيص توزيع المخزون بعد أول تشغيل." },
      "error": { "title": "تعذّر تحميل التشخيص", "body": "لم تستجب نقطة تشخيص توزيع المخزون." }
    },
    "providerProxy": {
      "loading": "جارٍ تحميل وكيل المزود…",
      "error": {
        "title": "تعذّر تحميل وكيل المزود",
        "body": "لم تستجب نقطة دليل المشرف."
      },
      "empty": {
        "title": "لا توجد روابط لهذا الاختيار",
        "body": "اختر مؤسسة أو سطحاً آخر يحتوي على مزود متصل."
      },
      "fields": {
        "surface": "السطح",
        "organization": "المؤسسة",
        "connection": "الرابط",
        "method": "الطريقة",
        "path": "المسار",
        "queryParams": "معاملات الاستعلام",
        "headers": "ترويسات آمنة",
        "body": "المتن"
      },
      "surface": {
        "channel": "مزود قناة",
        "inventory": "مزود مخزون"
      },
      "placeholders": {
        "path": "/api/path"
      },
      "hints": {
        "keyValue": "سطر واحد بصيغة key=value أو key: value.",
        "headers": "تُحظر ترويسات التفويض والأسرار من جهة العميل والخادم.",
        "body": "متن الطلب الخام للمزود. اتركه فارغاً لطلبات GET."
      },
      "validation": {
        "pathSlash": "يجب أن يبدأ المسار بـ /.",
        "pathAbsolute": "يجب أن يكون المسار نسبياً وألا يحتوي على ://.",
        "connection": "اختر رابطاً قبل الإرسال.",
        "forbiddenHeader": "الترويسة {{header}} غير مسموحة.",
        "keyValue": "استخدم إدخال key=value أو key: value واحداً في كل سطر.",
        "requestFailed": "فشل طلب الوكيل قبل إرجاع استجابة من upstream.",
        "pathTraversal": "مقاطع اجتياز المسار غير مسموحة."
      },
      "confirmMutating": "إرسال طلب وكيل مزود بطريقة {{method}}؟",
      "actions": {
        "send": "إرسال طلب الوكيل",
        "sending": "جارٍ الإرسال…"
      },
      "response": {
        "title": "استجابة المزود",
        "status": "الحالة {{status}}",
        "header": "الترويسة",
        "value": "القيمة",
        "emptyBody": "لم يُلتقط متن للاستجابة."
      }
    }
  },
  "public": {
    "landing": {
      "nav": {
        "aria": "تنقل الصفحة العامة",
        "how": "كيف يعمل",
        "features": "المنتج",
        "billing": "الفوترة",
        "faq": "الأسئلة",
        "signIn": "تسجيل الدخول",
        "getStarted": "جربه مجانا",
        "mobileAria": "تنقل الصفحة للجوال",
        "menuOpen": "فتح القائمة",
        "menuClose": "إغلاق القائمة"
      },
      "skip": "تخطي إلى المحتوى الرئيسي",
      "social": {
        "eyebrow": "بالأرقام",
        "title": "مبني على طريقة بيع التجار السعوديين فعلاً.",
        "items": {
          "channels": {
            "value": "٥+",
            "label": "قنوات بيع",
            "body": "سلة ونون وأمازون وزد وترينديول تبقى متزامنة من مكان واحد."
          },
          "inbox": {
            "value": "١",
            "label": "صندوق طلبات",
            "body": "طلبات كل قناة تصل إلى طابور واحد مع السياق الكامل."
          },
          "sync": {
            "value": "ثوانٍ",
            "label": "هدف المزامنة",
            "body": "تنتقل تغييرات المخزون بسرعة تكفي حتى يرى العميل التالي الحقيقة."
          },
          "manual": {
            "value": "٠",
            "label": "قفزات إكسل",
            "body": "بلا تصدير يدوي وبلا مطابقة للمخزون يدوياً عبر اللوحات."
          }
        }
      },
      "faq": {
        "eyebrow": "الأسئلة الشائعة",
        "title": "أسئلة يسألها التجار قبل الربط.",
        "items": {
          "channels": {
            "question": "ما القنوات التي يدعمها تلاق؟",
            "answer": "يربط تلاق اليوم سلة ونون وأمازون وزد وترينديول، بنفس نموذج المزامنة عبر كل قناة تربطها."
          },
          "sku": {
            "question": "هل يجب أن تتطابق أكواد SKU بين القنوات؟",
            "answer": "تسرّع الأكواد المتطابقة عملية الإعداد، لكن تلاق يظهر أيضاً المنتجات غير المربوطة حتى تراجع ربط القنوات وتصححه قبل الاعتماد على التحديثات الآلية."
          },
          "billing": {
            "question": "كيف تعمل الفوترة؟",
            "answer": "في سلة وزد يبقى الرسم على فاتورة السوق التي تراجعها أصلاً. أما اتصالات أمازون ونون وترينديول فتبقى مجانية في العرض الأولي."
          },
          "zoho": {
            "question": "هل أستطيع إبقاء زوهو مصدر الحقيقة؟",
            "answer": "نعم. إذا كان زوهو يملك كتالوجك ومخزونك فابقه كذلك. وإذا لم يكن كذلك، ابدأ من تلاق ثم اربط زوهو لاحقاً من دون إعادة بناء القنوات."
          },
          "safety": {
            "question": "هل سيغير ربط تلاق مخزوني فوراً؟",
            "answer": "الربط يمنح صلاحية الوصول فقط. تعتمد تحديثات المخزون على ربط المنتجات ومصدر الحقيقة الذي اخترته، لذلك يمكنك مراجعة الإعداد قبل تفعيل المزامنة الآلية."
          },
          "setup": {
            "question": "كم يستغرق الإعداد؟",
            "answer": "اربط القناة بأمان، وراجع ربط الكتالوج، واختر مصدر المخزون. يبقي تلاق هذه القرارات واضحة قبل بدء المزامنة الآلية."
          },
          "support": {
            "question": "ماذا يحدث عند فشل المزامنة؟",
            "answer": "يعرض تلاق الصف والنظام والخطوة التصحيحية بدقة بدلاً من الفشل الصامت، حتى يصلح المشغّل المشكلة بالضبط."
          }
        }
      },
      "mobileCta": {
        "aria": "تسجيل عبر الجوال",
        "caption": "ابدأ بأول قناة",
        "primary": "ابدأ الآن"
      },
      "hero": {
        "eyebrow": "مصمم للنمو عبر قنوات متعددة",
        "titleLine1": "بع في كل مكان.",
        "titleLine2": "وأدر كل شيء",
        "titleAccent": "بتزامن واحد.",
        "body": "اربط سلة وزد ونون وأمازون وترينديول. وحّد المخزون، واجمع الطلبات في مساحة واحدة، وتوسع من دون إضافة المزيد من العمل اليدوي.",
        "primaryCta": "ابدأ المزامنة",
        "secondaryCta": "شاهد كيف يعمل",
        "connectsTo": "متصل مع",
        "salesChannels": "قنوات البيع",
        "inventorySources": "مصادر المخزون",
        "visual": {
          "live": "مباشر",
          "time": "قبل ثانيتين",
          "eyebrow": "طلب جديد",
          "order": "نون · #SA-31840",
          "sku": "هودي قطني · L · ×١",
          "syncTitle": "تمت مزامنة المخزون في",
          "syncValue": "−١ · ٢٣ متبقٍ",
          "miniTitle": "تم منع بيع زائد",
          "miniBody": "٣٧ مرة هذا الأسبوع"
        }
      },
      "problem": {
        "eyebrow": "واقع العمل اليومي",
        "title": "هل يبدو يوم عملك هكذا؟",
        "body": "تبيع في أكثر من مكان، لكن إبقاء القنوات متوافقة ما زال يعتمد على شخص يراجع اللوحات ويحدث الملفات ويأمل ألا يفوته شيء.",
        "before": {
          "title": "يوم تقضيه في ملاحقة المخزون",
          "time1": "١٠:٣٢",
          "time2": "١٠:٣٤",
          "time3": "١٠:٤١",
          "time4": "١١:١٢",
          "row1": "تفتح كل قناة بيع لمقارنة كميات المخزون.",
          "row2": "يتحول ملف إكسل إلى مصدر الحقيقة المؤقت.",
          "row3": "لا يظهر اختلاف المخزون إلا بعد إلغاء طلب.",
          "row4": "لا أحد يعرف هل وصل آخر تحديث إلى جميع القنوات."
        },
        "after": {
          "title": "يوم يبقى تحت السيطرة",
          "time1": "١٠:٣٢",
          "time2": "١٠:٣٤",
          "time3": "١٠:٤١",
          "time4": "—",
          "row1": "تظهر طلبات جميع القنوات في صندوق واحد.",
          "row2": "مصدر مخزون واحد يضبط الكمية في كل متجر.",
          "row3": "تنتقل التحديثات بلا تصدير أو مطابقة يدوية.",
          "row4": "عندما تحتاج مزامنة إلى تدخل، تظهر القناة المتأثرة والخطوة التالية بوضوح."
        }
      },
      "how": {
        "eyebrow": "كيف يعمل",
        "title": "ثلاث خطوات من متاجر متفرقة إلى عملية واحدة متزامنة.",
        "body": "اربط قنوات البيع، وحدد أين تعيش حقيقة المخزون، ودع تلاق يحافظ على حركة الطلبات والمخزون معاً.",
        "phases": {
          "connect": {
            "title": "اربط أول قناة",
            "body": "استخدم OAuth لربط حسابات البائعين من دون مشاركة كلمات المرور أو نسخ الأسرار التقنية يدوياً.",
            "cardTitle": "تسليم OAuth",
            "cardBody": "سلة وزد وأمازون والقنوات الأخرى تحتفظ بمسار التفويض الخاص بها. يحفظ تلاق الاستدعاء العائد ويكمل بعد تسجيل الدخول عند الحاجة."
          },
          "map": {
            "title": "اربط الكتالوج بواسطة SKU",
            "body": "يسحب تلاق المنتجات من كل قناة ويظهر فقط أكواد SKU التي ما زالت تحتاج تصحيحاً قبل أن تصبح تحديثات المخزون موثوقة.",
            "cardTitle": "مراجعة التعارض",
            "cardBody": "ترى الصفوف غير المتطابقة، وتصلح الكود مرة واحدة، وتتوقف عن ملاحقة نفس التناقض عبر لوحات متعددة."
          },
          "source": {
            "title": "اختر مصدر الحقيقة",
            "body": "إذا كان زوهو هو مالك الكتالوج اليوم فابقه كذلك. وإذا لم يكن كذلك، ابدأ من تلاق ثم اربط زوهو لاحقاً من دون إعادة بناء القنوات.",
            "cardTitle": "تبديل الملكية",
            "cardBody": "المنتج يحتاج جواباً واضحاً عن المكان الذي يعيش فيه الكتالوج والمخزون، ثم يدفع تلاق تلك الحالة إلى الخارج."
          },
          "sync": {
            "title": "تنزل البيعة وينخفض المخزون في كل مكان",
            "body": "ينبغي أن يحدّث طلب واحد كل القنوات المتصلة بسرعة تكفي حتى لا يرى العميل التالي مخزوناً قديماً.",
            "cardTitle": "أثر مزامنة حي",
            "cardBody": "حدث من القناة إلى الداخل، ثم تحديث للمخزون في تلاق، ثم دفع للخارج، ثم إنشاء أمر بيع في زوهو إذا كان الربط نشطاً."
          },
          "orders": {
            "title": "اشتغل من صندوق طلبات واحد",
            "body": "تصل الطلبات بهوية القناة والحالة والسياق المالي بحيث يشحن الفريق من مساحة واحدة بدلاً من التنقل طوال اليوم.",
            "cardTitle": "طابور موحد",
            "cardBody": "يعامل تلاق حالة الطلب والقناة وحالة المزامنة كبيانات أساسية، لذلك يجب أن تكون هذه النقطة واضحة في الصفحة العامة."
          },
          "errors": {
            "title": "اعرف الفشل بوضوح عندما يحدث",
            "body": "التفصيل المفيد عند الفشل هو الصف والنظام والخطوة التالية. الفشل الصامت هو المشكلة الحقيقية.",
            "cardTitle": "أخطاء قابلة للتصرف",
            "cardBody": "يجب أن يوضح تلاق أي خطوة لاحقة فشلت ولماذا، حتى يصلح المشغّل المشكلة الدقيقة بدلاً من إعادة المحاولة عشوائياً."
          }
        }
      },
      "features": {
        "eyebrow": "داخل تلاق",
        "title": "شاهد كيف ينتقل العمل اليومي إلى مكان واحد.",
        "items": {
          "variance": {
            "title": "اكتشف اختلافات المخزون قبل أن تتحول إلى مشاكل بيع",
            "body": "عندما يكون زوهو مصدر المخزون، يقارن تلاق كمياته مع قنوات البيع المربوطة ويظهر الاختلافات للمراجعة.",
            "visualTitle": "اختلافات المخزون",
            "sourceLabel": "مصدر الحقيقة",
            "comparison": "مقارنة كميات المنتجات المربوطة عبر القنوات المتصلة",
            "result": "تظهر الاختلافات بوضوح للمراجعة"
          },
          "sync": {
            "title": "مزامنة فورية",
            "body": "تنتقل تحديثات المخزون والطلبات عبر القنوات المتصلة خلال ثوانٍ بدلاً من انتظار التحديث اليدوي."
          },
          "inbox": {
            "title": "صندوق طلبات موحد",
            "body": "طلبات سلة ونون وأمازون وزد وترينديول تصل إلى مكان واحد مع السياق الصحيح جاهزاً."
          },
          "protection": {
            "title": "حماية من البيع الزائد",
            "body": "المنتج مبني لمنع الطلبات المستحيلة قبل وقوعها، لا لتنظيف آثارها بعد أن تعاقبك السوق."
          },
          "catalog": {
            "title": "منتج واحد، قنوات كثيرة",
            "body": "عرّف المنتج مرة واحدة، واضبط ربطه جيداً، وحافظ على اتساق الكتالوج عبر الأسواق."
          },
          "zoho": {
            "title": "اختر مصدر المخزون",
            "body": "استخدم تلاق كمصدر للحقيقة، أو أبقِ زوهو متحكماً عندما يكون هو مالك دورة المخزون لديك."
          },
          "errors": {
            "title": "فشل المزامنة لا يختفي بصمت",
            "body": "شاهد القناة والمنتج والخطوة التي فشلت معاً حتى يعرف المشغّل ما يحتاج إلى تدخل."
          }
        }
      },
      "confidence": {
        "eyebrow": "ثقة تشغيلية",
        "title": "الأتمتة لا ينبغي أن تتركك في حيرة.",
        "body": "عندما تحتاج قناة إلى تدخل، يبقي تلاق المشكلة ظاهرة ويمنح المشغّل السياق الكافي للتصرف.",
        "items": {
          "visible": {
            "title": "لا فشل صامت",
            "body": "اعرف أي قناة أو اتصال يحتاج إلى تدخل بدلاً من اكتشاف اختلاف المخزون بعد إلغاء طلب."
          },
          "diagnose": {
            "title": "افهم المشكلة بدقة",
            "body": "شاهد المنتج والقناة والخطوة المتأثرة معاً بدلاً من البحث في سجلات متفرقة."
          },
          "recover": {
            "title": "أصلح ما يحتاج الإصلاح فقط",
            "body": "حدد المشكلة الدقيقة وصححها من دون إعادة التحقيق في سير العمل كاملاً."
          }
        }
      },
      "billing": {
        "eyebrow": "كيف تعمل الفوترة",
        "title": "لا تحتاج إلى نظام فوترة منفصل من تلاق حتى تبدأ.",
        "body": "في سلة وزد، ينسجم تلاق مع فوترة السوق التي يستخدمها التاجر بالفعل. أما القنوات الأخرى فتبقى مجانية أثناء الربط والتشغيل.",
        "recommended": "موصى به",
        "cards": {
          "salla": {
            "badge": "عبر السوق",
            "title": "سلة",
            "price": "ابتداءً من 199 ر.س/شهرياً",
            "body": "ثبّت تلاق من متجر تطبيقات سلة واحتفظ بالرسم على نفس فاتورة سلة التي يراجعها فريقك اليوم.",
            "cta": "عرضه في متجر سلة"
          },
          "zid": {
            "badge": "عبر السوق",
            "title": "زد",
            "price": "ابتداءً من 299 ر.س/شهرياً",
            "body": "ثبّت تلاق من سوق زد واحتفظ بإدارة الاشتراك داخل سير العمل الذي يستخدمه فريقك الآن.",
            "cta": "عرضه في سوق زد"
          },
          "free": {
            "badge": "مجاني دائماً",
            "title": "أمازون، نون، ترينديول",
            "price": "مجاني",
            "body": "تسمح واجهات البائعين العامة بأن تبقى هذه القنوات مجانية في العرض الأولي مع الاحتفاظ بنفس نموذج المزامنة.",
            "cta": "عرض القنوات المتصلة"
          }
        },
        "note": "أبقِ الفوترة في المكان الذي يتوقعه التاجر أصلاً. لا حاجة لعلاقة مورد إضافية فقط لتجربة ما إذا كان المسار مناسباً."
      },
      "cta": {
        "title": "أوقف البيع الزائد. ابدأ المزامنة.",
        "body": "امنح الفريق مكاناً واحداً لربط القنوات، وحسم ملكية الكتالوج، والحفاظ على حركة المخزون في الاتجاه الصحيح.",
        "primary": "ابدأ الآن",
        "secondary": "تسجيل الدخول"
      },
      "proposal": {
        "hero": {
          "title": "زامن مخزونك مع متاجرك أول بأول",
          "body": "",
          "primary": "اربط متجرك",
          "secondary": "شاهد طريقة العمل"
        },
        "integrations": {
          "sources": "مصادر المخزون",
          "channels": "قنوات البيع"
        },
        "preview": {
          "back": "العودة إلى المتاجر ←",
          "title": "اختلافات المخزون مع المتاجر",
          "subtitle": "راجع اختلافات الكميات المتوفر بالمتاجر مع المخزون",
          "noticeTitle": "تقرير للقراءة فقط",
          "noticeBody": "لا يعدّل المخزون ولا يدفع الكميات إلى القنوات. افحص المنتج وراجع قواعد التوزيع.",
          "disclaimer": "تمثيل من الواجهة · بيانات توضيحية",
          "search": "بحث",
          "searchValue": "SKU أو المنتج أو القائمة أو معرّف المتجر…",
          "filterStores": "المتاجر",
          "filterStoresValue": "كل المتاجر⌄",
          "apply": "تطبيق الفلاتر",
          "shirt": "قميص قطني · أزرق",
          "shirtListing": "قميص قطني أزرق",
          "mug": "كوب خزفي · أبيض",
          "mugListing": "كوب خزفي أبيض",
          "danger": "خطر",
          "connected": "متصل",
          "store": "متجر تجريبي",
          "reason": "المتجر صفر بينما المنتج متوفر",
          "source": "المخزون",
          "channel": "المتجر",
          "difference": "الفرق",
          "lastSeen": "آخر ظهور: ١ يونيو · ١٠:٣٠ ص",
          "date": "١ يونيو",
          "view": "عرض المنتج",
          "allocation": "توزيع المخزون",
          "columns": {
            "product": "المنتج",
            "listing": "المتجر",
            "source": "المخزون",
            "channel": "المتجر",
            "difference": "الفرق",
            "variance": "التباين",
            "seen": "آخر تحديث",
            "actions": "الإجراءات"
          }
        },
        "operations": {
          "eyebrow": "منصة واحد لكل متاجرك",
          "title": "شاهد كل متاجرك كعملية واحدة",
          "body": "نظرة مباشرة وكتالوج واحد وقائمة طلبات واحدة لكل متاجرك.",
          "demo": "حساب تجريبي حقيقي",
          "items": {
            "dashboard": {
              "mobileLabel": "لوحة المعلومات",
              "title": "ملخص للمعلومات المهمة",
              "body": "تابع المبيعات والمنتجات والمتاجر والإجراءات التي تحتاج انتباهك.",
              "alt": "لوحة معلومات تلاق للمبيعات والمنتجات والمتاجر والإجراءات"
            },
            "products": {
              "mobileLabel": "المنتجات · حساب تجريبي حقيقي",
              "title": "كتالوج واحد عبر كل المتاجر",
              "body": "شاهد حالة المنتج والسعر والمخزون وتوفرها بالمتاجر.",
              "alt": "كتالوج منتجات تلاق عبر المتاجر المرتبطة"
            },
            "orders": {
              "mobileLabel": "الطلبات",
              "title": "كل الطلبات في قائمة واحدة",
              "body": "عالج طلبات زد وسلة وأمازون وترينديول ونون دون التنقل بين الأنظمة.",
              "alt": "قائمة طلبات تلاق الموحدة عبر المتاجر المرتبطة"
            }
          }
        },
        "story": {
          "title": "اعرف سبب اختلاف المخزون.",
          "body": "اعرف المنتجات اللي ما تم توزيعها بشكل صحيح على المتاجر، وعرف لها جدولة توزيع بحيث تضمن إن المتاجر تعكس المخزون بشكل صحيح.",
          "example": "مثال من البيانات المعروضة.",
          "product": "قميص قطني",
          "source": "المصدر",
          "salesChannel": "قناة البيع",
          "stock": "كمية القناة",
          "sourceStock": "مصدر المخزون",
          "channelStock": "كمية القناة",
          "difference": "الفرق"
        },
        "setup": {
          "title": "ابدأ بمتجر واحد وبنساعدك بالباقي",
          "step1": "اربط مع متجر.",
          "step2": "نسحب المنتجات والطلبات من المتجر.",
          "step3": "اختر مصدر المخزون هل هو المتجر أو نظام تخزين مثل زوهو أو تلاق.",
          "step4": "اضبط نسب توزيع المخزون على المتجر وفعله تلقائيا.",
          "step5": "اختياري: زامن طلباتك أول بأول مع نظام المخزون الخارجي."
        },
        "faq": {
          "title": "الأسئلة الشائعة",
          "zoho": {
            "question": "هل أحتاج إلى برنامج مخزون خارجي؟",
            "answer": "الربط يمنح صلاحية الوصول. تحديث الكميات يعتمد على ربط المنتجات ومصدر المخزون وإعدادات المزامنة التي تختارها."
          },
          "stock": {
            "question": "هل تتغير الكميات بمجرد الربط؟",
            "answer": "لا. يمكنك استخدام تلاق كمصدر للمخزون، أو ربط Zoho إذا كنت تدير مخزونك فيه بالفعل."
          },
          "sync": {
            "question": "ماذا يحدث عند فشل المزامنة؟",
            "answer": "راجع المنتجات غير المرتبطة وصحّح الربط قبل الاعتماد على تحديثات المخزون الآلية."
          }
        }
      },
      "footer": {
        "copy": "منتج من DevOcean Labs · الرياض",
        "privacy": "الخصوصية",
        "terms": "الشروط",
        "contact": "تواصل"
      }
    },
    "site": {
      "skip": "تخطي إلى المحتوى الرئيسي",
      "lastUpdated": "آخر تحديث: ١ أكتوبر ٢٠٢٦",
      "onThisPage": "في هذه الصفحة",
      "nav": {
        "aria": "التنقل في المعلومات العامة",
        "home": "الصفحة الرئيسية لتلاق",
        "privacy": "الخصوصية",
        "terms": "الشروط",
        "faq": "الأسئلة الشائعة",
        "support": "الدعم",
        "signIn": "تسجيل الدخول"
      },
      "footer": {
        "aria": "روابط المعلومات العامة",
        "description": "مزامنة المخزون والطلبات للتجار.",
        "identity": "Ocean Devs · مؤسسة محيط البرمجة · الرقم الوطني الموحد 7051193857",
        "location": "حي النرجس، الرياض، المملكة العربية السعودية"
      },
      "privacy": {
        "title": "سياسة الخصوصية",
        "sections": {
          "identity": {
            "title": "من نحن وأدوارنا",
            "body": "تُشغّل تلاق تحت الاسم التجاري الإنجليزي Ocean Devs بواسطة مؤسسة محيط البرمجة، وهي مؤسسة فردية سعودية تحمل الرقم الوطني الموحد 7051193857 ومقرها حي النرجس في الرياض، المملكة العربية السعودية.\n\nنكون جهة التحكم في بيانات حساب التاجر والدعم والأمان وإدارة الخدمة. أما البيانات الشخصية الواردة في الطلبات التي يربطها التاجر بتلاق، فعادةً ما يحدد التاجر غرض استخدامها ويكون جهة التحكم فيها، بينما تعالجها تلاق وفق تعليماته."
          },
          "information": {
            "title": "المعلومات التي نعالجها",
            "body": "نعالج بيانات حسابات التجار وأعضاء الفريق، وسجلات الدخول والأمان بما فيها عناوين IP، ومراسلات الدعم، وبيانات اعتماد المزودين المشفرة، وخيارات الإعداد. وقد تزودنا الخدمات المرتبطة ببيانات المنتجات والقوائم والمستودعات والمخزون والطلبات والمدفوعات والتنفيذ وبيانات تواصل العملاء وعناوين التسليم.\n\nنستخدم وسائل التخزين الأساسية في المتصفح لتشغيل تلاق: تحافظ ملفات تعريف الارتباط المحمية من وصول JavaScript على جلسات تسجيل الدخول وتحمي تسجيل الدخول عبر Google، وتحفظ مساحة التخزين المحلية اللغة وإشعارات المهام المغلقة، وتحفظ مساحة تخزين الجلسة عمليات التسليم المؤقتة للتكاملات. وقد تسجل Sentry إعادة لجلسة عند وقوع خطأ، مع إخفاء النصوص وحجب الوسائط.\n\nنعالج أيضاً بيانات تشخيصية تقنية، مثل نتائج اتصالات المزودين ومعرّفات التتبع ومعلومات الجهاز أو المتصفح وأحداث الأخطاء. لا يطلب تكامل أمازون الحالي في تلاق بيانات أمازون المقيدة الخاصة بتواصل المشتري أو الضرائب أو عنوان التسليم ولا يحتفظ بها."
          },
          "purposes": {
            "title": "لماذا نعالج المعلومات",
            "body": "نستخدم المعلومات لإنشاء الحسابات وحمايتها، وربط الخدمات التي يصرح بها التجار، ومزامنة الكتالوج والمخزون، ومعالجة الطلبات وتسويتها، وتقديم الدعم، وتشخيص الأعطال، ومنع إساءة الاستخدام، وتحسين الاعتمادية، والوفاء بالالتزامات النظامية.\n\nبحسب النشاط، تكون المعالجة لازمة لتنفيذ اتفاقية الخدمة أو الوفاء بالتزام نظامي أو تحقيق مصلحة تشغيلية أو أمنية مشروعة لا تتغلب على حقوق الأفراد، أو بناءً على موافقة صحيحة عندما تكون الموافقة مطلوبة."
          },
          "providers": {
            "title": "مزودو الخدمات والنقل الدولي",
            "body": "تستضيف Hetzner البنية الأساسية للتطبيق وقاعدة البيانات في فالكنشتاين بألمانيا. وتوفر Cloudflare R2 تخزين الملفات والنسخ الاحتياطية. كما نستخدم Sentry لمراقبة الأخطاء وBetter Stack للسجلات وResend للبريد الإلكتروني التشغيلي وGoogle لتسجيل الدخول الاختياري. وتعالج قنوات التجارة وأنظمة المخزون المرتبطة، ومنها سلة وزد وأمازون ونون وترينديول وZoho، البيانات اللازمة لتكاملاتها.\n\nقد تعالج هذه الخدمات المعلومات خارج المملكة العربية السعودية. نقتصر في المشاركة على المعلومات اللازمة ونستخدم الضمانات التعاقدية والأمنية وضمانات النقل المطلوبة نظاماً. ولا نبيع البيانات الشخصية."
          },
          "rights": {
            "title": "حقوقك في الخصوصية",
            "body": "مع مراعاة نظام حماية البيانات الشخصية السعودي وشروطه، يحق للأفراد طلب العلم بالمعالجة والوصول إلى بياناتهم الشخصية والحصول على نسخة واضحة منها وتصحيح البيانات غير الدقيقة أو إكمالها وطلب إتلافها عند انطباق ذلك وسحب الموافقة عندما تعتمد المعالجة عليها.\n\nيتولى التاجر عادةً طلبات عملائه لأنه جهة التحكم في بيانات الطلبات. وسنساعد التجار ونتولى الطلبات المتعلقة ببيانات الحساب أو الدعم التي تتحكم بها تلاق بعد التحقق من هوية مقدم الطلب."
          },
          "retention": {
            "title": "الاحتفاظ والإتلاف والتواصل",
            "body": "تُحذف سجلات تدقيق اتصالات واجهات المزودين وسجلات الويب هوك المكتملة بعد ٩٠ يوماً. ويُحتفظ بسجلات الحسابات والطلبات الأخرى طوال الحاجة إليها لتقديم الخدمة، وقد يستمر الاحتفاظ بها عند الحاجة للأمان أو النزاعات أو المحاسبة أو التزامات المتاجر أو الأنظمة. ونقيّم طلبات إغلاق الحساب والإتلاف وفق الأنظمة المنطبقة. وتظل نسخ الاحتياط محمية إلى أن تنتهي وفق دورة الاحتفاظ المطبقة عليها.\n\nلطلب الوصول أو التصحيح أو نسخة من البيانات أو إغلاق الحساب أو الإتلاف عند انطباقه، راسل support@tlaaq.com. وقد نطلب معلومات لازمة للتحقق من الهوية والصلاحية قبل تنفيذ الطلب."
          }
        },
        "request": {
          "title": "مارس أحد حقوق الخصوصية",
          "body": "راسل support@tlaaq.com"
        }
      },
      "terms": {
        "title": "شروط الخدمة",
        "sections": {
          "account": {
            "title": "الحسابات والصلاحية",
            "body": "يجب تقديم معلومات صحيحة عن الحساب وحماية بيانات الدخول وامتلاك الصلاحية النظامية لإلزام المنشأة التجارية التي تسجلها. وتتحمل مسؤولية النشاط المنفذ عبر حسابك وإزالة صلاحية أي شخص لم يعد بحاجة إليها دون تأخير."
          },
          "service": {
            "title": "خدمة تلاق",
            "body": "تربط تلاق قنوات التجارة وأنظمة المخزون المدعومة لمزامنة المنتجات والقوائم والكميات والطلبات. وتختلف العمليات المتاحة بحسب المزود والباقة والصلاحيات وإعدادات التاجر. وأنت تفوّض تلاق بالاتصال بالمزودين المرتبطين ومعالجة المعلومات الواردة منهم فقط لتقديم الخدمة وحمايتها."
          },
          "subscriptions": {
            "title": "الاشتراكات والتجديد والاسترداد",
            "body": "تُشترى اشتراكات تلاق المدفوعة وتُدار حالياً عبر سلة أو زد. وتظهر الأسعار والفترات التجريبية والتجديد والإلغاء والضرائب وأهلية استرداد المبالغ في المتجر المعني، وتخضع لقواعد فوترة المتجر والباقة المختارة فيه. ولا تجمع تلاق حالياً مدفوعات بطاقات الاشتراك مباشرةً."
          },
          "responsibilities": {
            "title": "مسؤوليات التاجر",
            "body": "تظل مسؤولاً عن منتجاتك وأسعارك وقرارات المخزون وطلباتك وتواصلك مع العملاء وإشعاراتك النظامية والتزامات الضرائب والفوترة والالتزام بقواعد كل مزود مرتبط. راجع ربط المنتجات وإعدادات مصدر البيانات وقواعد التوزيع والإجراءات المقترحة قبل الاعتماد على الأتمتة. ولا تستخدم تلاق لمعالجة معلومات لا تملك صلاحية الوصول إليها."
          },
          "availability": {
            "title": "الإتاحة وخدمات الأطراف الأخرى",
            "body": "نعمل على إبقاء تلاق موثوقة، لكن المزامنة تعتمد على واجهات الأطراف الأخرى وبيانات الاعتماد والحصص وأعطال المزود وإعدادات التاجر. ولا نضمن عملاً متواصلاً أو خالياً من الأخطاء. وقد تتغير المزايا عندما يغير المزود واجهته أو قواعد متجره. ولا تتحمل تلاق مسؤولية الأفعال المستقلة لأي منصة أخرى أو مدى إتاحتها."
          },
          "termination": {
            "title": "التعليق وإغلاق الحساب",
            "body": "يمكنك الإلغاء عبر المتجر الذي يدير اشتراكك، ويمكنك طلب إغلاق الحساب عبر support@tlaaq.com. وقد نقيد الوصول أو نعلقه لحماية الخدمة أو الالتزام بالأنظمة أو قواعد المزود أو معالجة عدم السداد أو إساءة الاستخدام الجوهرية. وتُعالج البيانات بعد الإغلاق وفق سياسة الخصوصية والمتطلبات النظامية المنطبقة."
          },
          "liability": {
            "title": "إخلاء المسؤولية وحدودها",
            "body": "إلى أقصى حد تسمح به الأنظمة الآمرة، تُقدم تلاق بحسب الإتاحة ومن دون ضمانات ضمنية. ولا يتحمل أي طرف مسؤولية الخسائر غير المباشرة أو العرضية أو الخاصة أو التبعية. ويقتصر إجمالي مسؤولية Ocean Devs الناشئة عن الخدمة على رسوم اشتراك تلاق المدفوعة خلال الاثني عشر شهراً السابقة للحدث الذي نشأت عنه المطالبة. ولا يستبعد أي حكم مسؤولية لا يجوز استبعادها نظاماً."
          },
          "law": {
            "title": "النظام واللغة والتواصل",
            "body": "تخضع هذه الشروط لأنظمة المملكة العربية السعودية، وتختص بنزاعاتها المحاكم المختصة في الرياض ما لم تقضِ الأنظمة الآمرة بخلاف ذلك. ويُعتد بالنص العربي عند التعارض بين النسختين العربية والإنجليزية. ويمكن إرسال الأسئلة عن هذه الشروط إلى support@tlaaq.com."
          }
        }
      },
      "faq": {
        "title": "الأسئلة الشائعة",
        "subtitle": "إجابات مباشرة عن الحسابات والتكاملات والمزامنة والبيانات والفوترة.",
        "browse": "تصفح حسب الموضوع",
        "categoriesAria": "موضوعات الأسئلة الشائعة",
        "categories": {
          "all": "الكل",
          "account": "الحساب",
          "integrations": "التكاملات",
          "sync": "المزامنة",
          "data": "البيانات",
          "billing": "الفوترة"
        },
        "questions": {
          "connect": { "question": "كيف أربط متجراً؟", "answer": "افتح صفحة القنوات بعد تسجيل الدخول، واختر مزوداً مدعوماً، ثم أكمل خطوات التفويض لديه. تحفظ تلاق بيانات اعتماد المزود مشفرة ولا تستخدمها إلا للعمليات المصرح بها." },
          "providers": { "question": "ما الخدمات التي يمكنني ربطها؟", "answer": "تدعم تلاق سلة وزد وأمازون ونون وترينديول كقنوات تجارة، ويمكن استخدام تلاق أو Zoho كمصدر للمخزون. وتختلف الإمكانات حسب المزود." },
          "synchronize": { "question": "ما المعلومات التي تزامنها تلاق؟", "answer": "يمكن للاتصالات المصرح بها مزامنة المنتجات والقوائم والمستودعات والمخزون والطلبات. وتعتمد الإجراءات المتاحة على المزود والصلاحيات وإعداداتك." },
          "failure": { "question": "ماذا يحدث عند فشل المزامنة؟", "answer": "تسجل تلاق النتيجة التشغيلية وتعرض أخطاء قابلة للمعالجة عند الإمكان. صحح انتهاء التفويض أو نقص الربط أو حدود المزود أو مشكلات الإعداد قبل إعادة المحاولة." },
          "stock": { "question": "هل تتغير الكميات بمجرد الربط؟", "answer": "لا. يمنح الربط صلاحية الوصول، لكن تحديث الكميات يعتمد على ربط المنتجات ومصدر المخزون المختار وقواعد التوزيع وإعدادات الأتمتة التي تفعلها." },
          "security": { "question": "كيف تُحمى بيانات الاتصال؟", "answer": "تُشفر بيانات اعتماد المزودين ويُعزل الوصول لكل منشأة، وتقتصر المراقبة التشغيلية على البيانات التشخيصية اللازمة لحماية الخدمة وصيانتها. ولا يمكن لأي خدمة عبر الإنترنت ضمان الأمان المطلق." },
          "rights": { "question": "كيف أطلب الوصول أو التصحيح أو الإتلاف؟", "answer": "راسل support@tlaaq.com. نتحقق من الهوية والصلاحية، ثم نتولى البيانات التي تتحكم بها تلاق أو نساعد التاجر المسؤول في بيانات الطلبات المرتبطة." },
          "amazon": { "question": "هل تصل تلاق إلى بيانات مشتري أمازون المقيدة؟", "answer": "ليس حالياً. يستبعد تكامل أمازون معلومات تواصل المشتري والضرائب وعنوان التسليم المقيدة. ولن تُضاف الصلاحية المقيدة إلا لحاجة معتمدة للشحن أو الفوترة." },
          "team": { "question": "هل يمكن لعدة أشخاص استخدام مساحة التاجر؟", "answer": "نعم. يمكن للمالك دعوة أعضاء الفريق، وعليه إزالة الصلاحية عند انتفاء الحاجة إليها. وينبغي أن يستخدم كل شخص حسابه الخاص." },
          "plans": { "question": "أين أدير اشتراكي؟", "answer": "تُدار الاشتراكات والتجديد والإلغاء واسترداد المبالغ المؤهلة حالياً عبر متجر سلة أو زد الذي اشتريت منه الباقة." }
        }
      },
      "support": {
        "title": "الدعم",
        "subtitle": "احصل على المساعدة في حسابك أو خدماتك المرتبطة أو طلبات الخصوصية.",
        "email": { "title": "الدعم عبر البريد", "body": "لأسئلة الحسابات والتكاملات والاشتراكات والمشكلات التقنية.", "address": "support@tlaaq.com" },
        "whatsapp": { "title": "واتساب", "body": "تواصل مع فريق دعم تلاق عبر واتساب.", "action": "فتح واتساب", "unavailable": "دعم واتساب غير متاح مؤقتاً." },
        "privacy": { "title": "طلب حقوق الخصوصية", "body": "اطلب الوصول أو التصحيح أو نسخة أو إغلاق الحساب أو الإتلاف عند انطباقه وفق نظام حماية البيانات الشخصية.", "action": "قراءة سياسة الخصوصية" }
      }
    }
  }
}
